

//INTERVENTION STRINGS
// note: some of this is legacy stuff.
//    you'll notice that it's using our library function for string replacement rather than supplying a function.
//    Kept it this way for backward compatability
//    you'll also notice that we have nested arrays here rather than giving an individual key to each string. this works because these particular strings are selected at random from their buckets
// TODO: consider making a sub object for these strings
const EN_US_INTERVENTION_STRINGS = {
  pageGambitGoodPhrases: [
    "Excellent work.",
    "Lets keep reading.",
    "Here's the next page.",
    "You are reading well.",
    "Good reading.",
    "You are flying. Here's a new page.",
    "Outstanding.",
    "Turning the page.",
    "Here is a new page.",
    "Let's go on."
  ],
  pageGambitGoodPhrases_MID_GRADE_BAND: [
    "Excellent work.",
    "Lets keep reading.",
    "Here's the next page.",
    "You are reading well.",
    "You're doing great.",
    "You've got this. Here's a new page.",
    "Outstanding.",
    "Turning the page.",
    "Here is a new page.",
    "Let's go on."
  ],
  pageGambitGoodPhrases_HIGH_GRADE_BAND: [
    "Excellent work.",
    "Lets keep reading.",
    "Here's the next page.",
    "You are reading well.",
    "You're doing great.",
    "You've got this. Here's a new page.",
    "Outstanding.",
    "Turning the page.",
    "Here is a new page.",
    "Let's go on."
  ],
  pageGambitStrugglingPhrases: [
    "Terrific, you finished the page.",
    "Before the next page, just wanted to say great job.",
    "You are really working at this.",
    "You are reading well. Here's the next page.",
    "Keep trying.",
    "You are doing well. Here's a new page.",
    "Next page -- you are almost done.",
    "Good work. Next page."
  ],
  pageGambitStrugglingPhrases_MID_GRADE_BAND: [
    "Nice work on that part.",
    "You're doing well.",
    "Great work. Keep going.",
    "You are reading well. Here's the next page.",
    "Keep trying.",
    "You are doing well. Here's a new page.",
    "Next page -- you are almost done.",
    "Good work. Next page."
  ],
  pageGambitStrugglingPhrases_HIGH_GRADE_BAND: [
    "Nice work on that part.",
    "You're doing well.",
    "Great work. Keep going.",
    "You are reading well. Here's the next page.",
    "Keep trying.",
    "You are doing well. Here's a new page.",
    "Next page -- you are almost done.",
    "Good work. Next page."
  ],
  lastPhraseOnPageResponse: [
    "Nice!",
    "Super!",
    "Way to go!"
  ],
  lastPhraseOnPageResponse_HIGH_GRADE_BAND: [
    "Nice",
    "Great job.", // Edit v2
    "You're doing well.",
  ],
  readWithMePrompt: [
    "Your turn!",
    "Now you try!",
    "Ready? Read!",
    "Now try reading.",
  ],
  readWithMePrompt_MID_GRADE_BAND: [
    'Your turn',
    'Alright, your turn to read.',
    'Start when you\'re ready.',
    'Now try reading.',
  ],
  readWithMePrompt_HIGH_GRADE_BAND: [
    "Your turn",
    "Alright, your turn to read.",
    "Start when you're ready.",
    "Now try reading.",
  ],
  try_again: [
    "let's try that again.",
    "read that to me again.",
    "try that one more time.",
    "how about you read that again?",
    "can you re-read that?",
    "ready to try again? Go!"
  ],
  try_again_MID_GRADE_BAND: [
    "let's try that again.",
    "Can you read that again?",
    "try that one more time.",
    "Read that out loud again.",
    "can you re-read that?",
    "Try reading that again.",
  ],
  try_again_HIGH_GRADE_BAND: [
    "let's try that again.",
    "Can you read that again?",
    "try that one more time.",
    "Read that out loud again.",
    "can you re-read that?",
    "Try reading that again.",
  ],
  keep_reading: {
    proficient: [
      "Keep going!",
      "Please go on.",
      "Keep reading.",
      "Lets go on.",
      "Read on.",
    ],
    capable: [
      "Let's keep reading!",
      "Keep going!",
      "Please go on.",
      "You're doing great.",
      "Keep reading."
    ],
    beginner: [
      "Let's keep reading!",
      "You're doing great.",
      "Let's read some more.",
      "Go on reading.",
    ],
  },
  keep_reading_MID_GRADE_BAND: {
    proficient: [
      "Keep going!",
      "Please go on.",
      "Keep reading.",
      "Lets go on.",
      "Read on.",
    ],
    capable: [
      "Let's keep reading!",
      "Keep going!",
      "Please go on.",
      "You're doing great.",
      "Keep reading."
    ],
    beginner: [
      "Let's keep reading",
      "Great work. Keep going.",
      "Let's read some more.",
      "Go on reading.",
    ],
  },
  keep_reading_HIGH_GRADE_BAND: {
    proficient: [
      "Keep going",
      "Please go on.",
      "Keep reading.",
      "Lets go on.",
      "Read on.",
    ],
    capable: [
      "Let's keep reading",
      "Keep going",
      "Please go on.",
      "You're doing great.",
      "Keep reading.",
    ],
    beginner: [
      "Let's keep reading",
      "Great work. Keep going.",
      "Let's read some more.",
      "Go on reading.",
    ],
  },
  read_perfectly: [
    "Great job - you red that well.",
    "Fantastic job.",
    "Cool, that was good reading.",
    "Excellent reading.",
    "No Errors.",
    "You red that without any mistakes.",
    "Way to go, Zero errors.",
  ],
  read_perfectly_MID_GRADE_BAND: [
    "Great job reading.",
    "You red that well.",
    "Nice reading.",
    "Excellent reading.",
    "That was a smooth read -- no errors.",
    "You red that clearly with no mistakes.",
    "Well done, no errors.",
  ],
  read_perfectly_HIGH_GRADE_BAND: [
    "Great job reading.",
    "You red that well.",
    "Nice reading.",
    "Excellent reading.",
    "That was a smooth read -- no errors.",
    "You red that clearly with no mistakes.",
    "Well done, no errors.",
  ],
  storyPhrases: {
    proficient: [
      "Cool, you're done with this story.",
      "I have some feedback for you.",
      "Way to go. You've finished this story.",
      "Cool, you've finished this story.",
      "I have some feedback for you.",
       "Great job, you completed this story.",
      "Let's see how you did on this story.",
      "You've finished."
    ],
    capable: [
      "Way to go. You've finished this story.",
      "Cool, you've finished this story.",
      "I have some feedback for you.",
      "Finished. You did a great job.",
       "Nice work, you red the entire story.",
       "Great job, you completed the story.",
      "Lets see how you did on this story.",
      "You've finished."
    ],
    beginner: [
      "You got to the end. Wonderful job.",
      "The end. Way to go.",
      "Thanks for reading with me.",
      "lets see how you did with this story.",
      "That was fun and you red really well.", //Do not change this. Polly will mispronounce "read".
      "Finished. You did a great job.",
      "You did a great job.",
      "That was fun and you red really well.", //Do not change this. Polly will mispronounce "read".
    ],
  },
  storyPhrases_MID_GRADE_BAND: {
    proficient: [
      "Cool, you're done with this passage.", // Edit v2
      "I have some feedback for you.",
      "Way to go. You've finished this passage.", // Edit v2
      "Cool, you've finished this passage.", // Edit v2
      "I have some feedback for you.",
      "Awesome. You completed this passage.", // Edit v2
      "Let's see how you did on this passage.", // Edit v2
      "You've finished."
    ],
    capable: [
      "Way to go. You've finished this passage.", // Edit v2
      "Cool, you've finished this passage.", // Edit v2
      "I have some feedback for you.",
      "Finished. You did a great job.",
      "Great, you red the entire passage.", // Edit v2
      "Great work - you completed this passage.", // Edit v2
      "Let's see how you did on this passage.", // Edit v2
      "You've finished."
    ],
    beginner: [
      "You reached the end. Well done.",
      "The end. Way to go.",
      "Good reading session.",
      "Let's see how you did with this passage.", // Edit v2
      "You red really well.",
      "Finished. You did a great job.",
      "You did a great job.",
      "You red that clearly.",
    ],
  },
  storyPhrases_HIGH_GRADE_BAND: {
    proficient: [
      "Cool, you're done with this passage.", // Edit v2
      "I have some feedback for you.",
      "Way to go. You've finished this passage.", // Edit v2
      "Cool, you've finished this passage.", // Edit v2
      "I have some feedback for you.",
      "Awesome. You completed this passage.", // Edit v2
      "Let's see how you did on this passage.", // Edit v2
      "You've finished.",
    ],
    capable: [
      "Great, you've finished this passage.", // Edit v2
      "Cool, you've finished this passage.", // Edit v2
      "I have some feedback for you.",
      "Finished. You did a great job.",
      "Great work, you red the entire passage.", // Edit v2
      "You completed this passage.", // Edit v2
      "Let's see how you did on this passage.", // Edit v2
      "You've finished.",
    ],
    beginner: [
      "You reached the end. Well done.",
      "Good reading session.",
      "Let's see how you did with this passage.", // Edit v2
      "You red really well.",
      "Finished. You did a great job.",
      "You did a great job.",
      "You red that clearly.",
    ],
  },
  toofastPhrases: {
    proficient: [
      "Can you slow down a bit so i can hear you better?",
      "Read at a comfortable speed, and i will follow you better.",
      "Help me out by reading clearly and not quite so quickly."
    ],
    capable: [
      "Can you slow down a bit so i can hear you better?",
      "Try saying each word clearly so I can understand you better.",
      "Help me out by reading a little more slowly.",
    ],
    beginner: [
      "I'm having a little trouble hearing you.  Say each word clearly.",
      "Help me follow you better by reading each word as clearly as you can.",
      "Speak a little louder so I can hear you.",
      "Can you reed a little louder?",
    ],
  },
  comprehensionIntro: {
    proficient: [
      "Let's talk about the story.",
      "Can you tell me about the story?",
      "Great job. Here is a question for you about the story.",
      "Let's pause and think about what we've read.",
      "Let's think about what we've read."
    ],
    capable: [
      "Can you tell me about the story?",
      "Great job. Here is a question for you.",
      "Can you answer this question?",
      "Let's pause and think about what we've read.",
      "Let's think about what we've read."
    ],
    beginner: [
      "Here is a question for you about this story.",
      "Tell me about the story.",
      "Can you help me understand the story better?",
      "Let's pause and think about what we've read.",
    ],
  },
  comprehensionIntro_MID_GRADE_BAND: {
    proficient: [
      "Let's talk about the passage.", // Edit v2
      "Can you tell me about the passage?", // Edit v2
      "Great job. Here is a question about the passage.", // Edit v2
      "Let's pause and think about what we've read.",
      "Let's think about what we've read."
    ],
    capable: [
      "Can you tell me about the passage?", // Edit v2
      "Great job. Here is a question for you.",
      "Can you answer this question?",
      "Let's pause and think about what we've read.",
      "Let's think about what we've read."
    ],
    beginner: [
      "Here is a question for you about the passage.", // Edit v2
      "Tell me about the passage.", // Edit v2
      "Can you help me understand the passage better?", // Edit v2
      "Let's pause and think about what we've read.",
    ],
  },
  comprehensionIntro_HIGH_GRADE_BAND: {
    proficient: [
      "Let's talk about the passage.", // Edit v2
      "Can you tell me about the passage?", // Edit v2
      "Great job. Here is a question about the passage.", // Edit v2
      "Let's pause and think about what we've read.",
      "Let's think about what we've read.",
    ],
    capable: [
      "Can you tell me about the passage?", // Edit v2
      "Great job. Here is a question for you.",
      "Can you answer this question?",
      "Let's pause and think about what we've read.",
      "Let's think about what we've read.",
    ],
    beginner: [
      "Here is a question for you about the passage.", // Edit v2
      "Tell me about the passage.", // Edit v2
      "Help me understand the passage better.", // Edit v2
      "Let's pause and think about what we've read.",
    ],
  },
  comprehensionRightAnswer: {
    proficient: [
      "Great reading, that's right.",
      "You've got it!",
      "I'm so proud of you. You're doing great!"
    ],
    capable: [
      "Thanks. You are correct.",
      "Great reading, that's right.",
      "I'm so proud of you. You're doing great!"
    ],
    beginner: [
      "Great reading, that's right.",
      "Thanks. You are correct.",
      "I'm so proud of you. You're doing great!"
    ],
  },
  comprehensionRightAnswer_MID_GRADE_BAND: { // Edit v1
    proficient: [
      "Great reading, that's right.",
      "You've got it!",
      "You're making great progress.",
    ],
    capable: [
      "Thanks. You are correct.",
      "Great reading, that's right.",
      "You're making great progress.",
    ],
    beginner: [
      "Great reading, that's right.",
      "Thanks. You are correct.",
      "You're making great progress.",
    ],
  },
  comprehensionRightAnswer_HIGH_GRADE_BAND: {
    proficient: [
      "Great reading, that's right.",
      "You've got it!",
      "You're making great progress.",
    ],
    capable: [
      "Thanks. You are correct.",
      "Great reading, that's right.",
      "You're making great progress.",
    ],
    beginner: [
      "Great reading, that's right.",
      "Thanks. You are correct.",
      "You're making great progress.",
    ],
  },
  comprehensionWrongAnswerOnFirst: [
    "Try again.",
    "Oops, let's check that answer.",
    "That question is tricky, can you check it again?",
    "I see this question stumped you, can you check it?"
  ],
  comprehensionWrongAnswerOnFirst_MID_GRADE_BAND: [
    "Let's take another look at this.",
    "Let's check that answer.",
    "That question is tricky, can you check it again?",
    "Let's rethink this one.",
  ],
  comprehensionWrongAnswerOnFirst_HIGH_GRADE_BAND: [
    "Let's take another look at this.",
    "Let's check that answer.",
    "That question is tricky, can you check it again?",
    "Let's rethink this one.",
  ],
  comprehensionWrongAnswerOnSecond: [
    "Try again.",
    "Oops, let's check that answer.",
    "That question is tricky, can you check it again?",
    "I see this question stumped you, can you check it?"
  ],
  comprehensionWrongAnswerOnSecond_MID_GRADE_BAND: [
    "Let's take another look at this.",
    "Let's check that answer.",
    "That question is tricky, can you check it again?",
    "Let's rethink this one.",
  ],
  comprehensionWrongAnswerOnSecond_HIGH_GRADE_BAND: [
    "Let's take another look at this.",
    "Let's check that answer.",
    "That question is tricky, can you check it again?",
    "Let's rethink this one.",
  ],
  comprehensionWrongAnswerRetry: [
    "Oops, that's still not correct.",
    "Try again. That's not right.",
    "Let's check that answer again.",
    "Hmm, let's check that answer.",
  ],
  comprehensionWrongAnswerRetry_MID_GRADE_BAND: [
    "Let's think through this again.",
    "Try again. That's not right.",
    "Let's check that answer again.",
    "Let's check that answer.",
  ],
  comprehensionWrongAnswerRetry_HIGH_GRADE_BAND: [
    "Let's think through this again.",
    "Try again. That's not right.",
    "Let's check that answer again.",
    "Let's check that answer.",
  ],
  comprehensionWrongAnswer: [
    "Oops, that's not correct. Try again.",
    "Try again. That's not right.",
    "Hmm, let's check that answer.",
  ],
  comprehensionWrongAnswer_MID_GRADE_BAND: [
    "Let's think through this again.",
    "Try again. That's not right.",
    "Let's check that answer.",
  ],
  comprehensionWrongAnswer_HIGH_GRADE_BAND: [
    "Let's think through this again.",
    "Try again. That's not right.",
    "Let's check that answer.",
  ],
  comprehensionRight: {
    proficient: [
       "That is correct.",
      "You got it!",
       "You figured it out,",
      "Yes, that's right.",
    ],
    capable: [
      "You got this one right.",
      "Cool. You are correct.",
      "That's right.",
       "You figured it out.",
    ],
    beginner: [
       "That is correct.",
      "You got it!",
      "Yes, that's right.",
    ],
  },
  comprehensionRight_MID_GRADE_BAND: {
    proficient: [
      "That is correct.",
      "You got it!",
      "You figured it out.",
      "Yes, that's right.",
    ],
    capable: [
      "You got this one right.",
      "Cool. You are correct.",
      "That's right.",
      "You figured it out.",
    ],
    beginner: [
      "That is correct.",
      "You got it!",
      "Yes, that's right.",
    ],
  },
  comprehensionRight_HIGH_GRADE_BAND: {
    proficient: [
      "That is correct.",
      "You got it",
      "You figured it out.",
      "Yes, that's right.",
    ],
    capable: [
      "You got this one right.",
      "Cool. You are correct.",
      "That's right.",
      "You figured it out.",
    ],
    beginner: [
      "That is correct.",
      "You got it!",
      "Yes, that's right.",
    ],
  },
  comprehensionPrompt: [
    "This question might be tricky. Make your best guess by clicking on one of the answers.",
    "Which answer makes the most sense? Click on one of the answers."
  ],
  interventionOneErrorLeadInDontSayWord: {
    proficient: [
      "Let's review one word together.",
      "We should pause on a word",
      "Hold on. Lets work on a word.",
      "Before we go on, lets work on one of the words.",
      "Looks like we should work on one of these words.",
      "We should spend a minute to review.",
    ],
    capable: [
      "Let's review a word together.",
      "Looks like we should work on one of these words.",
      "We should work together for a minute.",
      "Hold on.  Lets work on a word.",
      "Here's some help.",
      "We should work on one of the words.",
    ],
    beginner: [
      "How about help with one of these words?",
      "Looks like we should focus on a word.",
      "Here's some help.",
      "Why don't we work on one of the words?",
      "Lets work on a word together.",
      "I'd like to tell you more about a word.",
    ],
  },
  interventionOneErrorLeadInSayWord: {
    proficient: [
      "Lets go over: \"${p0}\".",
      "Let's review: \"${p0}\" together.",
      "Hold on. Lets review: \"${p0}\".",
      "We should work on: \"${p0}\".",
      "Let's pause on: \"${p0}\".",
      "We should work on: \"${p0}\".",
      "We can go over: \"${p0}\".",
      "Lets work on: \"${p0}\".",
      "Lets talk about the word: \"${p0}\"",
      "Hold on, lets work on: \"${p0}\".",
      "Before we go on,lets go over: \"${p0}\".",
      "Looks like we should work on: \"${p0}\".",
      "How about we work on: \"${p0}\".",
      "We should spend a minute on: \"${p0}\"."
    ],
    capable: [
      "Let's review: \"${p0}\" together.",
      "Hold on. Lets review: \"${p0}\".",
      "We should focus on: \"${p0}\".",
      "We should spend a second on: \"${p0}\".",
      "Lets work on: \"${p0}\".",
      "Lets talk about the word: \"${p0}\"",
      "let's hold on.",
      "Before we go on, let’s work on: \"${p0}\".",
      "Looks like we should work on: \"${p0}\".",
      "We should work on: \"${p0}\".",
      "Lets go over: \"${p0}\".",
      "We're going to work on: \"${p0}\".",
      "Hold on, lets talk about: \"${p0}\".",
      "How about we work on: \"${p0}\".",
      "We should spend a minute on: \"${p0}\"."
    ],
    beginner: [
      "Hold on. lets work on: \"${p0}\".",
      "Here's some help on the word: \"${p0}\".",
      "We should work on the word: \"${p0}\".",
      "Lets go over: \"${p0}\".",
      "We should talk about the word: \"${p0}\".",
      "Before we go on, let’s work on: \"${p0}\".",
      "We should work on: \"${p0}\".",
      "Lets go to work on: \"${p0}\".",
      "We're going to work on: \"${p0}\".",
      "Hold on, lets talk about: \"${p0}\".",
      "We should spend a minute on: \"${p0}\"."
    ],
  },
  interventionMultipleErrorLeadIn: {
    proficient: [
      "Review can sharpen understanding.",
      "How about a quick review.",
      "We should review the sentence.",
      "Let's work on this sentence.",
      "We should go over that sentence again.",
      "Here's a quick recap.",
      "Why don't we work together for a minute?"
    ],
    capable: [
      "Let's try that sentence again.",
      "Let's work on that sentence.",
      "Let's do a quick review.",
      "I didn't catch some words.",
      "Looks like we should review.",
    ],
    beginner: [
      "We should go over that sentence again.",
      "Hmmm, we should review.",
      "Hold on. Let's work on this sentence.",
      "We should spend time going over that again.",
      "Wait, lets spend a second on these words.",
      "Lets work on this.",
      "How about we work on this?",
      "We should read that sentence again.",
      "Let's work together on this."
    ],
  },
  endOfClapPhrases: {
    beginner: [
      "Good work, keep reading.",
      "Nice work. Go on.",
      "You're doing well. Keep going.",
      "Now you know another word. Keep reading.",
    ],
    capable: [
      "Great job, keep reading.",
      "Terrific. Go on.",
      "Nice work. Go on.",
      "You're doing well. Keep reading.",
    ],
    proficient: [
      "Keep reading.",
      "Excellent. Go on.",
      "Terrific work. Go on.",
      "You're doing well. Keep reading.",
    ],
  },
  feedbackUtterances: [
    "If I'm saying this, there's a bug", // This is correct
    "Great job, let's do it again",
    "You're doing well. Keep going.",
    "Great, now you know another word. Let's keep going."
  ],
  listening: {
    greatJob: [
      "Great job.",
      "Good work.",
      "Keep it up.",
      "Great, let's keep going.",
      "Nice work.",
      "Got it. Let's go on.",
    ],
    didntHear: [
      "Can you try again?",
      "I didn't hear you.",
      "Try again, please.",
      "Say it a little louder.",
      "Ok, I didn't get that. Try again.",
      "Can you say again, a little louder?",
      "Say it out loud again.",
      "What's the word?",
    ],
    moveOn: [
      "Ok, lets go on.",
      "Lets move on.",
      "Alright, keep reading.",
      "We'll keep going.",
      "Keep reading.",
      "Keep on going.",
      "We'll move on.",
      "Lets get back to reading.",
      "Ok, back to the story.", // Edit v2
    ],
    giveAnswer: [ //Listen.js appends the target word before sending the text to speech
      "The word is:",
      "Ok, its:",
      "This is:",
      "This word is:",
      "You say:",
    ],
    thanks: [
      "Ok, thanks.",
      "Thanks, keep going.",
      "thanks very much.",
      "Good effort.",
      "thank you, keep reading.",
    ]
  },
  rhymes_with: "This word rhymes with:",
  this_word: "This word",
  rhymes: "rhymes",
  with: "with",
  listen_to_rhyme: "Listen to the rhyming word",
  listen_for_the: "Listen for the",
  spelling: "spelling",
  of: "of",
  is_spelled: "is spelled",
  let_me_spell: "Let me spell that for you",
  you_said: "You might have said",
  instead_of: "instead of",
  the_word_is: "<break time = \"0.5s\"/> The word is",
  important_word: " is an important word. Say ",
  three_times: " three times as fast as you can ",
  let_me_say: "Let me say that for you",
  let_me_say_MID_GRADE_BAND: "I'll read that out loud.", // Edit v1
  let_me_say_HIGH_GRADE_BAND: "I'll read that out loud.", // Edit v1
  means: "means",
  lets_read_the_word: "Let's read the word",
  fun_fact: "Fun Fact!",
  heres_a_fact: "Here's a fun fact for you about the word",
  watch_lips: "Watch my friend's lips say",
  tap_play: "when you are ready, tap the play button.",
  watch_how_to_say: "Watch how to say",
  now_you_say_word: "Now, \"you\" say the word.",
  lets_read_word: "Let's read the word",
  let_me: "Let me",
  makes: "makes",
  say: "say",
  times: "times",
  now_you_try_word: "Now, \"you\" try reading this word.",
  im_going_to: "I'm going to",
  the_word_is_capitalized: "The word is",
  sound_out_capitalized: "Sound out",
  spellOutLeadIn: "Try to sound out this word.",
  spellOutLeadInBeforeVersion: "I'm going to spell out the word:",
  imGoingToSoundThisWordOut: "I'm going to sound out this word:",
  repeat_after_me: "Repeat after me",
  show_again: "I'll show you again",
  be_careful_not_to: "Be careful not to",
  make_this_mistake: " make this mistake.",
  your_turn: "Your turn",
  wait: "Wait",
  mistake_added: (word) => ` add ${(/^[aeiou]$/i).test(word[0]) ? 'an' : ''} "${word}" at the end.`,
  letsWorkOn: "Let's work on:",
  mistake_dropped: (word) => ` drop the "${word}" ending.`,
  mistake_mix_up_ending: (word) => ` mix up the "${word}" ending.`,
  is_pronounced: "is pronounced",
  word_has_many_letters_and_many_syllables: (wordLength, n) => `The word has ${wordLength} letters and ${n} ${n > 1 ? 'syllables' : 'syllable'}.`,
  word_has_many_letters_and_many_sounds: (wordLength, n) => `The word has ${wordLength} letters and ${n} ${n > 1 ? 'sounds' : 'sound'}.`,
  try_to_sound_it_out: "Try to sound it out.",
  ok: "Okay,",
  ok_im_going_to_sound_out_this_word_for_you: "Okay, I'm going to sound out this word.",
  pay_attention_to_the_word_ending: "Pay attention to the word ending",
  letters: "Letters",
  sounds: "Sounds",


  /* intervention library strings */
  heres_a_riddle: "I’ve got a riddle for you.",
  riddle_solved: "Yes! You solved the riddle.",
  riddle_unsolved: (answer) => `I was hoping you'd say ${answer}.`,
  fun_fact: "Fun Fact!",
  heres_a_fact: "Here's a fun fact for you about the word:",
  morpheme: {
    prefix: "beginning",
    suffix: "ending",
    root: "root",
    means: "means",
    intro: ({ morphemePosition }) =>
      `This word has a common ${morphemePosition}. If you know this ${morphemePosition}, you can figure out lots of words. <break time=\"1s\"/>`,
    examples: ({ morphemePosition }) =>
      `Here are some examples of words that use the ${morphemePosition}`,
    ask_word: ({ morphemePosition }) =>
      `Which of these words uses the same ${morphemePosition}?`,
    correct: 'is right. Whenever you see these letters together, they will tell you the word is about',
    struggle: ({ morphemePosition }) =>
      `is another word that uses the common ${morphemePosition}`,
  },
  elkonin_box: {
    intro_1: ({ nSounds }) =>
      `There are ${nSounds} sounds in this word. You can see ${nSounds} boxes on the screen. Move the first red ball into the first box, and say the first sound. Then move the other balls in the boxes, and say each sound.`,
    intro_2:
      "Watch as I move these balls into boxes. Each sound has its own box.",
    tutor_intro_part_1: "Here is a new sound game. I have a word with 3 sounds. The word is:",
    tutor_intro_part_1_MID_GRADE_BAND: "Here is a new sound activity. I have a word with 3 sounds. The word is:", // Edit v1
    tutor_intro_part_1_HIGH_GRADE_BAND: "Here is a new sound activity. I have a word with 3 sounds. The word is:", // Edit v1
    tutor_intro_part_2: "I'm going to say the 3 sounds, and move one red ball into one box for each sound. Watch me do this first. The word is:",
    ignore_extras:
      "There may be more boxes than sounds in the word. Just ignore the extras",
    ask_word: `Now put those sounds together and say the word.`,
    ask_sounds_1: ({ word }) => `Use your ${getInterface()} to move the balls into the boxes and say each sound in the word: "${word}".`,
    ask_sounds_2: ({ hasImage }) => `Use your ${getInterface()} to move the balls into the boxes, and say the sounds of the word${hasImage ? ' shown in the picture' : ''}.`,
    your_turn: `Now it's your turn.`,
    your_turn_tutor: "Now you try it. The word is:",
    ask_blend: `Now, blend the sounds into the word.`,
    correct: `Great job on: `,
    blend: `Now, I'll blend those sounds into:`,
    describe_1:  `The word,`,
    describe_2: ({ nSounds }) => `, has ${nSounds} sounds.`,
    feedback_1:
      `Use your ${getInterface()} to move a ball and say each of the sounds in:`,
    feedback_2_part_1: `The sounds in the word`,
    feedback_2_part_2: `are`,
    struggle_part_1: `The word is:`,
    struggle_part_2: `Let's keep going.`,
    too_many_sounds: "Too many sounds.",
    the_sounds_are: "The sounds in the word are:",
    what_word: "What word does that make?",
    drag_the_circles: "Drag the circles into the boxes.",
    lets_work_on: ({ word }) => `Let's work on: "${word}".`,
  },
  cognate_intro_1: (word) =>
    word,
  cognate_intro_2: " is ",
  cognate_intro_3: (cognate) =>
    `<lang xml:lang="es-ES">"${cognate}"</lang>`,
  cognate_intro_4: `...in Spanish...`,
  cognate_now_you_say_it: "Now, \"you\" say the word in English.",
  name: {
    ask_sounds: `Let's sound out this name. Say the first sound and then keep going with each sound.`,
    intro_1_part_1: `This is a`,
    intro_1_part_2: `name that means:`,
    intro_2: `is a famous:`,
    ask_word_1: `Great, now run your ${getInterface()} over the parts from the beginning to end and say the name.`,
    ask_word_2: "Now, you pronounce this name.",
    correct_1: `Yes, this name is pronounced:`,
    correct_2: "Good work.", // Edit v1
    struggle_part_1: `This name is pronounced:`,
    struggle_part_2: `Let's keep reading.`,
    fun_fact: `Here's a fun fact:`,
    lip_sync: "Watch my friend break this name into parts.",
  },
  vocabulary_with_picture: {
    title: "Vocabulary With Pictures",
    intro: (descriptor) => `is a ${descriptor} word.`,
    question_text: 'Which picture best shows the word:',
    correct_response: "That is correct.", // Edit v1
    means: 'means',
    descriptor: ["pretty hard"],
  },
  sound_seeker: {
    intro: `We're going to find a sound in:`,
    describe_1: ({ isStart }) => `${isStart ? "starts" : "ends"} with`,
    yes: 'Yes',
    describe_2: ({ isStart }) => `also ${isStart ? "starts" : "ends"} with`,
    ask_word: ({ isStart }) =>
      `${
        isTouchDevice() ? "tap" : "click"
      } on the picture that ${isStart ? "starts" : "ends"} with`,
    correct: `Thanks for sound seeking. Let's do some reading.`,
    no: 'no',
    incorrect: ({ isStart }) => `doesn't ${isStart ? "start" : "end"} with`,
    its_this_one: "It's this one.",
    like_word: 'just like:',
  },
  prediction_question: {
    intro:
      'Try guessing what happens next.<break time="0.5s"/> Think about the story we’ve read so far.', // Edit v1
    correct_response: "Good prediction, I'm so proud of you.",
    correct_response_HIGH_GRADE_BAND: "Good prediction,", // Edit v1
    expire_right_answer: (answer) => `The right answer is: "${answer}".`,
    struggle: `Ok, trying to figure out what's coming is an important part of reading. Let's see what happens. Keep reading.`,
  },
  sound_out: {
    intro: `I'm going to sound out this word for you.`,
    ask_sounds: `Ok, now it's your turn. Say each sound.`,
    ask_word: "What word does that make?",
  },
  sound_out_MID_GRADE_BAND: {
    intro: "I'm going to sound out this word.", // Edit v1
    ask_sounds: `Ok, now it's your turn. Say each sound.`,
    ask_word: "What word does that make?",
  },
  sound_out_HIGH_GRADE_BAND: {
    intro: "I'm going to sound out this word.", // Edit v1
    ask_sounds: `Ok, now it's your turn. Say each sound.`,
    ask_word: "What word does that make?",
  },
  letter_flies: {
    intro: `When you hear me say a sound, catch the butterfly that matches the sound. You do this by ${
      isTouchDevice() ? "tapping" : "clicking"
    } the butterfly with the letter that matches the sound.<break time="1s"/> Watch me do this first.`,
    your_turn: `Now it's your turn.`,
    catch_butterfly: `The sound to catch is:`,
    click_on: isTouchDevice() ? "tap on" : "click on",
    ask_sound_part_1: `Ok, now say the sound`,
    ask_sound_part_2: `makes`,
    struggle: "Oh no. The letterfly is escaping.",
    struggle_MID_GRADE_BAND: "The letterfly is escaping.", // Edit v1
    struggle_HIGH_GRADE_BAND: "The letterfly is escaping.", // Edit v1
    correct_1: "You caught that letterfly.",
    correct_2: `That's the way to collect letter flies.`,
    tutor: {
      intro: "When you hear me say a sound, catch the letterfly that matches the sound. You do this by clicking the butterfly with the letter that matches the sound.<break time=\"1s\"/> Watch me do this first.",
      on_no_click_action_1: `click on the letter that makes the:`,
      on_no_click_action_2: `sound.`,
      struggle: `Oh no. The letterfly is escaping, don't worry, we will catch more later.`,
      struggle_MID_GRADE_BAND: `The letterfly is escaping, don't worry, we will catch more later.`, // Edit v1
      struggle_HIGH_GRADE_BAND: `The letterfly is escaping, don't worry, we will catch more later.`, // Edit v1
      your_turn_instruction_1: `Now it's your turn.`,
      your_turn_instruction_2: `has the`, // [word] has the [sound]
      your_turn_instruction_3: `...sound. Which letter makes the`,
      your_turn_instruction_4: `sound.`, // [sound] sound.
      silent_letter: ({targetGrapheme}) => `<speak><prosody rate="slow">${targetGrapheme}</prosody></speak>`,
      silent_instruction_1: `Can you say the sound`,
      silent_instruction_2: `makes?`, // [sound] makes?
      silent_instruction_3: `makes the`,
      silent_instruction_4: `<speak><break time="1s"/>sound.</speak>`, // [sound]?
    },
  },
  GSF: {
    ftue_intro:
      `Let’s play a sorting game! I’m going to show you three words and ask you to choose a word to fill in the blank. Each row and column matches by their starting sound or what they mean. Watch me do this first.`,
    ftue_intro_MID_GRADE_BAND: `Let’s play a sorting game. I’m going to show you three words and ask you to choose a word to fill in the blank. Each row and column matches by their starting sound or what they mean. Watch me do this first.`, // Edit v1
    ftue_intro_HIGH_GRADE_BAND: `Let’s do a sorting exercise. I’m going to show you three words and ask you to choose a word to fill in the blank. Each row and column matches by their starting sound or what they mean. Watch me do this first.`, // Edit v1
    ftue_column_1: `The words in this column match by their starting sound. The "B" sound.`,
    ftue_column_2: `So, the words in the second column will also match by their starting sound. The "C" sound.`,
    ftue_row_1: `The words in this row match by what they mean: "Food words".`,
    ftue_row_2: `So, the words in the second row will also match by what they mean: Something related to "Box".`,
    ftue_find_word_1:
      `We need to find a word that starts with the "C" sound like "Carrot" and is related to "Box".`,
    ftue_find_word_2:
      `I'm going to drag the word "Crate" into the empty square because it starts with the "C" sound like "Carrot" and is a container like "Box".`,
    ftue_find_word_2_iPad:
      `I'm going to tap the word "Crate" because it starts with the "C" sound like "Carrot" and is a container like "Box".`,
    ftue_your_turn: "Now it's your turn: Find the missing word that matches one word's sound and the other word's meaning.",
    non_ftue_intro: "Let’s play the sorting game! Find the missing word that matches one word's sound and the other word's meaning.",
    non_ftue_intro_MID_GRADE_BAND: "Let’s play the sorting game. Find the missing word that matches one word's sound and the other word's meaning.", // Edit v1
    non_ftue_intro_HIGH_GRADE_BAND: "Let’s do the sorting exercise. Find the missing word that matches one word's sound and the other word's meaning.", // Edit v1
    one_more: "Let’s do one more.",
    choose_word: "Choose a word to fill in the blank.",
    correct: ({ correctWord, category, word1, letter, word2 }) =>
      `You got it! "${correctWord}" is in the category, "${category}", like "${word1}", and starts with the letter, "${letter}" like "${word2}".`,
    great_work: "Great work!",
    scaffolding_1:
      "Oops! That's not right. Try again, remember that we need to find the missing word that matches one word's sound and the other word's meaning.",
    scaffolding_1_MID_GRADE_BAND: "Not quite. Try again, remember that we need to find the missing word that matches one word's sound and the other word's meaning.", // Edit v1
    scaffolding_1_HIGH_GRADE_BAND: "Not quite. Try again, remember that we need to find the missing word that matches one word's sound and the other word's meaning.", // Edit v1
    scaffolding_2: ({ category, word1, letter, word2 }) =>
      `That's not right. Look for a word that matches the category, "${category}", like "${word1}", and starts with the letter, "${letter}" like "${word2}".`,
    timeout_1:
      "Choose a word and drag it into the empty square. Remember that we need to find the missing word that matches one word's sound and the other word's meaning.",
    timeout_2: ({ category, word1, letter, word2 }) =>
      `Look for a word that matches the category, "${category}", like "${word1}", and starts with the letter, "${letter}" like "${word2}".`,
    show_answer: ({ correctWord, category, word1, letter, word2 }) =>
      `The correct word is "${correctWord}". It matches the category, "${category}", like "${word1}", and starts with the letter, "${letter}" like "${word2}".`,
  },
  HFWDotGrid: {
    ftue_intro: "I'm going to say a word, and I want you to move one dot into one box for each sound in the word. Watch me do this first. The word is: \"cat\".",
    ftue_your_turn: ({ targetWord }) => `Now, you should try it. How many sounds are in the word: "${targetWord}". Drag the correct number of dots to represent the sounds in the word: "${targetWord}".`,
    ftue_your_turn_iPad: ({ targetWord }) => `Now, you should try it. How many sounds are in the word: "${targetWord}". Tap a dot to select it, then tap an empty box to move it there. Move one dot for each sound in the word: "${targetWord}".`,
    non_ftue_intro: ({ targetWord }) => `We should work on the word: "${targetWord}". How many sounds are in the word: "${targetWord}". Drag the correct number of dots to represent the sounds in the word: "${targetWord}".`,
    non_ftue_intro_iPad: ({ targetWord }) => `We should work on the word: "${targetWord}". How many sounds are in the word: "${targetWord}". Tap a dot to select it, then tap an empty box to move it there. Move one dot for each sound in the word: "${targetWord}".`,
    correct_response: `Nice! That's right.`,
    incorrect_response: `That's not quite right.`,
    timeout_response: ({ targetWord }) => `You can do it! Drag the correct number of dots to represent the sounds in the word: "${targetWord}".`,
    timeout_response_iPad: ({ targetWord }) => `You can do it! Tap a dot to select it, then tap an empty box to move it there. Move one dot for each sound in the word: "${targetWord}".`,
    timeout_response_MID_GRADE_BAND: ({ targetWord }) => `Drag the correct number of dots to represent the sounds in the word: "${targetWord}".`, // Edit v1
    timeout_response_iPad_MID_GRADE_BAND: ({ targetWord }) => `Tap a dot to select it, then tap an empty box to move it there. Move one dot for each sound in the word: "${targetWord}".`, // Edit v1
    timeout_response_HIGH_GRADE_BAND: ({ targetWord }) => `Drag the correct number of dots to represent the sounds in the word: "${targetWord}".`, // Edit v1
    timeout_response_iPad_HIGH_GRADE_BAND: ({ targetWord }) => `Tap a dot to select it, then tap an empty box to move it there. Move one dot for each sound in the word: "${targetWord}".`, // Edit v1
    tap_arrow: `Tap the arrow when you're done.`,
    has_sounds: ({ targetWord, numPhonemes }) => `"${targetWord}" has ${numPhonemes} sounds.`,
    let_me_show_you: "Let me show you.",
    great_job: "Great job!",
    neutral_response: "Okay, let's keep reading.",
    positive_feedback: "Nice work! Let's keep reading.",
  },
  say_a_sound: {
    intro: ({ nSounds }) =>
      `Watch my friend's mouth for each of the ${nSounds} sounds in this word.`,
    ask_sounds: `Now I'm going to show you the letters for each of these sounds and you say the sound.`,
    ask_word: "Now, read the whole word.",
  },
  word_display: {
    intro: "Watch and listen. We're going to learn more about this word.",
    ask_sound_part_1: `What is the first sound in:`,
    ask_sound_part_2: `.`,
    describe_part_1: `Okay:`,
    describe_part_2: `starts with`,
    continue: `Let's get back to reading.`,
  },
  up_and_down: {
    intro_1_intervention: `Watch your friend go up the stairs as I say the sounds in the word:`,
    intro_1_tutor: `I will give you a word, and you should sound out the word by saying the sounds of the word, one at a time. At the end, you should blend them all together to say the word. Watch me do this first for the word:`,
    intro_2: `Help your friend climb up the stairs by saying the sounds in the word:`,
    ask_sounds_intervention: `Now you try it. Say all the sounds in:`,
    ask_sounds_tutor_0: `Now it's your turn.`,
    ask_sounds_tutor_1: `The word is:`,
    ask_sounds_tutor_2: `Please say the sounds in the word:`,
    ask_sounds_tutor_3: `one at a time.`,
    ask_sounds_tutor_image_1: `The word is: `,
    ask_sounds_tutor_image_2: `Please say the sounds in the word `,
    ask_sounds_tutor_image_3: ` one at a time, followed by saying the whole word `,
    ask_sounds_tutor_image_4: `again.`,
    prompt_sounds: 'Can you say the sounds in:',
    prompt_sounds_assessment: 'You can do it! Say the sounds in:',
    ask_blend_intervention: "Blend the sounds in the word.",
    ask_blend_tutor: "What word does that make?",
    ask_blend_assessment: "You can do it, blend the sounds to say the word.",
    correct: `Great job.`,
    struggle_intro: `The word is:`,
    struggle_end: `Let's read some more.`,
    repeat_after_me: `Repeat after me`,
  },
  rhyming: {
    intro: `Let's learn about this word with rhymes.`,
    describe: `Our word rhymes with:`,
    ask_word_1: `So, read this word that rhymes with:`,
    ask_word_2: `Now you read:`,
    correct: "You mastered this rhyme.",
    struggle: `Let's use the rhyme.`,
    rhymes_with: "rhymes with",
  },
  rhyming_quiz: {
    intro: "Time for the rhyming game.",
    intro_HIGH_GRADE_BAND: "Time for a rhyming exercise.", // Edit v1
    our_word_is: 'Our word is:',
    which_rhymes_with: 'Which of these words rhymes with:',
    click_to_choose: () => `${
      isTouchDevice() ? "Touch" : "Click"
    } to choose.`,
    you_are_right: 'You are right.',
    no: "No, ",
    doesnt_rhyme_with: "doesn't rhyme with:",
    but: "But",
    does: "does",
    rhymes_with: 'rhymes with',
    back_to_reading: 'Back to reading.',
  },
  say_one_sound: {
    intro: "Watch and listen as I say this word",
    describe: ({ position }) =>
      `I'm going to say the ${position} sound in the word:`,
    ask_word: `Now it's your turn. Say the word:`,
    struggle: `We're going to work on:`,
    ask_sound: ({ position }) =>
      `Now say the ${position} sound in:`,
    sound_is: "Okay, the sound is",
    correct: "Way to go.",
    first: "first",
    last: "last",
  },
  word_investigator: {
    intro: ({ word }) =>
      `Look at this word. This word should have ${word.length} letters and ${word.length} sounds. But there is a letter and a sound missing. Let's investigate.`,
    describe_1: ({ word }) => `has ${word.length} sounds.`,
    describe_2: ({ word }) =>
      `but there are only ${word.length - 1} sounds here. The`,
    describe_3: `Find the letter that makes the missing sound in`,
    missing: "is missing.",
    ask_letter: `${
      isTouchDevice() ? "tap" : "click"
    } on the letter at the top that makes the missing sound.`,
    correct_1: "Right. You are a good investigator.",
    correct_2: "Great, thanks.",
    struggle: `That's not the right letter sound.`,
    try_again: `On inspection, let's keep trying.`,
    give_answer_part_1: `The missing letter is`,
    give_answer_part_2: `Now, you read the word.`,
    inactivity: `Give it a try. ${
      isTouchDevice() ? "tap" : "click"
    } on a letter at the top.`,
  },
  give_and_take: {
    time_to_get_goofy: "Let's play with this word:", // Edit v1
    time_to_get_goofy_HIGH_GRADE_BAND: "Let's do some wordplay:", // Edit v1
    watch_and_listen: ({ isStart }) => `Watch and listen as I say the ${isStart ? 'first' : 'last'} part of this word.`,
    describe: ({ nSounds }) => `This word-part has ${nSounds} sounds.`,
    ask_word_part: "Say the word-part with me.",
    correct_1: "You did it",
    correct_2: `Let's keep going.`,
    correct_3: "Way to go.",
    correct_3_MID_GRADE_BAND: "You got it.", // Edit v1
    correct_3_HIGH_GRADE_BAND: "You got it.", // Edit v1
    ok_new_word_is: 'Ok, our new word is:',
    thanks: 'Thanks',
    struggle_1: "The word-part is",
    struggle_2: "Now the word is in the boxes. Read the whole word to me.",
    this_word_is: 'This word is:',
    back_to_reading: 'Back to reading.',
    add_sound: ({ isStart }) =>
      `Now, I am going to add the ${isStart ? 'first' : 'last'} part to our word. The new sound is`,
    word_is: "Now the word is",
    makes_word: "That makes the word",
    ask_sounds: ({ nSounds }) => `Now, repeat the ${nSounds} sounds.`,
    ask_word: `Now read the whole word.`,
    replace_sound: `Ok, one last step. Let's replace a sound. We're going to change the sound`,
    to: "to",
    ask_sub: "Now sound out the new word.",
  },
  change_one_part: {
    intro: "Time for the letter swap game. Watch and listen as this word is sounded out.", // Edit v2
    intro_HIGH_GRADE_BAND: "Time for the letter swap exercise. Watch and listen as this word is sounded out.", // Edit v2
    change_one: `I'm going to change one letter in this word. Changing the letter will change the sound and make a new word.`,
    ask_word: "Can you read this word?",
    ask_word_MID_GRADE_BAND: "Please read this word.", // Edit v1
    ask_word_HIGH_GRADE_BAND: "Please read this word.", // Edit v1
    another_swap: `Let's do another swap.`,
    correct: "Good work.",
    sound_out: `Ok, let's sound out this word together.`,
    good_job: `Nice job swapping letters`, // Edit v1
    assessment_handle_intro: `We are now going to play a game with words. Wait to start until I let you know it’s time.`,
    assessment_handle_intro_say_word: 'This word is:',
    assessment_handle_intro_make_change: `I’m going to change one letter in this word. Changing the letter will change the sound and make a new word.`,
    assessment_handle_intro_prompt_to_try_transition: `When you see the boxes turn yellow, you should then say the new word.`,
    assessment_handle_intro_prompt_to_try_read: 'Give it a try. Say:',
    assessment_handle_intro_silence: 'You should say:',
    assessment_handle_silence: `You can do it! Please say the new word.`,
    assessment_handle_silence_MID_GRADE_BAND: `You can do it. Please say the new word.`, // Edit v1
    assessment_handle_silence_HIGH_GRADE_BAND: `Please say the new word.`, // Edit v1
    assessment_handle_first_item_prompt: 'Ok, now let’s play with the word:',
    assessment_handle_first_item_make_change: `Let's change one letter.`,
    assessment_handle_first_item_prompt_to_read: `Now it is your turn to say the new word.`,
    assessment_handle_nth_item_prompt: 'Ok, let’s play with the word:',
    assessment_handle_nth_item_make_change: `Let's change one letter.`,
    assessment_handle_nth_item_prompt_to_read: `What's the word?`,
    assessment_handle_item_done_try_another: `Good try. Now let's try some other words.`,
    assessment_handle_end: `Got it!  Thanks.`,
    end: "Thank you!",
    tutor_example_intro_FTUE: "Let's play the letter swap game. Watch me play first by changing a sound and making a new word. The word is:",
    tutor_example_intro_FTUE_HIGH_GRADE_BAND: "Let's do the letter swap exercise. Watch me first by changing a sound and making a new word. The word is:", // Edit v1
    tutor_example_change_one_FTUE: "Now I change the sound and look, the new word is:",
    tutor_example_change_one: `Let's change one sound.`,
    tutor_example_intro: "Next, let's play with the word:",
    tutor_example_ask_word: `Now you try. Read the new word.`,
    tutor_subsequent_ask_word: `Please read the new word.`,
    tutor_silent_ask_word: `Can you say the sounds in the new word?`,
    tutor_silent_end: `The word is`,
    non_ortho: {
      example: {
        we_are_now: `We are now going to play a game with words. Wait to speak until I let you know it's time.`,
        these_boxes_represent: `These three boxes represent the three sounds in the word:`,
        those_sounds_are: `Those three sounds are:`,
        im_going_to_change: `I'm going to change one sound in the word:`,
        im_going_to_change_2: `I'm going to change the`,
        sound_to_the: `...sound to the`,
        sound_which_will_make: `...sound, which will make a new word.`,
        when_you_see_the_boxes: `When you see the boxes turn yellow, you should say the new word that it makes if I change the:`,
        in: `in`,
        to_a: `to a`,
      },
      subsequent: {
        now_lets_play_with: `Now let's play with the word:`,
        these_boxes_represent: `These three boxes represent the three sounds in the word:`,
        those_sounds_are: `Those three sounds are:`,
        lets_change: `Now let's change the:`,
        sound_to_the: `...sound to the`,
        sound: `...sound...`,
      }
    }
  },
  word_scramble: {
    before_we_look_at: 'Before we look at:',
    lets_talk_about: "let's talk about:",
    sound_out: `Let's sound out this word together.`,
    scrambled: "Uh-oh, the word got scrambled. Watch me fix this word.",
    scrambled_MID_GRADE_BAND: "The word got scrambled. Watch me reorder it.", // Edit v1
    scrambled_HIGH_GRADE_BAND: "The word got scrambled. Watch me reorder it.", // Edit v1
    fix_scrambled: `To fix scrambled words, just use your ${getInterface()} to drag the letters to the right place.`,
    ask_unscramble: "Move the boxes to fix the word.",
    your_turn: "Your turn",
    ask_word_1: "Read this word.",
    ask_word_2: "Now, read this word.",
    this_is_our_word: 'This is our word:',
    unscrambled: 'unscrambled',
    lets_do_some_reading: "Let's do some reading.",
    you_got: 'You got:',
    back_in_order: 'back in order',
    fantastic_job: 'Fantastic job',
  },  /* end intervention library strings */


  comprehensionPrompt: [
    "This question might be tricky. Make your best guess by clicking on one of the answers.",
    "Which answer makes the most sense? Click on one of the answers.",
  ],
  comprehensionWrongAnswer: [
    "Oops, that's not correct. Try again.",
    "Try again. That's not right.",
    "Hmm, let's check that answer.",
  ],
  comprehensionWrongAnswer_MID_GRADE_BAND: [
    "Let's think through this again.",
    "Try again. That's not right.",
    "Let's check that answer.",
  ],
  comprehensionWrongAnswer_HIGH_GRADE_BAND: [
    "Let's think through this again.",
    "Try again. That's not right.",
    "Let's check that answer.",
  ],
  syllable_segmentation: {
    ftue_intro:'When you come across long words while reading, you can divide the word into smaller parts, called syllables, to help you read it. ',
    ftue_intro_watch: "Watch as I drag the dotted lines to segment the word.",
    ftue_intro_your_turn: "Okay, now it's your turn!",
    ftue_intro_your_turn_resume: "Think about how to divide this word. Drag the dotted lines to segment the word. Click the submit button when you are finished.",
    non_ftue_intro: "Think about how to divide this word. Drag the dotted lines to segment the word. Click the submit button when you are finished.",
    dnd_idle_1: "You can do it! Drag the dotted lines to the correct spaces between the letters to segment the word.",
    dnd_idle_1_MID_GRADE_BAND: "You can do it. Drag the dotted lines to the correct spaces between the letters to segment the word.", // Edit v1
    dnd_idle_1_HIGH_GRADE_BAND: "Drag the dotted lines to the correct spaces between the letters to segment the word.", // Edit v1
    dnd_idle_2: "Let’s do this one together. Watch as I drag the dotted lines to the correct spaces to segment the word.",
    dnd_wrong: "Let me help you with this.",
    dnd_wrong_resume: "Watch as I drag the dotted line(s) to the correct space(s) to segment the word.",
    dnd_correct: "You got it!",
    response_into: "What is the word?",
    response_idle_1: "Can you say this word out loud?",
    response_idle_1_MID_GRADE_BAND: "Please say this word out loud.", // Edit v1
    response_idle_1_HIGH_GRADE_BAND: "Please say this word out loud.", // Edit v1
    response_correct: ({word})=>`That’s it! Great job on: "${word}".`
  },
  syllable_blend_click: {
    non_ftue_intro: "Click on each syllable.",
    tap_idle_1: "You can do it! Tap the highlighted syllable to hear it.",
    tap_idle_1_MID_GRADE_BAND: "Tap the highlighted syllable to hear it.",
    tap_idle_1_HIGH_GRADE_BAND: "Tap the next syllable.",
    tap_idle_2: "Let me help you with this one. Listen to each syllable.",
    combine_intro: "Now, let's put the syllables together. Click this button.",
    response_intro: "Blend them all together — what is the complete word?",
    response_correct: ({word}) => `Yes! Let's continue reading.`,
  },
  syllable_decoding: {
    look_intro: "Look at the word.",
    listen_intro: "Listen to each syllable.",
    say_intro: "Now you say each syllable.",
    blend_intro: "Great job! Now let's blend the syllables.",
    blend_intro_quiet: "Now let's blend the syllables.",
    read_intro: "Now you read the whole word.",
    read_correct: ({word}) => `Yes! Let's continue reading.`,
  },
  phoneme_syllable_word: {
    look_intro: ({word}) => `Look at the word: ${word}.`,
    listen_sounds_intro: "Listen to each sound.",
    say_sounds_intro: "Now you say each sound.",
    blend_intro: "Now blend the sounds into syllables.",
    say_syllables_intro: "Now you say each syllable.",
    read_intro: "Now read the whole word.",
    read_correct: ({word}) => `Yes! Let's continue reading.`,
  },
};












const ES_MX_INTERVENTION_STRINGS = {
  pageGambitGoodPhrases: [
    "¡Así se hace!",
    "¡Sigamos leyendo!",
    "¡Vamos a la siguiente página!",
    "¡Qué bien lees!",
    "¡Así se lee!",
    "¡Estás que vuelas! ¡Siguiente página!",
    "¡Espectacular!",
    "¡Pasemos de página!",
    "¡Aquí va la siguiente página!",
    "¡Adelante!"
  ],
  pageGambitGoodPhrases_MID_GRADE_BAND: [
    "¡Así se hace!",
    "¡Sigamos leyendo!",
    "¡Vamos a la siguiente página!",
    "¡Qué bien lees!",
    "¡Vas muy bien!",
    "¡Tú puedes! Vamos a la siguiente página.",
    "¡Espectacular!",
    "¡Pasemos de página!",
    "¡Aquí va la siguiente página!",
    "¡Adelante!"
  ],
  pageGambitGoodPhrases_HIGH_GRADE_BAND: [
    "¡Así se hace!",
    "¡Sigamos leyendo!",
    "¡Vamos a la siguiente página!",
    "¡Qué bien lees!",
    "¡Vas muy bien!",
    "¡Tú puedes! Vamos a la siguiente página.",
    "¡Espectacular!",
    "¡Pasemos de página!",
    "¡Aquí va la siguiente página!",
    "¡Adelante!"
  ],
  pageGambitStrugglingPhrases: [
    "¡Genial, terminaste la página!",
    "¡Buen trabajo! Vamos a la siguiente página.",
    "¡Le estás echando muchas ganas!",
    "¡Qué bien lees! Aquí viene la siguiente página.",
    "¡Inténtalo de nuevo!",
    "¡Vas muy bien! Aquí viene la siguiente página.",
    "¡Ya casi terminas! ¡Siguiente página!",
    "¡Buen trabajo! Siguiente página."
  ],
  pageGambitStrugglingPhrases_MID_GRADE_BAND: [
    "¡Eso estuvo muy bien!",
    "¡Qué bien lo estás haciendo!",
    "¡Muy bien! ¡Sigue así!",
    "¡Qué bien lees! Aquí viene la siguiente página.",
    "¡Inténtalo de nuevo!",
    "¡Vas muy bien! Aquí viene la siguiente página.",
    "¡Ya casi terminas! ¡Siguiente página!",
    "¡Buen trabajo! Siguiente página."
  ],
  pageGambitStrugglingPhrases_HIGH_GRADE_BAND: [
    "¡Eso estuvo muy bien!",
    "¡Qué bien lo estás haciendo!",
    "¡Muy bien! Sigue así.",
    "¡Qué bien lees! Aquí viene la siguiente página.",
    "¡Casi! Vuelve a intentarlo.",
    "Vas muy bien. Aquí viene la siguiente página.",
    "¡Ya casi! Siguiente página.",
    "¡Buen trabajo! Siguiente página."
  ],
  lastPhraseOnPageResponse: [
    "¡Increíble!",
    "¡Súper!",
    "¡Bien hecho!"
  ],
  lastPhraseOnPageResponse_HIGH_GRADE_BAND: [
    "¡Así se hace!",
    "¡Sigue así!",
    "¡Vas bien!",
  ],
  readWithMePrompt: [
    "¡Ahora es tu turno!",
    "¡Ahora inténtalo tú!",
    "¿Listo? ¡A leer!",
    "¡Inténtalo!"
  ],
  readWithMePrompt_MID_GRADE_BAND: [
    "¡Hazlo tú ahora!",
    "¡Bien, ahora lee tú!",
    "Comienza cuando estés listo.",
    "Ahora lee."
  ],
  readWithMePrompt_HIGH_GRADE_BAND: [
    "¡Ahora tú!",
    "Bien, ¡tu turno!",
    "Comienza cuando estés listo.",
    "¡Inténtalo!"
  ],
  try_again: [
    "¡Inténtalo una vez más!",
    "Vuelve a leerlo.",
    "¡Una vez más!",
    "¿Lo intentamos de nuevo?",
    "¿Me lo lees otra vez?",
    "¿Lo intentamos otra vez? ¡Tú puedes!"
  ],
  try_again_MID_GRADE_BAND: [
    "¡Inténtalo una vez más!",
    "¡Una vez más!",
    "Léelo en voz alta de nuevo.",
    "¿Me lo lees otra vez?",
    "¡Inténtalo otra vez!",
  ],
  try_again_HIGH_GRADE_BAND: [
    "Inténtalo una vez más.",
    "¿Lo lees otra vez?",
    "Una vez más.",
    "Léelo en voz alta de nuevo.",
    "¿Lo lees otra vez?",
    "Inténtalo otra vez.",
  ],
  keep_reading: {
    proficient: [
      "¡Sigue así!",
      "¡Sigue, vas muy bien!", //removing accent on continúa here and elsewhere because amira sounds weird when she says it
      "¡Sigue leyendo!",
      "¡Continuemos!",
    ],
    capable: [
      "¡Vamos a seguir leyendo!",
      "¡Sigue así!",
      "¡Sigue, vas muy bien!",
      "¡Vas muy bien!",
      "¡Sigue leyendo!"
    ],
    beginner: [
      "¡Vamos a seguir leyendo!",
      "¡Vas muy bien!",
      "¡Leamos un poco más!",
      "¡Sigue leyendo!",
    ],
  },
  keep_reading_MID_GRADE_BAND: {
    proficient: [
      "¡Sigue así!",
      "¡Sigue, vas muy bien!",
      "¡Sigue leyendo!",
      "¡Continuemos!",
    ],
    capable: [
      "¡Vamos a seguir leyendo!",
      "¡Sigue así!",
      "¡Sigue, vas muy bien!",
      "¡Vas muy bien!",
      "¡Sigue leyendo!"
    ],
    beginner: [
      "Vamos a seguir leyendo.",
      "¡Muy bien! Sigue así.",
      "¡Leamos un poco más!",
      "¡Sigue leyendo!",
    ],
  },
  keep_reading_HIGH_GRADE_BAND: {
    proficient: [
      "Avancemos.",
      "Continuemos.", //removing accent on continúa here and elsewhere because amira sounds weird when she says it,
      "Sigue leyendo.",
      "Continuemos.",
      "Sigue leyendo."
    ],
    capable: [
      "Seguimos leyendo.",
      "Sigue adelante.",
      "Sigue, vas muy bien.",
      "Vas muy bien.",
      "Sigue leyendo."
    ],
    beginner: [
      "Seguimos leyendo.",
      "Buen trabajo. Sigue así.",
      "Vamos a leer un poco más.",
      "Sigue leyendo.",
    ],
  },
  read_perfectly: [
    "¡Excelente! Lo leíste perfectamente.",
    "¡Fantástico!",
    "¡Así se hace! ¡Qué bien leíste!",
    "¡Lectura increíble!",
    "¡Sin errores!",
    "¡Lo leíste clarito y sin errores!",
    "¡Así se hace! Cero errores."
  ],
  read_perfectly_MID_GRADE_BAND: [
    "¡Qué buena lectura!",
    "¡Qué bien lo leíste!",
    "¡Muy buena lectura!",
    "¡Leíste muy bien! ¡Buen trabajo!",
    "¡Sin errores! ¡Qué lectura tan perfecta!",
    "¡Leíste clarito y sin errores!",
    "¡Bien hecho! Cero errores.",
  ],
  read_perfectly_HIGH_GRADE_BAND: [
    "Qué buena lectura.",
    "Qué bien lo leíste.",
    "Muy buena lectura.",
    "Leíste muy bien. Buen trabajo.",
    "Sin errores. Lectura impecable.",
    "Leíste clarito y sin errores.",
    "Bien hecho. Cero errores.",
  ],
  storyPhrases: {
    proficient: [
      "¡Genial! Terminaste el cuento.",
      "Veamos cómo te fue.",
      "¡Muy bien! Ya terminaste el cuento.",
      "¡Genial! Ya terminaste el cuento.",
      "Veamos cómo te fue.",
       "¡Buen trabajo! Terminaste el cuento.",
      "Veamos cómo te fue con el cuento.",
      "¡Terminaste!"
    ],

    capable: [
      "¡Muy bien! Ya terminaste el cuento.",
      "¡Genial! Ya terminaste el cuento.",
      "Veamos cómo te fue.",
      "Ya terminaste. ¡Bien hecho!",
       "¡Muy bien hecho! ¡Leíste todo el cuento!",
       "¡Buen trabajo! ¡Terminaste el cuento!",
      "¡Vamos a ver cómo te fue con este cuento!",
      "¡Terminaste!"
    ],
    beginner: [
      "¡Llegaste al final! ¡Buen trabajo!",
      "¡Terminaste! ¡Bien hecho!",
      "¡Gracias por leer conmigo!",
      "¡Vamos a ver cómo te fue con este cuento!",
      "¡Eso fue divertido y leíste muy bien!",
      "Ya terminaste. ¡Bien hecho!",
      "¡Hiciste un buen trabajo!",
      "¡Eso fue divertido y leíste muy bien!"
    ],
  },
  storyPhrases_MID_GRADE_BAND: {
    proficient: [
      "¡Listo, terminaste este texto!",
      "Veamos cómo te fue.",
      "¡Perfecto, ya terminaste este texto!",
      "Buen trabajo, terminaste el texto.",
      "Veamos cómo te fue.",
      "¡Muy bien! Terminaste este texto.",
      "Vamos a ver cómo te fue con este texto.",
      "¡Terminaste!"
    ],

    capable: [
      "Perfecto, ya finalizaste este texto.",
      "Buen trabajo, terminaste el texto.",
      "Veamos cómo te fue.",
      "Ya terminaste. ¡Bien hecho!",
      "¡Excelente, leíste todo el texto!",
      "¡Bien hecho, terminaste el texto!",
      "Vamos a ver cómo te fue con este texto.",
      "¡Terminaste!"
    ],
    beginner: [
      "Llegaste al final del texto. ¡Muy bien!",
      "Terminaste. ¡Bien hecho!",
      "¡Qué buena lectura hoy!",
      "Vamos a ver cómo te fue con este texto.",
      "¡Leíste muy bien!",
      "Ya terminaste. ¡Bien hecho!",
      "¡Hiciste un buen trabajo!",
      "Leíste con mucha claridad.",
    ],
  },
  storyPhrases_HIGH_GRADE_BAND: {
    proficient: [
      "Listo, terminaste este texto.",
      "Veamos cómo te fue.",
      "Perfecto, ya terminaste este texto.",
      "Buen trabajo, terminaste el texto.",
      "Veamos cómo te fue.",
      "Muy bien. Terminaste este texto.",
      "Vamos a ver cómo te fue con este texto.",
      "Terminaste."
    ],

    capable: [
      "Terminaste este texto.",
      "Buen trabajo, terminaste el texto.",
      "Veamos cómo te fue.",
      "Ya terminaste. Bien hecho.",
      "Excelente, leíste todo el texto.",
      "Bien hecho, terminaste el texto.",
      "Vamos a ver cómo te fue con este texto.",
      "Terminaste."
    ],
    beginner: [
      "Llegaste al final del texto. Muy bien.",
      "Buena lectura hoy.",
      "Vamos a ver cómo te fue con este texto.",
      "Leíste muy bien.",
      "Ya terminaste. Bien hecho.",
      "Hiciste un buen trabajo.",
      "Leíste con mucha claridad.",
    ],
  },
  toofastPhrases: {
    proficient: [
      "Lee despacito. ¡Quiero escucharte bien!",
      "Lee a tu ritmo. ¡Así te entiendo mejor!",
      "Lee despacito. ¡Quiero escuchar cada palabra!"
    ],
    capable: [
      "Lee despacito. ¡Quiero escucharte bien!",
      "Pronuncia bien cada palabra. ¡Así te entiendo mejor!",
      "Lee un poquito más despacio. ¡Quiero escucharte bien!"
    ],
    beginner: [
      "Casi no te escucho. Lee despacito y clarito.",
      "Lee cada palabra lo más claro que puedas.",
      "Habla un poquito más alto. ¡Quiero escucharte!",
      "¿Puedes leer un poquito más alto?"
    ],
  },
  comprehensionIntro: {
    proficient: [
      "Hablemos del cuento.",
      "¿Me cuentas sobre el cuento?",
      "¡Buen trabajo! Ahora una pregunta sobre el cuento.",
      "Pausemos y pensemos en lo que leímos.",
      "Pensemos en lo que leímos."
    ],
    capable: [
      "¿Me cuentas sobre el cuento?",
      "¡Buen trabajo! Tengo una pregunta.",
      "¿Me contestas esta pregunta?",
      "Pausemos y pensemos en lo que leímos.",
      "Pensemos en lo que leímos."
    ],
    beginner: [
      "Aquí tienes una pregunta sobre el cuento.",
      "Cuéntame sobre el cuento.",
      "¿Me cuentas más sobre el cuento?",
      "Pausemos y pensemos en lo que leímos."
    ],
  },
  comprehensionIntro_MID_GRADE_BAND: {
    proficient: [
      "Hablemos sobre el texto.",
      "¿Qué me puedes contar sobre el texto?",
      "¡Buen trabajo! Una pregunta sobre el texto.",
      "Pausemos y pensemos en lo que leímos.",
      "Pensemos en lo que leímos."
    ],
    capable: [
      "¿Qué me puedes contar sobre el texto?",
      "¡Buen trabajo! Tengo una pregunta.",
      "¿Me contestas esta pregunta?",
      "Pausemos y pensemos en lo que leímos.",
      "Pensemos en lo que leímos."
    ],
    beginner: [
      "Aquí tienes una pregunta sobre el texto.",
      "Dime qué entendiste del texto.",
      "¿Qué entendiste del texto?",
      "Pausemos y pensemos en lo que leímos."
    ],
  },
  comprehensionIntro_HIGH_GRADE_BAND: {
    proficient: [
      "Hablemos sobre el texto.",
      "¿Qué me puedes contar sobre el texto?",
      "Buen trabajo. Una pregunta sobre el texto.",
      "Pausemos y pensemos en lo que leímos.",
      "Pensemos en lo que leímos."
    ],
    capable: [
      "¿Qué me puedes contar sobre el texto?",
      "Buen trabajo. Tengo una pregunta.",
      "¿Me contestas esta pregunta?",
      "Pausemos y pensemos en lo que leímos.",
      "Pensemos en lo que leímos."
    ],
    beginner: [
      "Aquí tienes una pregunta sobre el texto.",
      "Dime qué entendiste del texto.",
      "Ayúdame a entender mejor el texto.",
      "Pausemos y pensemos en lo que leímos."
    ],
  },
  comprehensionRightAnswer: {
    proficient: [
      "¡Leíste muy bien! ¡Así es!",
      "¡Eso es!",
      "¡Estoy muy orgullosa de ti! ¡Lo estás haciendo muy bien!"
    ],
    capable: [
      "¡Muy bien! Respondiste correctamente.",
      "¡Leíste muy bien! ¡Así es!",
      "¡Estoy muy orgullosa de ti! ¡Lo estás haciendo muy bien!"
    ],
    beginner: [
      "¡Leíste muy bien! ¡Así es!",
      "¡Muy bien! Respondiste correctamente.",
      "¡Estoy muy orgullosa de ti! ¡Lo estás haciendo muy bien!"
    ],
  },
  comprehensionRightAnswer_MID_GRADE_BAND: {
    proficient: [
      "Leíste muy bien. ¡Así es!",
      "¡Eso es!",
      "Buen avance. ¡Sigue así!",
    ],
    capable: [
      "¡Muy bien! Respondiste correctamente.",
      "Leíste muy bien. ¡Así es!",
      "Buen avance. ¡Sigue así!",
    ],
    beginner: [
      "Leíste muy bien. ¡Así es!",
      "¡Muy bien! Respondiste correctamente.",
      "Buen avance. ¡Sigue así!",
    ],
  },
  comprehensionRightAnswer_HIGH_GRADE_BAND: {
    proficient: [
      "Leíste muy bien. Esa es la respuesta correcta.",
      "Eso es.",
      "Buen avance. Sigue así.",
    ],
    capable: [
      "Muy bien. Respondiste correctamente.",
      "Leíste muy bien. Esa es la respuesta correcta.",
      "Buen avance. Sigue así.",
    ],
    beginner: [
      "Leíste muy bien. Esa es la respuesta correcta.",
      "Muy bien. Respondiste correctamente.",
      "Buen avance. Sigue así.",
    ],
  },
  comprehensionWrongAnswerOnFirst: [
    "¡Inténtalo otra vez!", // Edit v1
    "¡Uy! Vamos a revisar esa respuesta.",
    "Esa pregunta es complicada. ¡Vuelve a intentarlo!",
    "Esta pregunta es difícil. ¡Vuelve a intentarlo!"
  ],
   comprehensionWrongAnswerOnFirst_MID_GRADE_BAND: [
    "Revisamos esto otra vez.", // Edit v1
    "Revisamos si esa respuesta está bien.", // Edit v1
    "Esa pregunta es complicada. ¡Vuelve a intentarlo!",
    "Pensamos en eso otra vez." // Edit v1
  ],
  comprehensionWrongAnswerOnFirst_HIGH_GRADE_BAND: [
    "Revisamos esto otra vez.", // Edit v1
    "Revisamos si esa respuesta está bien.", // Edit v1
    "Esa pregunta es complicada. Vuelve a intentarlo.",
    "Vamos a verla otra vez con calma." // Edit v1
  ],
  comprehensionWrongAnswerOnSecond: [
    "¡Inténtalo otra vez!", // Edit v1
    "¡Uy! Vamos a revisar esa respuesta.",
    "Esa pregunta es complicada. ¡Vuelve a intentarlo!",
    "Esta pregunta es difícil. ¡Vuelve a intentarlo!"
  ],
  comprehensionWrongAnswerRetry: [
    "¡Vaya! Sigamos intentando.",
    "Inténtalo otra vez. ¡Tú puedes!",
    "¡Vamos a revisar esa respuesta otra vez!",
    "Mmm, ¡vamos a revisar esa respuesta!", // Edit v1
  ],
  comprehensionWrongAnswerRetry_MID_GRADE_BAND: [
    "Vamos a analizar esto una vez más.", // Edit v1
    "Inténtalo otra vez. ¡Tú puedes!",
    "Vamos a revisar esa respuesta una vez más.",
    "Vamos a revisar esa respuesta.", // Edit v1
  ],
  comprehensionWrongAnswerRetry_HIGH_GRADE_BAND: [
    "Analizamos esto una vez más.", // Edit v1
    "Inténtalo otra vez. Casi lo logras.",
    "Revisamos esa respuesta una vez más.",
    "Vamos a revisar esa respuesta.", // Edit v1
  ],
  comprehensionWrongAnswer: [
    "¡Casi! Inténtalo otra vez.",
    "Inténtalo otra vez. ¡Tú puedes!",
    "Mmm, ¡vamos a revisar esa respuesta!", // Edit v1
  ],
  comprehensionWrongAnswer_MID_GRADE_BAND: [
    "Analicemos esto una vez más.",
    "Inténtalo otra vez. ¡Tú puedes!",
    "Vamos a revisar esa respuesta.",
  ],
  comprehensionWrongAnswer_HIGH_GRADE_BAND: [
    "Analicemos esto una vez más.",
    "Inténtalo otra vez. Casi lo logras.",
    "Vamos a revisar esa respuesta.",
  ],
  comprehensionRight: {
    proficient: [
      "¡Respondiste bien!", // Edit v2
      "¡Eso es!",
      "¡Sí, así es!"
    ],
    capable: [
      "¡Respondiste bien!",
      "¡Muy bien! ¡Respondiste bien!",
      "¡Sí, así es!",
      "Diste con la respuesta."
    ],
    beginner: [
      "¡Respondiste bien!",
      "¡Eso es!",
      "¡Sí, así es!"
    ],
  },
  comprehensionRight_MID_GRADE_BAND: {
    proficient: [
      "¡Respondiste bien!",
      "¡Eso es!",
      "¡Diste con la respuesta!",
    ],
    capable: [
      "¡Respondiste bien!",
      "¡Eso es! ¡Respondiste bien!",
      "¡Así es!",
      "¡Diste con la respuesta!",
    ],
    beginner: [
      "Respondiste correctamente.",
      "¡Eso es!",
      "¡Sí, así es!"
    ],
  },
  comprehensionRight_HIGH_GRADE_BAND: {
    proficient: [
      "Respondiste bien.",
      "Así es.",
      "Diste con la respuesta.",
    ],
    capable: [
      "Respondiste bien.",
      "Muy bien. Respondiste bien.",
      "Así es.",
      "Diste con la respuesta.",
    ],
    beginner: [
      "Respondiste correctamente.",
      "Eso es.",
      "Sí, así es."
    ],
  },
  comprehensionPrompt: [
    "Esta pregunta es un reto. ¡Haz clic en la mejor respuesta!",
    "¿Cuál respuesta tiene más sentido? Selecciona la mejor."
  ],
  interventionOneErrorLeadInDontSayWord: {
    proficient: [
      "¡Vamos a revisar una palabra juntos!",
      "¡Vamos a fijarnos en una palabra!",
      "¡Espera! ¡Vamos a practicar una palabra!",
      "Antes de continuar, vamos a practicar una de las palabras.",
      "Practiquemos una de estas palabras.",
      "Tomemos un momento para repasar."
    ],
    capable: [
      "¡Vamos a revisar una palabra juntos!",
      "Practiquemos una de estas palabras.",
      "Tomemos un momento para repasar.",
      "¡Espera! ¡Vamos a practicar una palabra!",
      "¡Aquí te ayudo!",
      "Practiquemos una de las palabras."
    ],
    beginner: [
      "¿Qué tal si te ayudo con una de estas palabras?",
      "Enfoquémonos en una palabra.",
      "¡Aquí te ayudo!",
      "¿Por qué no practicamos una de las palabras?",
      "¡Vamos a practicar una palabra juntos!",
      "Quiero hablarte de una palabra."
    ],
  },
  interventionOneErrorLeadInSayWord: {
    proficient: [
      "Vamos a repasar la palabra: \"${p0}\".", // Edit
      "Revisemos la palabra: \"${p0}\".",
      "Espera. Revisemos la palabra: \"${p0}\".",
      "Practiquemos la palabra: \"${p0}\".",
      "Vamos a detenernos en la palabra: \"${p0}\".",
      "Deberíamos practicar la palabra: \"${p0}\".",
      "Vamos a repasar la palabra: \"${p0}\".",
      "Practiquemos la palabra: \"${p0}\".",
      "Hablemos sobre la palabra: \"${p0}\".",
      "Espera. Practiquemos la palabra: \"${p0}\".",
      "Antes de continuar, repasemos la palabra: \"${p0}\".",
      "Practiquemos la palabra: \"${p0}\".",
      "¿Qué tal si practicamos la palabra: \"${p0}\"?",
      "Tomemos un momento para repasar la palabra: \"${p0}\"."
    ],
    capable: [
      "Revisemos la palabra: \"${p0}\".",
      "Espera. Revisemos la palabra: \"${p0}\".",
      "Enfoquémonos en la palabra: \"${p0}\".",
      "Tomemos un momento para repasar la palabra: \"${p0}\".",
      "Practiquemos la palabra: \"${p0}\".",
      "Hablemos sobre la palabra: \"${p0}\".",
      "¡Un momento!",
      "Antes de continuar, practiquemos la palabra: \"${p0}\".",
      "Practiquemos la palabra: \"${p0}\".",
      "Practiquemos la palabra: \"${p0}\".",
      "Vamos a repasar la palabra: \"${p0}\".",
      "Vamos a practicar la palabra: \"${p0}\".",
      "Espera. Hablemos sobre la palabra: \"${p0}\".",
      "¿Qué tal si practicamos la palabra: \"${p0}\"?",
      "Tomemos un momento para repasar la palabra: \"${p0}\"."
    ],
    beginner: [
      "Espera. Practiquemos la palabra: \"${p0}\".",
      "Esto puede ayudarte con la palabra: \"${p0}\".",
      "Practiquemos la palabra: \"${p0}\".",
      "Vamos a repasar la palabra: \"${p0}\".",
      "Hablemos sobre la palabra: \"${p0}\".",
      "Antes de continuar, practiquemos la palabra: \"${p0}\".",
      "Practiquemos la palabra: \"${p0}\".",
      "Practiquemos la palabra: \"${p0}\".",
      "Vamos a practicar la palabra: \"${p0}\".",
      "Espera. Hablemos sobre la palabra: \"${p0}\".",
      "Tomemos un momento para repasar la palabra: \"${p0}\"."
    ],
  },
  interventionMultipleErrorLeadIn: {
    proficient: [
      "Repasar puede ayudarte a comprender mejor.",
      "¿Qué tal si hacemos un repaso rápido?",
      "Revisemos la oración.",
      "¡Vamos a practicar esta oración!",
      "Repasemos esa oración.",
      "¡Aquí va un repaso rápido!",
      "¿Por qué no trabajamos juntos un momento?"
    ],
    capable: [
      "¡Vamos a leer esa oración otra vez!",
      "¡Vamos a practicar esa oración!",
      "¡Vamos a hacer un repaso rápido!",
      "Practiquemos algunas palabras.",
      "Repasemos juntos.",
    ],
    beginner: [
      "Repasemos esa oración.",
      "Repasemos.",
      "¡Espera! ¡Vamos a practicar esta oración!",
      "Tomemos un momento para repasar.",
      "Espera. Tomemos un momento para repasar estas palabras.",
      "¡Vamos a practicar esto!",
      "¿Qué tal si practicamos esto?",
      "Espera. Tomemos un momento para repasar estas palabras.",
      "¡Vamos a practicar esto juntos!"
    ],
  },
  endOfClapPhrases: {
    beginner: [
      "Buen trabajo. Sigue leyendo.",
      "Bien hecho. ¡Continuemos!",
      "¡Lo estás haciendo muy bien! Sigue así.", // Edit v1
      "Aprendiste una nueva palabra. Sigue leyendo."
    ],
    capable: [
      "¡Excelente! Sigue leyendo.",
      "Magnífico. ¡Continuemos!",
      "Bien hecho. ¡Continuemos!",
      "Eres toda una estrella. Sigue leyendo."
    ],
    capable_MID_GRADE_BAND: [
      "¡Excelente! Sigue leyendo.",
      "Magnífico. Puedes continuar.",
      "Bien hecho. Puedes continuar.",
      "Vas muy bien. Continúa con la lectura.", // Edit v1
    ],
    capable_HIGH_GRADE_BAND: [
      "¡Excelente! Sigue leyendo.",
      "Magnífico. Puedes continuar.",
      "Bien hecho. Puedes continuar.",
      "Vas muy bien. Continúa con la lectura.", // Edit v1
    ],
    proficient: [
      "¡Sigue leyendo!",
      "Excelente. ¡Continuemos!",
      "Magnífico trabajo. ¡Continuemos!",
      "Eres toda una estrella. Sigue leyendo."
    ],
    proficient_MID_GRADE_BAND: [
      "Sigue leyendo.",
      "Excelente. Puedes continuar.",
      "Magnífico trabajo. Puedes continuar.",
      "Vas muy bien. Continúa con la lectura.", // Edit v1
    ],
    proficient_HIGH_GRADE_BAND: [
      "Sigue leyendo.",
      "Excelente. Puedes continuar.",
      "Magnífico trabajo. Puedes continuar.",
      "Vas muy bien. Continúa con la lectura.", // Edit v1
    ],
  },
  feedbackUtterances: [
    "Si digo esto, hay un error en el programa.",
    "¡Buen trabajo! Vamos a hacerlo otra vez.",
    "¡Lo estás haciendo muy bien! Sigue así.", // Edit v1
    "¡Genial, ya sabes otra palabra! Continuemos."
  ],
  listening: {
    greatJob: [
      "¡Así se hace!",
      "¡Muy bien hecho!", // Edit v1
      "¡Sigue así!",
      "¡Fantástico! ¡Seguimos!",
      "¡Buen trabajo!",
      "¡Listo! Continuemos."
    ],
    greatJob_MID_GRADE_BAND: [
      "¡Excelente!",
      "¡Muy bien hecho!", // Edit v1
      "¡Mantén ese ritmo!", // Edit v1
      "¡Muy bien! Seguimos.", // Edit v1
      "¡Buen trabajo!",
      "¡Así se hace! Seguimos."
    ],
    greatJob_HIGH_GRADE_BAND: [
      "Excelente.",
      "Muy bien hecho.", // Edit v1
      "Mantén ese ritmo.", // Edit v1
      "Muy bien, seguimos.", // Edit v1
      "Buen trabajo.",
      "Muy bien. Seguimos."
    ],
    didntHear: [
      "¡Inténtalo otra vez!",
      "No te escuché.",
      "Inténtalo otra vez, por favor.",
      "Dilo un poquito más alto.",
      "No te entendí. ¡Inténtalo otra vez!",
      "¡Repítelo un poco más alto!",
      "Dilo en voz alta otra vez.",
      "¿Cuál es la palabra?"
    ],
    didntHear_MID_GRADE_BAND: [
      "¡Inténtalo otra vez!",
      "No te escuché.",
      "Inténtalo otra vez, por favor.",
      "Dilo un poco más alto.",
      "No te entendí. Inténtalo otra vez.",
      "Repítelo un poco más alto.",
      "Repítelo en voz alta.", // Edit v1
      "¿Cuál es la palabra?"
    ],
    didntHear_HIGH_GRADE_BAND: [
      "Inténtalo otra vez.",
      "No te escuché.",
      "Inténtalo otra vez, por favor.",
      "Dilo un poco más alto.",
      "No te entendí. Inténtalo otra vez.",
      "Repítelo un poco más alto.",
      "Repítelo en voz alta.", // Edit v1
      "¿Cuál es la palabra?"
    ],
    moveOn: [
      "¡Listo! Continuemos.",
      "Continuemos.",
      "¡Muy bien, sigue leyendo!",
      "Continuemos.",
      "¡Sigue leyendo!",
      "¡Adelante!",
      "Continuemos.",
      "¡Vamos a seguir leyendo!",
      "Volvamos a la historia." // Edit
    ],
    moveOn_MID_GRADE_BAND: [
      "¡Muy bien, sigamos!",
      "¡Sigamos adelante!",
      "¡Muy bien, sigue leyendo!",
      "¡Vamos a continuar!",
      "¡Sigue leyendo!",
      "¡Adelante, continúa!",
      "¡Sigue adelante!",
      "¡Continuemos con la lectura!",
      "¡Volvamos al texto!", // Edit V1
    ],
    moveOn_HIGH_GRADE_BAND: [
      "Bien, sigamos.",
      "Sigamos adelante.",
      "Muy bien, sigue leyendo.",
      "Continuemos.",
      "Sigue leyendo.",
      "Cuando quieras, continúa.",
      "Sigue adelante.",
      "Sigamos leyendo.",
      "Vuelve al texto.", // Edit V1
    ],
    giveAnswer: [ //Listen.js appends the target word before sending the text to speech
      "La palabra es: ",
      "Bien, la palabra es:",
      "Esta es: ",
      "Esta palabra es: ",
      "Di la palabra: ",
    ],
    thanks: [
      "Bien, gracias.",
      "Gracias, sigue así.", // Edit v1
      "Muchas gracias.",
      "¡Buen esfuerzo!",
      "Gracias, ¡sigue leyendo!"
    ]
  },
  rhymes_with: "Esta palabra rima con: ",
  this_word: "Esta palabra",
  rhymes: "rima",
  with: "con",
  listen_to_rhyme: "Escucha la palabra que rima",
  listen_for_the: "Escucha el",
  spelling: "deletreo",
  of: "de",
  is_spelled: "se deletrea",
  let_me_spell: "Permíteme deletrear la palabra",
  you_said: "Podrías haber dicho",
  instead_of: "en lugar de",
  the_word_is: "La palabra es",
  important_word: "es una palabra importante. Di",
  three_times: "tres veces lo más rápido posible.",
  let_me_say: "Déjame decir la palabra",
  let_me_say_MID_GRADE_BAND: "Lo leeré en voz alta.", // Edit v1
  let_me_say_HIGH_GRADE_BAND: "Lo leeré en voz alta.", // Edit v1
  means: "significa",
  lets_read_the_word: "Leamos la palabra",
  fun_fact: "¡Dato curioso!",
  heres_a_fact: "¿Sabías que...?",
  watch_lips: "Observa los labios de esta persona diciendo",
  tap_play: "Para continuar, toca el botón de reproducción.",
  watch_how_to_say: "Observa cómo se dice",
  now_you_say_word: "Ahora di tú la palabra ",
  lets_read_word: "Leamos la palabra",
  let_me: "Déjame",
  makes: "se pronuncia",
  say: "di",
  times: "veces",
  now_you_try_word: "Inténtalo con esta palabra.",
  im_going_to: "Voy a",
  the_word_is_capitalized: "La palabra es",
  sound_out_capitalized: "Di los sonidos",
  spellOutLeadIn: "Intenta pronunciar los sonidos que forman esta palabra.",
  spellOutLeadInBeforeVersion: "Voy a deletrear esta palabra.",
  imGoingToSoundThisWordOut: "Voy a decir los sonidos de esta palabra.", // Edit v1
  repeat_after_me: "Repite conmigo.",
  show_again: "Te lo muestro de nuevo.",
  be_careful_not_to: "Procura no",
  make_this_mistake: "cometer este error",
  your_turn: "Es tu turno",
  wait: "Espera",
  mistake_added: (word) => ` añadir ${(/^[aeiou]$/i).test(word[0]) ? 'an' : ''} ${word} al final.`,
  letsWorkOn: "Vamos a trabajar en:",
  mistake_dropped: (word) => ` omitir la terminación de la palabra ${word}.`,
  mistake_mix_up_ending: (word) => ` cambiar la terminación de la palabra ${word}.`,
  is_pronounced: "se pronuncia",
  word_has_many_letters_and_many_syllables: (wordLength, n) => `La palabra tiene ${wordLength} letras y ${n} ${n > 1 ? 'sílabas' : 'syllable'}.`,
  word_has_many_letters_and_many_sounds: (wordLength, n) => `La palabra tiene ${wordLength} letras y ${n} ${n > 1 ? 'sonidos' : 'sonido'}.`,
  try_to_sound_it_out: "Pronuncia los sonidos que forman esta palabra.",
  ok: "De acuerdo,",
  ok_im_going_to_sound_out_this_word_for_you: "Voy a pronunciar los sonidos que forman esta palabra.",
  ok_im_going_to_sound_out_this_word_for_you_HIGH_GRADE_BAND: "Voy a pronunciar esta palabra sonido por sonido.", // Edit v1
  pay_attention_to_the_word_ending: "Presta atención a la terminación de esta palabra",
  letters: "Letras",
  sounds: "Sonidos",

  /* intervention library strings */
  heres_a_riddle: "Tengo un acertijo para ti.",
  riddle_solved: "¡Sí!¡Resolviste el acertijo!",
  riddle_solved_MID_GRADE_BAND: "¡Lo lograste! Adivinaste el acertijo.", // Edit v1
  riddle_solved_HIGH_GRADE_BAND: "¡Lo lograste! Adivinaste el acertijo.", // Edit v1
  riddle_unsolved: (answer) => `Esperaba que dijeras ${answer}.`,
  fun_fact: "¡Dato curioso!",
  heres_a_fact: "Aquí hay un dato curioso sobre la palabra",
  morpheme: {
    prefix: "principio",
    suffix: "final",
    root: "raíz",
    means: 'significa',
    intro: ({ morphemePosition }) =>
      `Esta palabra tiene un ${morphemePosition} común. Si conoces este ${morphemePosition}, puedes descifrar muchas palabras. <break time=\"1s\"/>`,
    examples: ({ morphemePosition }) =>
      `Aquí hay varios ejemplos de palabras que usan el ${morphemePosition}`,
    ask_word: ({ morphemePosition }) =>
      `¿Cuál de estas palabras usa el mismo ${morphemePosition}?`,
    correct: 'está correcta. Cada vez que ves estas letras juntas, significa que la palabra trata sobre',
    struggle: ({ morphemePosition }) =>
      `es otra palabra que usa el ${morphemePosition} común`,
  },
  elkonin_box: {
    intro_1: ({ nSounds }) =>
      `Hay ${nSounds} sonidos en esta palabra. Verás que hay ${nSounds} casillas en la pantalla. Mueve la primera bola roja a la primera casilla y di el primer sonido. Luego, mueve el resto de las bolas a las casillas y di cada sonido.`,
    intro_2:
      "Mira cómo muevo estas bolas a las casillas. Cada sonido tiene su propia casilla.",
    tutor_intro_part_1: "Vamos con un nuevo ejercicio de sonidos. Tengo una palabra con 3 sonidos. La palabra es: ",
    tutor_intro_part_1_MID_GRADE_BAND: "Vamos con un nuevo ejercicio de sonidos. Esta palabra tiene 3 sonidos. La palabra es...", // Edit v1
    tutor_intro_part_1_HIGH_GRADE_BAND: "Vamos con un nuevo ejercicio de sonidos. Esta palabra tiene 3 sonidos. La palabra es...", // Edit v1
    tutor_intro_part_2: "Voy a decir los sonidos y mover una bola roja a una caja para cada sonido. Mírame hacerlo primero. La palabra es",
    ignore_extras:
      "Puede haber más casillas que sonidos en la palabra. Ignora las que sobren.",
    ask_word: `Ahora, junta esos sonidos y di la palabra.`,
    ask_sounds_1: ({ word }) => `Usa tu ${getSpanishInterface()} para mover las bolas a las cajas y di cada uno de los sonidos de la palabra ${word}.`,
    ask_sounds_2: ({ hasImage }) => `Usa tu ${getSpanishInterface()} para mover las bolas a las cajas y di los sonidos de la palabra${hasImage ? ' que aparece en la imagen' : ''}.`,
    your_turn: `Ahora es tu turno.`,
    your_turn_tutor: "Ahora es tu turno. La palabra es:",
    ask_blend: `Ahora, combina los sonidos para formar la palabra.`,
    correct: `Buen trabajo con la palabra: `,
    blend: `Ahora combinaré los sonidos para formar la palabra`,
    describe_1: `La palabra`,
    describe_2: ({ nSounds }) => `tiene ${nSounds} sonidos.`,
    feedback_1:
      `Usa tu ${getSpanishInterface()} para mover una bola y di cada uno de los sonidos en: `,
    feedback_2_part_1: `Los sonidos que forman la palabra`,
    feedback_2_part_2: `son`,
    struggle_part_1: `La palabra es: `,
    struggle_part_2: `Sigamos.`,
    too_many_sounds: "Demasiados sonidos.",
    lets_work_on: ({ word }) => `Practiquemos la palabra ${word}`,
    the_sounds_are: "los sonidos de la palabra son: ",
    what_word: "¿Qué palabra forman esos sonidos?",
    drag_the_circles: "Mueva las bolas a las cajas.",
  },
  cognate_intro: (word, cognate) =>
    `"${word}" es <lang xml:lang="es-ES">${cognate}</lang> en español.`,
  cognate_intro_1: (word) =>
    word,
  cognate_intro_2: " es ",
  cognate_intro_3: (cognate) =>
    cognate,
  cognate_intro_4: ` en español.`,
  cognate_now_you_say_it: "Ahora, di tú la palabra en inglés.",
  name: {
    ask_sounds: `Vamos a pronunciar los sonidos que forman este nombre. Di el primer sonido y luego cada uno de los demás sonidos.`,
    intro_1_part_1: `Este es un`,
    intro_1_part_2: `nombre que significa: `,
    intro_2: `es un famoso: `,
    ask_word_1: `¡Genial! Ahora mueve tu ${getSpanishInterface()} sobre cada parte, de principio a fin, y di el nombre.`,
    ask_word_2: "Ahora, pronuncia tú este nombre.",
    correct_1: `Sí, este nombre se pronuncia: `,
    correct_2: "Buen trabajo.", // Edit v1
    struggle_1_part_1: `Este nombre se pronuncia`,
    struggle_1_part_2: `Sigamos leyendo.`,
    fun_fact: `Aquí hay un dato curioso:`,
    lip_sync: "Mira cómo esta persona divide el nombre en varias partes.",
  },
  name_HIGH_GRADE_BAND: {
    ask_sounds: `Vamos a pronunciar los sonidos que forman este nombre. Di el primer sonido y luego cada uno de los demás sonidos.`,
    intro_1_part_1: `Este es un`,
    intro_1_part_2: `nombre que significa: `,
    intro_2: `es un famoso: `,
    ask_word_1: `¡Genial! Ahora mueve tu ${getSpanishInterface()} sobre cada parte, de principio a fin, y di el nombre.`,
    ask_word_2: "Ahora, pronuncia tú este nombre.",
    correct_1: `Sí, este nombre se pronuncia: `,
    correct_2: "Muy bien hecho.", // Edit v1
    struggle_1_part_1: `Este nombre se pronuncia`,
    struggle_1_part_2: `Sigamos leyendo.`,
    fun_fact: `Aquí hay un dato curioso:`,
    lip_sync: "Mira cómo esta persona divide el nombre en varias partes.",
  },
  vocabulary_with_picture: {
    title: "Vocabulario con imágenes",
    intro: (descriptor) => `es una palabra ${descriptor}.`,
    question_text: '¿Qué imagen representa mejor la palabra?',
    correct_response: "¡Correcto!", // Edit v1
    means: 'significa',
    descriptor: ["nueva"],
  },
  vocabulary_with_picture_HIGH_GRADE_BAND: {
    title: "Vocabulario con imágenes",
    intro: (descriptor) => `es una palabra ${descriptor}.`,
    question_text: '¿Qué imagen representa mejor la palabra?',
    correct_response: "¡Correcto!", // Edit v1
    means: 'significa',
    descriptor: ["nueva e importante"],
  },
  sound_seeker: {
    intro: `Vamos a encontrar un sonido en`,
    describe_1: ({ isStart }) => `${isStart ? "comienza" : "termina"} con`,
    yes: "Sí",
    describe_2: ({ isStart }) => `también ${isStart ? "comienza" : "termina"} con`,
    ask_word: ({ isStart }) =>
      `${
        isTouchDevice() ? "toca" : "haz clic en"
      } la imagen que ${isStart ? "comienza" : "termina"} con`,
    correct: `¡Muy bien! Leamos un poco.`,
    no: "No",
    incorrect: ({ isStart }) => `no ${isStart ? "comienza" : "termina"} con`,
    its_this_one: "Es este.",
    like_word: 'como: ',
  },
  prediction_question: {
    intro:
      'De acuerdo. Veamos cuán bien puedes adivinar qué sucede a continuación.<break time="0.5s"/> Piensa en la parte de la historia que hemos leído hasta ahora.',
    correct_response: "Buena predicción, estoy muy orgullosa de ti.",
    expire_right_answer: (answer) => `La respuesta correcta es: ${answer}.`,
    struggle: `Tratar de adivinar lo que sucederá es una parte importante de la lectura. Veamos qué pasa ahora. Sigue leyendo.`,
  },
  prediction_question_MID_GRADE_BAND: {
    intro:
      'Piensa en lo que podría pasar después.<break time="0.5s"/> Toma en cuenta lo que ya leímos.', // Edit v1
    correct_response: "Buena predicción.", // Edit v1
    expire_right_answer: (answer) => `La respuesta correcta es: ${answer}.`,
    struggle: `Tratar de adivinar lo que sucederá es una parte importante de la lectura. Veamos qué pasa ahora. Sigue leyendo.`,
  },
  prediction_question_HIGH_GRADE_BAND: {
    intro:
      'Piensa en lo que podría pasar después.<break time="0.5s"/> Toma en cuenta lo que ya leímos.', // Edit v1
    correct_response: "Buena predicción.", // Edit v1
    expire_right_answer: (answer) => `La respuesta correcta es: ${answer}.`,
    struggle: `Tratar de adivinar lo que sucederá es una parte importante de la lectura. Veamos qué pasa ahora. Sigue leyendo.`,
  },
  sound_out: {
    intro: `Voy a pronunciar los sonidos que forman esta palabra.`,
    ask_sounds: `Ahora es tu turno. Di cada sonido.`,
    ask_word: "¿Qué palabra forman esos sonidos?",
  },
  sound_out_MID_GRADE_BAND: {
    intro: `Voy a pronunciar esta palabra sonido por sonido.`, // Edit v1
    ask_sounds: `Ahora es tu turno. Di cada sonido.`,
    ask_word: "¿Qué palabra forman esos sonidos?",
  },
  sound_out_HIGH_GRADE_BAND: {
    intro: `Voy a pronunciar esta palabra sonido por sonido.`, // Edit v1
    ask_sounds: `Ahora es tu turno. Di cada sonido.`,
    ask_word: "¿Qué palabra forman esos sonidos?",
  },
  letter_flies: {
    intro: `Cuando me oigas decir un sonido, atrapa la mariposa que representa ese sonido. Para eso, ${
      isTouchDevice() ? "toca" : "haz clic en"
    } la mariposa con la letra que representa el sonido. <break time="1s"/> Observa primero cómo lo hago.`,
    your_turn: `Te toca a ti.`,
    catch_butterfly: `Atrapa la mariposa que representa el sonido: `,
    click_on: isTouchDevice() ? "toca" : "haz clic en",
    ask_sound_part_1: `Di el sonido de la letra`,
    ask_sound_part_2: ``,
    struggle: "¡Esa mariposa se está escapando!",
    struggle_MID_GRADE_BAND: "La mariposa se te está yendo.", // Edit v1
    struggle_HIGH_GRADE_BAND: "La mariposa de esa letra se está escapando.", // Edit v1
    correct_1: "Atrapaste la mariposa de esa letra.",
    correct_2: `Así se atrapan las mariposas de las letras.`,
    tutor: {
      intro: "Cuando me oigas decir un sonido, atrapa la mariposa que representa ese sonido. <break time=\"1s\"/> Mira cómo lo hago primero.",
      on_no_click_action_1: `Haz clic en la letra que hace el sonido`,
      on_no_click_action_2: ``,
      struggle: `¡Ay, no! Se escapó la mariposa. No te preocupes, ¡vamos a atrapar más después!`,
      struggle_MID_GRADE_BAND: `¡Ay, no! Se escapó la mariposa. No te preocupes, ¡vamos a atrapar más después!`, // Edit v1
      struggle_HIGH_GRADE_BAND: `¡Ay, no! Se escapó la mariposa. No te preocupes, ¡vamos a atrapar más después!`, // Edit v1
      your_turn_instruction_1: `Ahora es tu turno.`,
      your_turn_instruction_2: `tiene el sonido`, // [word] has the [sound]
      your_turn_instruction_3: `¿Qué letra hace el sonido`,
      your_turn_instruction_4: `?`, // [sound]?
      silent_letter: ({targetGrapheme}) => `<speak><prosody rate="slow">${targetGrapheme}</prosody></speak>`,
      silent_instruction_1: `¿Puedes decir el sonido de la letra`,
      silent_instruction_2: `?`, // ?
      silent_instruction_3: `tiene el sonido`,
      silent_instruction_4: ``, // ?
    },
  },
  GSF: {
    ftue_intro:
      `¡Juguemos a clasificar palabras! Te mostraré tres palabras y tú elegirás una para llenar el blanco. Las palabras de cada fila <break time="0.1s"/> y cada columna <break time="0.1s"/> tienen el mismo sonido inicial o significan algo parecido. Mira cómo se hace.`,
    ftue_intro_HIGH_GRADE_BAND:
      `Vamos a hacer un ejercicio de clasificación. Te mostraré tres palabras y tendrás que elegir cuál completa correctamente el espacio en blanco. Las palabras de cada fila <break time="0.1s"/> y cada columna <break time="0.1s"/> tienen el mismo sonido inicial o significan algo parecido. Observa cómo lo hago primero.`, // Edit v1
    ftue_column_1: `Las palabras de esta columna tienen el mismo sonido inicial. El sonido B <break time="0.1s"/>.`,
    ftue_column_2: `Por lo tanto, las palabras de la segunda columna también tendrán el mismo sonido inicial. El sonido C <break time="0.1s"/>.`,
    ftue_row_1: `Las palabras de esta fila tienen significados parecidos: <break time="0.1s"/> Palabras relacionadas con la comida.`,
    ftue_row_2: `Por lo tanto, las palabras de la segunda fila también tendrán significados parecidos. <break time="0.1s"/> Algo relacionado con Bolsa.`,
    ftue_find_word_1:
      `Tenemos que encontrar una palabra que comience con el sonido C, como Coco, y que esté relacionada con Bolsa.`,
    ftue_find_word_2:
      `Voy a arrastrar la palabra Caja al recuadro vacío porque comienza con el sonido C, como Coco, y sirve para guardar cosas, como Bolsa.`,
    ftue_find_word_2_iPad:
      `Voy a presionar la palabra Caja porque comienza con el sonido C, como Coco, y sirve para guardar cosas, como Bolsa.`,
    ftue_your_turn: "Ahora es tu turno: Encuentra la palabra que falta. Debe tener el sonido inicial de una palabra y un significado parecido al de la otra palabra.",
    non_ftue_intro: "¡Juguemos a clasificar palabras! Encuentra la palabra que falta. Debe tener el sonido inicial de una palabra y un significado parecido al de la otra palabra.",
    one_more: "Vamos a hacerlo una vez más.",
    choose_word: "Elige una palabra para llenar el blanco.",
    correct: ({ correctWord, category, word1, letter, word2 }) =>
      `¡Ya lo tienes! ${correctWord} está en la categoría ${category}, como ${word1}, y comienza con la letra, ${letter}<break time="0.1s"/>, como ${word2}.`,
    great_work: "¡Buen trabajo!",
    scaffolding_1:
      "¡Ups! Esa no es la palabra correcta. Inténtalo de nuevo. Recuerda que debes encontrar la palabra que falta. Debe tener el sonido inicial de una palabra y un significado parecido al de la otra palabra.",
    scaffolding_1_MID_GRADE_BAND:
      "Esa no es la palabra correcta. Inténtalo de nuevo. Recuerda que debes encontrar la palabra que falta. Debe tener el sonido inicial de una palabra y un significado parecido al de la otra palabra.", // Edit v1
    scaffolding_1_HIGH_GRADE_BAND:
      "Esa no es la palabra correcta. Inténtalo de nuevo. Recuerda que debes encontrar la palabra que falta. Debe tener el sonido inicial de una palabra y un significado parecido al de la otra palabra.", // Edit v1
    scaffolding_2: ({ category, word1, letter, word2 }) =>
      `Esa no es la palabra correcta. Busca una palabra que esté en la misma categoría, ${category}, como ${word1}, y que comience con la letra ${letter}<break time="0.1s"/>, como ${word2}.`,
    timeout_1:
      "Elige una palabra y arrástrala al recuadro vacío. Recuerda que tenemos que encontrar la palabra que falta. Debe tener el sonido inicial de una palabra y un significado parecido al de la otra palabra.",
    timeout_2: ({ category, word1, letter, word2 }) =>
      `Busca una palabra que esté en la misma categoría, ${category}, como ${word1}, y que comience con la letra ${letter}<break time="0.1s"/>, como ${word2}.`,
    show_answer: ({ correctWord, category, word1, letter, word2 }) =>
      `La palabra correcta es ${correctWord}. Pertenece a la misma categoría, ${category}, como ${word1}, y comienza con la letra, ${letter}<break time="0.1s"/>, como ${word2}.`,
  },
  HFWDotGrid: {
    ftue_intro: "Voy a decir una palabra. Luego vas a mover un círculo a un recuadro por cada sonido que escuches. Mira cómo lo hago primero. La palabra es: \"cat\".",
    ftue_your_turn: ({ targetWord }) => `Ahora te toca a ti. Cuántos sonidos hay en la palabra: "${targetWord}". Mueve el número correcto de círculos para representar los sonidos de la palabra: "${targetWord}".`,
    ftue_your_turn_iPad: ({ targetWord }) => `Ahora te toca a ti. Cuántos sonidos hay en la palabra: "${targetWord}". Toca un círculo para seleccionarlo y luego un recuadro vacío para moverlo allí. Mueve un círculo por cada sonido de la palabra: "${targetWord}".`,
    non_ftue_intro: ({ targetWord }) => `Trabajemos con la palabra: "${targetWord}". Cuántos sonidos tiene la palabra: "${targetWord}". Mueve el número correcto de círculos para representar los sonidos de la palabra: "${targetWord}".`,
    non_ftue_intro_iPad: ({ targetWord }) => `Trabajemos con la palabra: "${targetWord}". Cuántos sonidos tiene la palabra: "${targetWord}". Toca un círculo para seleccionarlo y luego un recuadro vacío para moverlo allí. Mueve un círculo por cada sonido de la palabra: "${targetWord}".`,
    correct_response: `¡Eso es! Muy bien.`,
    incorrect_response: `No exactamente.`,
    timeout_response: ({ targetWord }) => `¡Tú puedes! Mueve el número correcto de círculos para representar los sonidos de la palabra: "${targetWord}".`,
    timeout_response_iPad: ({ targetWord }) => `¡Tú puedes! Toca un círculo para seleccionarlo y luego un recuadro vacío para moverlo allí. Mueve un círculo por cada sonido de la palabra: "${targetWord}".`,
    timeout_response_MID_GRADE_BAND: ({ targetWord }) => `Mueve el número correcto de círculos para representar los sonidos de la palabra: "${targetWord}".`,
    timeout_response_iPad_MID_GRADE_BAND: ({ targetWord }) => `Toca un círculo para seleccionarlo y luego un recuadro vacío para moverlo allí. Mueve un círculo por cada sonido de la palabra: "${targetWord}".`,
    timeout_response_HIGH_GRADE_BAND: ({ targetWord }) => `Mueve el número correcto de círculos para representar los sonidos de la palabra: "${targetWord}".`,
    timeout_response_iPad_HIGH_GRADE_BAND: ({ targetWord }) => `Toca un círculo para seleccionarlo y luego un recuadro vacío para moverlo allí. Mueve un círculo por cada sonido de la palabra: "${targetWord}".`,
    tap_arrow: `Toca la flecha cuando termines.`,
    has_sounds: ({ targetWord, numPhonemes }) => `"${targetWord}" tiene ${numPhonemes} sonidos.`,
    let_me_show_you: "Déjame mostrarte.",
    great_job: "¡Buen trabajo!",
    neutral_response: "Bien, sigamos leyendo.",
    positive_feedback: "¡Buen trabajo! Sigamos leyendo.",
  },
  say_a_sound: {
    intro: ({ nSounds }) =>
      `Observa la boca de esta persona pronunciando cada uno de los ${nSounds} sonidos que forman esta palabra.`,
    ask_sounds: `Ahora te muestro la letra de cada sonido y tú pronuncias el sonido.`,
    ask_word: "Ahora lee la palabra completa."
  },
  word_display: {
    intro: "Observa y escucha. Vamos a aprender más acerca de esta palabra,",
    ask_sound_part_1: `¿Cuál es el primer sonido en: `,
    ask_sound_part_2: `?`,
    describe_part_1: `De acuerdo: `,
    describe_part_2: `comienza con`,
    continue: `Sigamos leyendo.`,
  },
  up_and_down: {
    intro_1_intervention: `Mira cómo tu colega sube las escaleras mientras digo los sonidos que forman la palabra: `,
    intro_1_tutor: `Ahora vamos a hacer algo diferente. Te daré una palabra y debes decir cada uno de sus sonidos, uno por uno. Al final, debes unirlos para decir la palabra completa. Mira primero cómo lo hago con la palabra:`,
    intro_2: `Ayuda a tu colega a subir las escaleras diciendo los sonidos que forman la palabra:`,
    ask_sounds_intervention: `Ahora, inténtalo tú. Di todos los sonidos que forman la palabra:`,
    ask_sounds_tutor_0: `Ahora es tu turno.`,
    ask_sounds_tutor_1: `La palabra es:`,
    ask_sounds_tutor_2: `Por favor, di uno por uno los sonidos de la palabra:`,
    ask_sounds_tutor_3: ``, // Intentionally blank because of differences in phrasing
    ask_sounds_tutor_image_1: `La palabra es: `,
    ask_sounds_tutor_image_2: `Por favor, di los sonidos de la palabra`,
    ask_sounds_tutor_image_3: `uno por uno. Luego, vuelve a decir la palabra completa: `,
    ask_sounds_tutor_image_4: ``, // Intentionally blank because of differences in phrasing
    ask_blend_intervention: "Combina los sonidos que forman la palabra.",
    ask_blend_tutor: "¿Cual palabra hacen los sonidos?",
    ask_blend_assessment: "Combina los sonidos que forman la palabra.", //TRANSLATE: "You can do it, blend the sounds to say the word."
    correct: `Buen trabajo.`,
    struggle_intro: `La palabra es:`,
    struggle_end: `Leamos un poco más.`,
    prompt_sounds: '¿Puedes decir todos los sonidos en: ',
    prompt_sounds_assessment: '¿Puedes decir todos los sonidos en: ', //TRANSLATE: 'You can do it! Say the sounds in'
    repeat_after_me: `Repite después de mí`,
  },
  rhyming: {
    intro: `Aprendamos sobre esta palabra con unas rimas.`,
    describe: `Nuestra palabra rima con: `,
    ask_word_1: `Lee esta palabra que rima con: `,
    ask_word_2: `Ahora lee tú:`,
    correct: "Ya dominas esta rima.",
    struggle: `Usemos la rima.`,
    rhymes_with: "rima con",
  },
  rhyming_quiz: {
    intro: "Es hora del juego de las rimas.",
    intro_HIGH_GRADE_BAND: "Ahora haremos un ejercicio con rimas.", // Edit v1
    our_word_is: 'Nuestra palabra es: ',
    which_rhymes_with: '¿Cuál de estas palabras rima con: ',
    click_to_choose: () => `${
      isTouchDevice() ? "Toca" : "Haz clic en"
    } para elegir.`,
    you_are_right: 'Respondiste correctamente.',
    no: "No, ",
    doesnt_rhyme_with: "no rima con",
    but: "Pero",
    does: "sí",
    rhymes_with: 'rima con',
    back_to_reading: 'Sigamos leyendo.',
  },
  say_one_sound: {
    intro: "Observa y escucha mientras digo esta palabra",
    describe: ({ position }) =>
      `Voy a decir el ${position} sonido de la palabra: `,
    ask_word: `Ahora es tu turno. Di la palabra`,
    struggle: `Vamos a trabajar en`,
    ask_sound: ({ position }) =>
      `Ahora, di el ${position} sonido de`,
    sound_is: "De acuerdo, el sonido es",
    correct: "Bien hecho.",
    first: "primer",
    last: "último",
  },
  word_investigator: {
    intro: ({ word }) =>
      `Observa esta palabra. Debería tener ${word.length} letras y ${word.length} sonidos. Pero faltan una letra y un sonido. Investiguemos.`,
    describe_1: ({ word }) => `tiene ${word.length} sonidos.`,
    describe_2: ({ word }) =>
      `Pero aquí solo hay ${word.length - 1} sonidos. El sonido`,
    // WordInvestigator appends the word itself (`${describe_3} ${word}.`), so this
    // must stay a plain string. As a function it was interpolated verbatim and the
    // minified source was read aloud (TT-1152).
    describe_3: `Busca la letra que corresponde al sonido que falta en la palabra`,
    missing: "falta.",
    ask_letter: `${
      isTouchDevice() ? "Toca" : "Haz clic en"
    } la letra de arriba que representa el sonido que falta.`,
    correct_1: "¡Correcto! Eres un buen investigador.",
    correct_2: "¡Excelente!",
    struggle: `Ese no es el sonido de la letra que falta.`,
    try_again: `Vamos a intentarlo una vez más.`,
    give_answer_part_1: `La letra que falta es`,
    give_answer_part_2: `Ahora lee la palabra.`,
    inactivity: `Inténtalo. ${
      isTouchDevice() ? "Toca" : "Haz clic en"
    } una letra de arriba que representa el sonido que falta.`,
  },
  give_and_take: {
    time_to_get_goofy: "Practiquemos con juegos de palabras.", // Edit v1
    watch_and_listen: ({ isStart }) => `Observa y escucha mientras digo la ${isStart ? 'primera' : 'última'} parte de esta palabra.`,
    describe: ({ nSounds }) => `Esta parte de la palabra tiene ${nSounds} sonidos.`,
    ask_word_part: "Di esta parte de la palabra conmigo.",
    correct_1: "¡Lo hiciste!",
    correct_2: `Sigamos.`,
    correct_3: "Bien hecho.", // Edit v1
    correct_3_MID_GRADE_BAND: "Muy bien.", // Edit v1
    correct_3_HIGH_GRADE_BAND: "Lo lograste.", // Edit v1
    ok_new_word_is: 'De acuerdo. Nuestra nueva palabra es:',
    thanks: 'Gracias',
    struggle_1: "La parte de la palabra es ",
    struggle_2: "Ahora la palabra está en las casillas. Lee la palabra.",
    this_word_is: 'Esta palabra es:',
    back_to_reading: 'Sigamos leyendo.',
    add_sound: ({ isStart }) =>
      `Ahora voy a añadir la ${isStart ? 'primera' : 'última'} parte de nuestra palabra. El sonido nuevo es`,
    word_is: "Ahora la palabra es",
    makes_word: "Eso forma la palabra",
    ask_sounds: ({ nSounds }) => `Ahora, repite los ${nSounds} sonidos.`,
    ask_word: `Ahora lee la palabra completa.`,
    replace_sound: `Un último paso. Vamos a cambiar uno de los sonidos. Vamos a cambiar el sonido`,
    to: "por",
    ask_sub: "Ahora di la palabra nueva.",
  },
  change_one_part: {
    intro: "Ahora vamos a intercambiar letras. Observa y escucha mientras pronuncio los sonidos que forman esta palabra.",
    intro_HIGH_GRADE_BAND: "Vamos con el ejercicio de intercambiar letras. Observa y escucha mientras pronuncio los sonidos que forman esta palabra.", // Edit v1
    change_one: `Voy a cambiar una letra en esta palabra. Al cambiar la letra, cambiará el sonido y se formará una palabra nueva.`,
    ask_word: "¿Puedes leer esta palabra?",
    ask_word_MID_GRADE_BAND: "Por favor, lee esta palabra.", // Edit v1
    ask_word_HIGH_GRADE_BAND: "Por favor, lee esta palabra.", // Edit v1
    another_swap: `Vamos a cambiar otra letra.`,
    correct: "Buen trabajo.",
    sound_out: `Vamos a pronunciar los sonidos de esta palabra.`,
    good_job: "¡Lo hiciste muy bien!", // Edit v1
    assessment_handle_intro: `Ahora jugaremos un juego de palabras. No empiezas hasta que yo te lo indique.`,
    assessment_handle_intro_say_word: 'Esta palabra es <break time="0.5s"/>',
    assessment_handle_intro_make_change: `Voy a cambiar una letra en esta palabra. Al cambiar la letra, cambiará el sonido y se formará una palabra nueva.`,
    assessment_handle_intro_prompt_to_try_transition: `Cuando las casillas se pongan amarillas, debes decir la palabra nueva.`,
    assessment_handle_intro_prompt_to_try_read: 'La palabra es <break time="0.5s"/>',
    assessment_handle_intro_silence: 'Debes decir <break time="0.5s"/>',
    assessment_handle_silence: `¡Tú puedes! Diga la palabra nueva.`,
    assessment_handle_silence_MID_GRADE_BAND: `Di la palabra nueva.`, // Edit v1
    assessment_handle_silence_HIGH_GRADE_BAND: `Di la palabra nueva.`, // Edit v1
    assessment_handle_first_item_prompt: 'Bien, ahora jugaremos con la palabra <break time="0.5s"/>',
    assessment_handle_first_item_make_change: `Cambiemos una letra`,
    assessment_handle_first_item_prompt_to_read: `Es tu turno. Di la palabra nueva.`,
    assessment_handle_nth_item_prompt: 'Bien, ahora jugaremos con la palabra <break time="0.5s"/>',
    assessment_handle_nth_item_make_change: `Cambiemos una letra`,
    assessment_handle_nth_item_prompt_to_read: `¿Cuál es la palabra?`,
    assessment_handle_item_done_try_another: `Vamos con otras palabras.`,
    assessment_handle_end: `¡Muy bien! Gracias.`,
    end: "¡Gracias!",
    end_with_more_activities: "¡Gracias! Sigamos con las siguientes actividades.",
    tutor_example_intro: "Mira y escucha mientras pronuncio los sonidos de esta palabra.",
    tutor_example_change_one: `Voy a cambiar una letra en esta palabra. Al cambiar la letra, cambiará el sonido y se formará una palabra nueva.`,
    tutor_example_word: 'Esta palabra es <break time="0.5s"/>',
    tutor_example_ask_word: `Ahora inténtalo tú. Lee la palabra nueva.`,
    tutor_try_another_word: `Vamos con otras palabras.`,
    tutor_subsequent_item_instruction: ({word}) => `Esta palabra es <break time="0.5s"/> ${word}`,
    tutor_subsequent_item_change_one: `Cambiemos una letra`,
    tutor_subsequent_ask_word: `Lee la palabra nueva.`,
    tutor_example_intro_FTUE: "Juguemos a intercambiar letras. Observa cómo cambio un sonido por otro para formar una palabra nueva. La palabra es",
    tutor_example_intro_FTUE_HIGH_GRADE_BAND: "Vamos a practicar el intercambio de letras. Observa cómo cambio un sonido por otro para formar una palabra nueva. La palabra es", // Edit v1
    tutor_example_change_one_FTUE: "Ahora cambio el sonido y mira: la palabra nueva es: ",
    tutor_silent_ask_word: `¿Puedes decir los sonidos en la nueva palabra?`,
    tutor_silent_end: `La palabra es`,
    non_ortho: {
      example: {
        we_are_now: `Ahora vamos con el ejercicio de palabras. Espera para hablar hasta que yo te lo indique.`,
        these_boxes_represent: `Estas cajas representan los sonidos de la palabra.`,
        those_sounds_are: `Esos sonidos son: `,
        im_going_to_change: `Voy a cambiar un sonido en la palabra`,
        im_going_to_change_2: `Voy a cambiar el`,
        sound_to_the: `sonido por el`,
        sound_which_will_make: `sonido, y así formamos una palabra nueva.`,
        when_you_see_the_boxes: `Cuando vea que las cajas se vuelven amarillas, debe decir la nueva palabra que hace si cambio el: `,
        in: `en`,
        to_a: `a un`,
      },
      subsequent: {
        now_lets_play_with: `Ahora jugemos con la palabra`,
        these_boxes_represent: `Estas tres cajas representan los tres sonidos en la palabra.`,
        those_sounds_are: `Esos tres sonidos son: `,
        lets_change: `Ahora cambiemos el`,
        sound_to_the: `sonido para el`,
        sound: `sonido`,
      }
    }
  },
  word_scramble: {
    before_we_look_at: 'Antes de echarle un vistazo a: ',
    lets_talk_about: "hablemos sobre",
    sound_out: `Pronunciemos los sonidos que forman esta palabra.`,
    scrambled: "Las letras se desordenaron. Mira cómo ordeno esta palabra.",
    fix_scrambled: `Para arreglar palabras desordenadas, usa tu ${getSpanishInterface()} para arrastrar las letras al lugar correcto.`,
    ask_unscramble: "Mueve las casillas para ordenar la palabra.",
    your_turn: "Es tu turno.",
    ask_word_1: "Lee esta palabra.",
    ask_word_2: "Ahora, lee esta palabra.",
    this_is_our_word: 'Esta es nuestra palabra: ',
    unscrambled: 'en orden',
    lets_do_some_reading: "Leamos un poco.",
    you_got: 'Pusiste las letras de: ',
    back_in_order: 'en orden',
    fantastic_job: 'Hiciste un trabajo fantástico'
  }, /* end intervention library strings */

  syllable_segmentation: {
    ftue_intro:'Cuando encuentres palabras largas mientras lees, puedes dividir la palabra en partes más pequeñas, llamadas sílabas, para ayudarte a leerla.',
    ftue_intro_watch: "Fíjate bien en cómo divido esta palabra.",
    ftue_intro_your_turn: "Ahora es tu turno.",
    ftue_intro_your_turn_resume: "Arrastra las líneas para dividir la palabra y presiona enviar cuando termines.",
    non_ftue_intro: "Divide la palabra arrastrando las líneas y envía tu respuesta.",
    dnd_idle_1: "Arrastra las líneas punteadas para dividir la palabra.",
    dnd_idle_1_MID_GRADE_BAND: "¡Tú puedes! Arrastra las líneas punteadas para dividir la palabra.",
    dnd_idle_1_HIGH_GRADE_BAND: "Coloca las líneas donde corresponde para dividir la palabra.",
    dnd_idle_2: "Mira cómo arrastro las líneas punteadas para dividir la palabra.",
    dnd_wrong: "Déjame ayudarte con esto.",
    dnd_wrong_resume: "Observa cómo coloco las líneas para dividir la palabra.",
    dnd_correct: "Lo lograste.",
    response_into: "¿Cuál es la palabra?",
    response_idle_1: "Di esta palabra en voz alta.",
    response_idle_1_MID_GRADE_BAND: "¡Di esta palabra en voz alta!",
    response_idle_1_HIGH_GRADE_BAND: "Lee esta palabra en voz alta.",
    response_correct: ({word})=>`¡Eso es! Excelente trabajo con: "${word}".`
  },
  syllable_blend_click: {
    non_ftue_intro: "Haz clic en cada sílaba.",
    tap_idle_1: "¡Tú puedes! Toca la sílaba resaltada para escucharla.",
    tap_idle_1_MID_GRADE_BAND: "Toca la sílaba resaltada para escucharla.",
    tap_idle_1_HIGH_GRADE_BAND: "Toca la siguiente sílaba.",
    tap_idle_2: "Déjame ayudarte con esta. Escucha cada sílaba.",
    combine_intro: "Ahora, juntemos las sílabas. Haz clic en este botón.",
    response_intro: "Júntalas todas. ¿Cuál es la palabra completa?",
    response_correct: ({word}) => `¡Sí! Sigamos leyendo.`,
  },
  syllable_decoding: {
    look_intro: "Mira la palabra.",
    listen_intro: "Escucha cada sílaba.",
    say_intro: "Ahora di cada sílaba.",
    blend_intro: "¡Buen trabajo! Ahora unamos las sílabas.",
    blend_intro_quiet: "Ahora unamos las sílabas.",
    read_intro: "Ahora lee la palabra completa.",
    read_correct: ({word}) => `¡Sí! Sigamos leyendo.`,
  },
  phoneme_syllable_word: {
    look_intro: ({word}) => `Mira la palabra: ${word}.`,
    listen_sounds_intro: "Escucha cada sonido.",
    say_sounds_intro: "Ahora di cada sonido.",
    blend_intro: "Ahora une los sonidos en sílabas.",
    say_syllables_intro: "Ahora di cada sílaba.",
    read_intro: "Ahora lee la palabra completa.",
    read_correct: ({word}) => `¡Sí! Sigamos leyendo.`,
  },

  comprehensionPrompt: [
    "Esta puede ser difícil. Haz clic en la respuesta que creas correcta.",
    "¿Cuál respuesta tiene más sentido? Selecciona la mejor.",
  ],
  comprehensionWrongAnswer: [
    "Casi. Inténtalo de nuevo.",
    "Hmm, piénsalo de nuevo.",
    "Sigue intentando."
  ],
  comprehensionWrongAnswer_MID_GRADE_BAND: [
    "¡Vamos, inténtalo de nuevo!", // Edit v1
    "¡Casi! Inténtalo de nuevo.",
    "¡Piénsalo bien e inténtalo otra vez!", // Edit v1
  ],
  comprehensionWrongAnswer_HIGH_GRADE_BAND: [
    "No te rindas, inténtalo otra vez.", // Edit v1
    "Una más, tú puedes.",
    "Piénsalo bien antes de responder.", // Edit v1
  ],
};



export const EN_US_COPY_STRINGS = {
  //INTRODUCTION
  ready_to_start: "Ready to start?",
  lets_do_it: "Let's do it",
  skip_intro_video: "Skip video",
  ready: "Ready",
  set: "Set",
  start_bang: "Go!",
  generative_start: "Go",
  and: "and",
  by: "by",
  or: "or",
  hello: "Hello",
  assigned_amira_intro: (tutorName) => `Your teacher would like for you to read to me. Okay?`,
  assigned_amira_intro_non_verbal: (tutorName) => `Your teacher would like for you to work with me. Okay?`,
  amira_intro: (tutorName) => `I'd like to read with you today.`,
  great_to_see_you: "Great to see you",
  enter: "Enter",
  blank: "blank",

  // Tutor Picker
  select_tutor: "Select Tutor",
  save: "Save",

  //BADGE AWARD NOTIFICATION
  you_earned_badges: [`You've earned badges!`, `Since the last time we’ve read together, you’ve earned badges!`],
  im_awarding_you: ({badgeName}) => `I'm awarding you the ${badgeName} badge!`,
  and: "And...",
  to_see_your_badges: "Let's see what badge you've earned. Now let's celebrate - dance time!",
  to_see_your_badges_early_reader: "Now it's time to celebrate. Let's dance.",
  to_see_your_badges_mature_reader: "Let's see what badge you've earned!",
  you_are_badge_level: ({rewardLevelId}) => `You are a reading ${rewardLevelId}!`,
  badging_speed: "SPEED",
  badging_words: "Words",
  badging_correct: "CORRECT",
  badging_your_reading: "YOUR READING",
  badging_level: "Level",
  badging_next_be: "Next, be a",

  BADGE_TITLE: {
    NUM_SESSIONS: {
      'PAL': "5 Sessions",
      "BUDDY": "10 Sessions",
      "RANGER": "20 Sessions",
      "TITAN": "50 Sessions",
      "GURU": "75 Sessions",
      "WIZARD": "100 Sessions"
    },
    NUM_MINUTES: {
      "BUDDY": "20 Minutes a Week",
      "GURU": "30 Minutes a Week",
    },
    NEW_WCPM_HIGH: {
      'PAL': "10 Words a Minute",
      "BUDDY": "20 Words a Minute",
      "RANGER": "30 Words a Minute",
      "TITAN": "40 Words a Minute",
      "GURU": "60 Words a Minute",
      "WIZARD": "100 Words a Minute",
    },
    SKILLS_SCAFFOLD_GRADUATION: {
      'PAL': "First Skill",
      "GURU": "Graduated Skills",
    },
    NEW_HIGH: {
      "RANGER": "New High",
      "GURU": "New High x2",
      "WIZARD": "New High x3",
    },
    CUSTOM: {
      'PAL': "Custom",
      "BUDDY": "Custom",
      "RANGER": "Custom",
      "TITAN": "Custom",
      "GURU": "Custom",
      "WIZARD": "Custom"
    }
  },


  //STUDENT HISTORY
  you_read_stories_one: "You've read",
  you_read_stories_two: "stories with me and taken",
  you_read_stories_two_MID_GRADE_BAND: "passages with me and taken", // Edit v2
  you_read_stories_two_HIGH_GRADE_BAND: "passages with me and taken", // Edit v2
  you_read_stories_three: "tests.",
  you_usually_read_stats_one: "You usually read",
  you_usually_read_stats_two: "words every minute and get about",
  you_usually_read_stats_three: "percent of them right.",
  enjoy_reading_together: "I really enjoy our time reading together.",
  enjoy_reading_together_MID_GRADE_BAND: "Great to see you work at this.", // Edit v1
  enjoy_reading_together_HIGH_GRADE_BAND: "Great to see you work at this.", // Edit v1
  no_student_history: "We haven't red together yet. I'm looking forward to reading with you. Please come back after you've taken a test.", //Do not change this. Polly will mispronounce "read"
  nice_to_meet_you: "Nice to Meet You!",
  getting_history: "Getting your history",
  how_you_are_doing: "Here's how you're doing",
  progress: {
    stories: `stories`,
    welcome: [
      "Thanks for checking on our progress.",
      "Happy to tell you about your progress.",
      "Great news! We've made a lot of progress together.",
      "Lets show you all that you've accomplished."
    ],
    sessions: ({numberOfStories}) => [
      `So far, our stories red together total ${numberOfStories}.`,
      `Stories red so far is ${numberOfStories} stories.`,
      `Together, we've red ${numberOfStories} stories.`,
    ],
    sessions_estimated: ({numberOfStories}) => [
      `So far, our stories red together is more than ${numberOfStories}.`,
      `Stories red so far is more than ${numberOfStories} stories.`,
      `Together, we've red more than ${numberOfStories} stories.`,
    ],
    badges_earned: [
      `Badges earned: `,
      `Badges received: `,
      `Number of badges is: `,
    ],
    metrics: [
      `Your average reading speed and accuracy are showing on the screen.`,
      `Your reading speed and accuracy are on screen.`
    ],
    praise: [
      `I like reading with you, so lets do it every day.`,
      `I hope we can keep reading together.`,
      `Thanks for being my reading `
    ],
    level: `And here's the best news of all. You are a reading`,
    next: [
      `If you keep reading with me, next up is`,
      `Keep reading, and you'll earn the next level:`,
      `Your next award is`
    ]
  },
  progress_MID_GRADE_BAND: {
    stories: `stories`,
    welcome: [
      "Thanks for checking on our progress.",
      "Happy to tell you about your progress.",
      "Great news! We've made a lot of progress together.",
      "Lets show you all that you've accomplished."
    ],
    sessions: ({numberOfStories}) => [
      `So far, our passages red together total ${numberOfStories}.`, // Edit v2
      `Passages red so far is ${numberOfStories} passages.`, // Edit v2
      `Together, we've red ${numberOfStories} passages.`, // Edit v2
    ],
    sessions_estimated: ({numberOfStories}) => [
      `So far, our passages red together is more than ${numberOfStories}.`, // Edit v2
      `Passages red so far is more than ${numberOfStories} passages.`, // Edit v2
      `Together, we've red more than ${numberOfStories} passages.`, // Edit v2
    ],
    badges_earned: [
      `Badges earned: `,
      `Badges received: `,
      `Number of badges is: `,
    ],
    metrics: [
      `Your average reading speed and accuracy are showing on the screen.`,
      `Your reading speed and accuracy are on screen.`
    ],
    praise: [
      "This reading time's been good. Let's keep it up.",
      "Let's read together again soon.",
      "Thanks for reading with me today.",
    ],
    level: "Now for the best part. You are a reading",
    next: [
      `If you keep reading with me, next up is`,
      `Keep reading, and you'll earn the next level:`,
      `Your next award is`
    ]
  },
  progress_HIGH_GRADE_BAND: {
    stories: `stories`,
    welcome: [
      "Thanks for checking on our progress.",
      "Happy to tell you about your progress.",
      "Great news! We've made a lot of progress together.",
      "Lets show you all that you've accomplished."
    ],
    sessions: ({numberOfStories}) => [
      `So far, our passages red together total ${numberOfStories}.`, // Edit v2
      `Passages red so far is ${numberOfStories} passages.`, // Edit v2
      `Together, we've red ${numberOfStories} passages.`, // Edit v2
    ],
    sessions_estimated: ({numberOfStories}) => [
      `So far, our passages red together is more than ${numberOfStories}.`, // Edit v2
      `Passages red so far is more than ${numberOfStories} passages.`, // Edit v2
      `Together, we've red more than ${numberOfStories} passages.`, // Edit v2
    ],
    badges_earned: [
      `Badges earned: `,
      `Badges received: `,
      `Number of badges is: `,
    ],
    metrics: [
      `Your average reading speed and accuracy are showing on the screen.`,
      `Your reading speed and accuracy are on screen.`
    ],
    praise: [
      "This reading time's been good. Let's keep it up.",
      "Let's read together again soon.",
      "Thanks for reading with me today.",
    ],
    level: "Now for the best part. You are a reading",
    next: [
      `If you keep reading with me, next up is`,
      `Keep reading, and you'll earn the next level:`,
      `Your next award is`
    ]
  },


  //VOICE PICKER OPTIONS
  ive_selected_x_stories: (numStories) => `I've selected ${numStories} stories for you:`,
  ive_selected_x_stories_MID_GRADE_BAND: (numStories) => `I've selected ${numStories} passages for you:`, // Edit v2
  ive_selected_x_stories_HIGH_GRADE_BAND: (numStories) => `I've selected ${numStories} passages for you:`, // Edit v2
  which_story: (readAloud) => `What would you like to ${readAloud ? 'hear' : 'read'}?`,
  which_story_MID_GRADE_BAND: (readAloud) => `What would you like to ${readAloud ? 'hear' : 'read'}?`, // Edit v2
  which_story_HIGH_GRADE_BAND: (readAloud) => `What would you like to ${readAloud ? 'hear' : 'read'}?`, // Edit v2

  back_to_inbox: "Back",
  id_like_you_to_read: "I'd like you to read:",
  click_story_to_start: "Click or say the name of the story when you're ready to start",
  click_story_to_start_MID_GRADE_BAND: "Click or say the name of the passage when you're ready to start", // Edit v2
  click_story_to_start_HIGH_GRADE_BAND: "Click or say the name of the passage when you're ready to start", // Edit v2
  no_stories_speech: "I'm sorry. Something went wrong. There are no stories for you",
  no_stories_speech_MID_GRADE_BAND: "I'm sorry. Something went wrong. There are no passages for you", // Edit v2
  no_stories_speech_HIGH_GRADE_BAND: "I'm sorry. Something went wrong. There are no passages for you", // Edit v2
  no_stories_text: "There are no Stories to Display",
  no_stories_text_MID_GRADE_BAND: "There are no passages to display", // Edit v2
  no_stories_text_HIGH_GRADE_BAND: "There are no passages to display", // Edit v2
  kindergarten: "Kindergarten",
  first_grade: "First Grade",
  second_grade: "Second Grade",
  third_grade: "Third Grade",
  what_grade: "What grade are you in?",
  didnt_understand: "I'm sorry, I didn't understand that.",
  what_activity_today: "What would you like to do today?",
  what_activity_next: "What would you like to do next?",
  take_a_test: "Take a test",
  take_a_test_speech: "take a test",
  // BTS bilingual chooser cards always show both languages regardless of UI locale, so these are fixed labels.
  take_a_test_english: "Take a Test (English)",
  hacer_una_prueba_spanish: "Hacer una prueba (Español)",
  read_a_story: "Read a story",
  read_a_story_MID_GRADE_BAND: "Read a passage", // Edit v2
  read_a_story_HIGH_GRADE_BAND: "Read a passage", // Edit v2
  read_a_story_speech: "read a story to me",
  read_a_story_speech_MID_GRADE_BAND: "read a passage to me", // Edit v2
  read_a_story_speech_HIGH_GRADE_BAND: "read a passage to me", // Edit v2
  read_a_story_in_spanish: "Leer una historia en español",
  read_a_story_in_spanish_MID_GRADE_BAND: "Leer un texto en español", // Edit v1
  read_a_story_in_spanish_HIGH_GRADE_BAND: "Leer un texto en español",
  read_a_story_in_spanish_speech: "léeme una historia en español",
  read_a_story_in_spanish_speech_MID_GRADE_BAND: "léeme un texto en español", // Edit v1
  read_a_story_in_spanish_speech_HIGH_GRADE_BAND: "léeme un texto en español",
  see_progress: "See progress",
  see_progress_speech: "see your progress",
  no_activities_speech: "Your teacher hasn't assigned you any activities.",
  would_you_like: "Would you like to",
  loading: "Loading",

  //ASSESSMENT INSTRUCTIONS
  orf_instructions: "Before you start reading, I have a few instructions for you. <break time=\"1s\"/> I would like you to read this story aloud for me. Read until you reach the end of the story or until I tell you to stop. Try each word, but If you come to a word that you do not know, <break time=\"0.5s\"/> you may skip it <break time=\"0.5s\"/> and read the next word you know. <break time=\"0.25s\"/> I'm going to count down and then you can start reading. Remember to read loud enough for me to hear. Let's get started!",
  orf_instructions_MID_GRADE_BAND: "Before you start reading, I have a few instructions for you. <break time=\"1s\"/> I would like you to read this passage aloud for me. Read until you reach the end of the passage or until I tell you to stop. Try each word, but If you come to a word that you do not know, <break time=\"0.5s\"/> you may skip it <break time=\"0.5s\"/> and read the next word you know. <break time=\"0.25s\"/> I'm going to count down and then you can start reading. Remember to read loud enough for me to hear. Let's get started.", // Edit v2
  orf_instructions_HIGH_GRADE_BAND: "Before you start reading, I have a few instructions for you. <break time=\"1s\"/> I would like you to read this passage aloud for me. Read until you reach the end of the passage or until I tell you to stop. Try each word, but If you come to a word that you do not know, <break time=\"0.5s\"/> you may skip it <break time=\"0.5s\"/> and read the next word you know. <break time=\"0.25s\"/> I'm going to count down and then you can start reading. Remember to read loud enough for me to hear. Let's get started.", // Edit v2
  orf_with_page_navigation_instructions: "Before you start reading, I have a few instructions for you. <break time=\"1s\"/> I would like you to read this story aloud for me. When you reach the end of a page, use the arrow button to move on. Read until you reach the end of the story or until I tell you to stop. Try each word, but If you come to a word that you do not know, <break time=\"0.5s\"/> you may skip it <break time=\"0.5s\"/> and read the next word you know. <break time=\"0.25s\"/> I'm going to count down and then you can start reading. Remember to read loud enough for me to hear. Let's get started!",
  orf_with_page_navigation_instructions_MID_GRADE_BAND: "Before you start reading, I have a few instructions for you. <break time=\"1s\"/> I would like you to read this passage aloud for me. When you reach the end of a page, use the arrow button to move on. Read until you reach the end of the passage or until I tell you to stop. Try each word, but If you come to a word that you do not know, <break time=\"0.5s\"/> you may skip it <break time=\"0.5s\"/> and read the next word you know. <break time=\"0.25s\"/> I'm going to count down and then you can start reading. Remember to read loud enough for me to hear. Let's get started!", // Edit v2
  orf_with_page_navigation_instructions_HIGH_GRADE_BAND: "Before you start reading, I have a few instructions for you. <break time=\"1s\"/> I would like you to read this passage aloud for me. When you reach the end of a page, use the arrow button to move on. Read until you reach the end of the passage or until I tell you to stop. Try each word, but If you come to a word that you do not know, <break time=\"0.5s\"/> you may skip it <break time=\"0.5s\"/> and read the next word you know. <break time=\"0.25s\"/> I'm going to count down and then you can start reading. Remember to read loud enough for me to hear. Let's get started.", // Edit v2
  dyslexia_instructions: "We're going to start off with a few short reading activities. Please wait for me to give you instructions for each part, then I'll listen to you read. Please read loudly and clearly. Let's get started!",
  dyslexia_instructions_non_verbal: "We're going to start off with a few short activities. Please wait for me to give you instructions for each part. Let's get started!",
  nwf_instructions:  "When you don't know a word, you try to sound it out. In the next section we are going to practice that by reading words that aren't real, but could be. For each one, put the different sounds the letters make together to form a complete word.",
  spelling_intro:  "In this section we are going to work on spelling.",
  spelling_idle_letter_click_encouragement: "You can do it. Click the letters to spell your answer. The word is: ",
  spelling_idle_letter_click_encouragement_MID_GRADE_BAND: "Keep going. Click the letters to enter your answer. The word is: ",
  spelling_idle_typing_encouragement: "You can do it. Type your answer in the box. The word is: ",
  spelling_idle_typing_encouragement_MID_GRADE_BAND: "Keep going. Type your answer in the box. The word is: ",
  listening_comprehension_intro:  "My friend is going to read you a story. Let’s listen carefully together. After the story I’ll ask you a few questions.",
  listening_comprehension_overlay_replay_label: "Replay",
  listening_comprehension_overlay_next_label: "Next",
  listening_comprehension_overlay_replay_aria: "Replay instructions",
  listening_comprehension_overlay_next_aria: "Next",
  sentence_builder_idle_encouragement: "Click words to build a sentence.",
  reading_comprehension_intro:  "Great job reading! Now I have a few questions about that story. I'll read the question and each of the answers. Try your best!",
  reading_comprehension_intro_MID_GRADE_BAND:  "Great job reading! Now I have a few questions about that passage. I'll read the question and each of the answers. Try your best!", // Edit v2
  reading_comprehension_intro_HIGH_GRADE_BAND:  "Great job reading. Now I have a few questions about that passage. I'll read the question and each of the answers. Try your best.", // Edit v2
  reading_comprehension_intro_NON_VERBAL_ONE:  "I'm going to show you a text to read. When you're done, I'll ask you some questions.",
  reading_comprehension_intro_NON_VERBAL_TWO:  "Click the button when you're ready to start.",
  reading_comprehension_intro_NON_VERBAL_THREE:  "I’ll read a question and each of the answers.",
  reading_comprehension_intro_NON_VERBAL_FOUR:  "To review the text, press this button.",
  reading_comprehension_intro_NON_VERBAL_FIVE:  "Try your best.",
  vocabulary_screener_intro: "For this next activity, I want you to choose the word that best fits. I will read the words to you.",
  letter_name_and_sounds_intro: "For this next activity, we're going to work with letters.",
  abbreviated_instructions: "Skipping Instructions",
  relevel_instructions: "Ok, let's get ready to read again. Please read loudly and clearly. If you get to a word that you do not know, remember that you may skip it. I'm going to count down and then you can start reading.",
  next_section_transition: "Great job on that part! Now we're going to try something else.",
  please_wait: (tutorName) => `Please wait until ${tutorName} tells you to start.`,
  end_assessment: "END ASSESSMENT",
  try_different_story: "I think we should try switching to a different story.",
  try_different_story_MID_GRADE_BAND: "I think we should try switching to a different passage.", // Edit v2
  try_different_story_HIGH_GRADE_BAND: "I think we should try switching to a different passage.", // Edit v2
  try_different_story_ran: "I think we should try something different.",
  please_keep_reading: "You're not finished yet, please keep reading.",
  lets_move_on: "Lets move on.",

  // Inactivity modal and Next button reminder
  inactivity_modal_alert: "Are you still here?",
  inactivity_modal_explanation: "Tap OK to keep reading!",
  inactivity_modal_voice_over: "You seem to be idle for a while. Tap OK to continue reading.",
  inactivity_modal_button: "OK",
  next_button_reminder: "Remember to click the next button to move on.",

  // ASSESSMENT - Word-part deletion
  word_part_deletion: {
    intro_instruction_1: "We're going to say some mystery words to Spot. I'm going to say a long word, and then give you a part of that word you should not say.",
    intro_instruction_2: ({word, omit, target}) => `For example, I would tell you to say: "${word}", without saying ${omit}. You would then say: "${target}". Can you say, "${word}", without saying ${omit}.`,
    intro_end: "Great!  Spot will bark when he hears you.",
    actual_instruction: ({word, omit}) => `Please say the word: "${word}", without ${omit}.`,
    prompt_to_try: ({word, omit}) => `You can do it, please say: "${word}" without ${omit}.`,
    end: "Thank you!",
    end_with_more_activities: "Thank you! Let's move on to the next set of activities.",
  },
  word_part_deletion_HIGH_GRADE_BAND: {
    intro_instruction_1: "We're going to say some mystery words to Spot. I'm going to say a long word, and then give you a part of that word you should not say.",
    intro_instruction_2: ({word, omit, target}) => `For example, I would tell you to say: "${word}", without saying ${omit}. You would then say: "${target}". Can you say, "${word}", without saying ${omit}.`,
    intro_end: "Great!  Spot will bark when he hears you.",
    actual_instruction: ({word, omit}) => `Please say the word: "${word}", without ${omit}.`,
    prompt_to_try: ({word, omit}) => `You can do it, please say: "${word}" without ${omit}.`,
    end: "Thank you!",
    end_with_more_activities: "Thank you! Let's move on to the next set of activities.",
  },

  // ASSESSMENT - Nonsense word repetition
  // Hardcoded "my friend" to handle spanish.  Edit if "modelName" ever is not "my friend"
  nonsense_word_repetition: {
    "intro": ({modelName, nonsenseWord}) => `Here’s my friend! My friend is going to say some words that aren’t real words like: "${nonsenseWord}".`,
    "intro_prompt": ({modelName, nonsenseWord}) => `Please say: "${nonsenseWord}", to my friend.`,
    "intro_end": ({modelName, nonsenseWord}) => `Great job! Now my friend is going to say some more words that aren’t real words. You should say them back to my friend and me, just like you repeated: "${nonsenseWord}". If you want my friend to say the words again, just press the big replay button.`,
    "prompt_to_try": ({modelName}) => `If you want my friend to repeat the word, press the replay button.`,
    "subsequent_prompt_to_try": "You can do it! Give it a try.",
    "subsequent_end": "Got it!",
    "end": "Got it, thanks!",
    "end_with_more_activities": "Thank you!  Let's move on to the next set of activities.",
  },
  nonsense_word_repetition_HIGH_GRADE_BAND: {
    "intro": ({modelName, nonsenseWord}) => `Here’s my friend! My friend is going to say some words that aren’t real words like: "${nonsenseWord}".`,
    "intro_prompt": ({modelName, nonsenseWord}) => `Please say: "${nonsenseWord}", to my friend.`,
    "intro_end": ({modelName, nonsenseWord}) => `Great job! Now my friend is going to say some more words that aren’t real words. You should say them back to my friend and me, just like you repeated: "${nonsenseWord}". If you want my friend to say the words again, just press the big replay button.`,
    "prompt_to_try": ({modelName}) => `If you want my friend to repeat the word, press the replay button.`,
    "subsequent_prompt_to_try": "You can do it! Give it a try.",
    "subsequent_end": "Got it!",
    "end": "Got it, thanks!",
    "end_with_more_activities": "Thank you!  Let's move on to the next set of activities.",
  },

  //INTERVENTIONS
  keep_reading: "Let's keep reading!",
  try_again: "let's try that again",
  start_reading: "Please start reading",
  wordAttackPrompt: [
    "Do you know the first sound in this word?",
    "Can you sound out this word?",
  ],

  //STATUS STRINGS
  onFire: [
    "Really good job.",
    "Great job!",
    "Amazing job!",
    "Excellent job reading!", // Edit v1
    "You're a rock star.",
    "Super job, reading.",
    "Way to go.",
  ],
  onFire_MID_GRADE_BAND: [
    "Really good job.",
    "Great job!",
    "Amazing job!",
    "You're making great progress!", // Edit v1
    "You're doing awesome.", // Edit v1
    "You red that really well.", // Edit v1
    "Well done.", // Edit v1
  ],
  onFire_HIGH_GRADE_BAND: [
    "Really good job.",
    "Great job!",
    "Amazing job!",
    "You're making great progress!", // Edit v1
    "You're doing awesome.", // Edit v1
    "You red that really well.", // Edit v1
    "Well done.", // Edit v1
  ],
  goodAccuracy: [
    "Way to go -- you got a lot of words correct.",
    "Very few mistakes.  Nice work.",
    "You red a lot of hard words correctly.", //Do not change this. Polly will mispronounce "read",
    "Nice reading today.",
    "That was nice reading.",
  ],
  goodAccuracy_MID_GRADE_BAND: [
    "Way to go -- you got a lot of words correct.",
    "Very few mistakes.  Nice work.",
    "You red a lot of challenging words correctly.", // Edit v1
    "Nice reading today.",
    "That was nice reading.",
  ],
  goodAccuracy_HIGH_GRADE_BAND: [
    "Keep it up -- you got a lot of words correct.", // Edit v1
    "Very few mistakes.  Nice work.",
    "You red a lot of challenging words correctly.", // Edit v1
    "Nice reading today.",
    "That was nice reading.",
  ],
  workOn: [
    "We'll work on doing better.",
    "I know you can improve.",
    "Keep working hard.",
    "We can do even better next time.",
    "If we keep reading together, you'll get even more correct.",
    "Let's keep at this.",
    "I hope you will keep reading with me.",
    "Keep at it.",
  ],
  workOn_MID_GRADE_BAND: [
    "We'll work on doing better.",
    "I know you can improve.",
    "Keep working hard.",
    "We can do even better next time.",
    "Let's keep working on this together.", // Edit v1
    "Let's keep at this.",
    "Let's keep practicing together.", // Edit v1
    "Keep at it.",
  ],
  workOn_HIGH_GRADE_BAND: [
    "We'll work on doing better.",
    "Keep practicing, and you'll keep improving.", // Edit v1
    "Keep working hard.",
    "Let's see if we can do even better next time.", // Edit v1
    "Let's keep working on this together.", // Edit v1
    "Let's keep at this.",
    "Let's keep practicing together.", // Edit v1
    "Keep at it.",
  ],
  goodSpeed: [
    "Appreciate how you red through this story.", //Do not change this. Polly will mispronounce "read"
    "You red at a good pace today.", //Do not change this. Polly will mispronounce "read"
    "Nice job reading so smoothly.",
    "Nice reading today.",
    "That was nice reading.",
  ],
  noImprovement: [
    "I had so much fun reading this story with you!",
    "What a great story! I hope you enjoyed it.",
    "That story was so much fun!",
    "Wow, we finished the whole story! You were awesome at staying focused.",
    "Great reading together! You did a super job staying with the story to the end.",
    "Way to go -- you got a lot of words right.",
    "Keep working hard.",
    "Nice job reading. If we keep reading together, you'll get even more right.",
    "Good work. We can do even better next time.,",
    "Way to go. If we keep reading together, you'll get even more right.",
    "Nice reading. Let's keep at this.",
  ],
  noImprovement_MID_GRADE_BAND: [
    "I appreciate you reading with me.", // Edit v1
    "Hope you enjoyed the passage.", // Edit v2
    "We finished the whole passage. Great job staying focused.", // Edit v2
    "Good reading today. You followed through to the end.", // Edit v1
    "Way to go -- you got a lot of words right.",
    "Keep working hard.",
    "Nice job reading. The more we read together, the better you'll get.", // Edit v1
    "Good work. Let's see how far we can go next time.", // Edit v1
    "Nice reading. Let's keep this up so you get even better at it.", // Edit v1
    "Nice reading. Let's keep at this.",
  ],
  noImprovement_HIGH_GRADE_BAND: [
    "I appreciate you reading with me.", // Edit v1
    "Hope you enjoyed the passage.", // Edit v2
    "That's the full passage! You remained focused.", // Edit v2
    "Good reading today. You followed through to the end.", // Edit v1
    "Keep it up -- you got a lot of words right.", // Edit v1
    "Keep working hard.",
    "Nice job reading. The more we read together, the better you'll get.", // Edit v1
    "Good work. Let's see how far we can go next time.", // Edit v1
    "Nice reading. Let's keep this up so you get even better at it.", // Edit v1
    "Nice reading. Let's keep at this.",
  ],
  wrapUp: [
    "Thanks for reading together.",
    "Thank you for reading to me.",
    "I enjoyed reading together.",
    "Appreciate you spending time reading.",
    "Thank you.",
    "Great reading with you.",
    "Appreciate you reading with me.",
  ],
  wrapUp_MID_GRADE_BAND: [
    "Thanks for reading with me.", // Edit v1
    "I appreciate your effort today.", // Edit v1
    "Good reading session today.", // Edit v1
    "Appreciate you spending time reading.",
    "Thank you.",
    "Great reading with you.",
    "I appreciate you reading that passage with me.", // Edit v2
  ],
  wrapUp_HIGH_GRADE_BAND: [
    "Thanks for reading with me.", // Edit v1
    "I appreciate your effort today.", // Edit v1
    "Good reading session today.", // Edit v1
    "Appreciate you spending time reading.",
    "Thank you.",
    "Great reading with you.",
    "I appreciate you reading that passage with me.", // Edit v2
  ],
  keep_up: "Keep up the good work!",
  status_stats_speech_front: (wcpm, accuracy) => `You red ${wcpm} words each minute and got ${accuracy} percent of them right`, //Do not change this. Polly will mispronounce "read"
  stats_compare_improved: (wpmDifference, accuracyDifference) => `That's ${wpmDifference} words faster and ${accuracyDifference} percent more accurate than usual.`,
  stats_compare_improved_wpm: (wpmDifference) => `That's ${wpmDifference} words faster than usual.`,
  stats_compare_improved_accuracy: (accuracyDifference) => `That's ${accuracyDifference} percent more words right than usual.`,
  times_up_speech: "Your time is up. Great work!",
  finished_story_speech: "Great work, you finished the story!",
  finished_story_speech_MID_GRADE_BAND: "Great work, you finished the passage.", // Edit v2
  finished_story_speech_HIGH_GRADE_BAND: "Great work, you finished the passage.", // Edit v2
  finished_assessment_speech: "Great work, you are all finished.  I'm going to log you out so you can move on with your day. Thank you.",
  all_done_speech: "Great work! You're all done.",
  another_textset_story_speech: "Great work! There's more to this story. Let's keep going!",
  another_story_speech: "Great work! Let's keep going!",
  stats_speech_one: "You red",  //Do not change this. Polly will mispronounce "read"
  stats_speech_two: "words each minute and got",
  stats_speech_three: "percent of them right.",
  no_historic_data_speech: [
    "I had so much fun reading this story with you!",
    "What a great story! I hope you enjoyed it.",
    "That story was so much fun!",
    "Wow, we finished the whole story! You were awesome at staying focused.",
    "Great reading together! You did a super job staying with the story to the end.",
  ],
  no_historic_data_speech_MID_GRADE_BAND: [
    "Appreciate you reading with me.", // Edit v1
    "I hope you enjoyed the passage.", // Edit v2
    "We finished the whole passage. Great job staying focused.", // Edit v2
    "Good work staying focused and completing the passage.", // Edit v2
  ],
  no_historic_data_speech_HIGH_GRADE_BAND: [
    "Appreciate you reading with me.", // Edit v1
    "I hope you enjoyed the passage.", // Edit v2
    "That's the full passage! You remained focused.", // Edit v2
    "Good reading today. You followed through to the end.", // Edit v1
  ],
  stats_speech_compare_improved: (wpmDifference) => `You red this story ${wpmDifference} words faster than usual and with higher accuracy.`, //Do not change this. Polly will mispronounce "read"
  stats_speech_compare_improved_both_one: "Wow - that was some of your best reading!",
  stats_speech_compare_improved_both_one_HIGH_GRADE_BAND: "That was some of your best reading!", // Edit v1
  stats_speech_compare_improved_both_two: "You red faster and with higher accuracy than usual!",
  stats_speech_compare_improved_wpm_one: "You red this story faster than usual!", //Do not change this. Polly will mispronounce "read"
  stats_speech_compare_improved_wpm_one_MID_GRADE_BAND: "You red this story faster than usual!", //Do not change this. Polly will mispronounce "read"
  stats_speech_compare_improved_wpm_one_HIGH_GRADE_BAND: "You red this story faster than usual!", //Do not change this. Polly will mispronounce "read"
  stats_speech_compare_improved_accuracy_one: "You red this story with higher accuracy than usual!", //Do not change this. Polly will mispronounce "read"
  even_better: "We can work together to get even better.",
  work_to_get_better: "We can work together to get better.",
  times_up: "Time's Up",
  finished_story: "You Finished the Story",
  finished_story_MID_GRADE_BAND: "You finished the passage", // Edit v2
  finished_story_HIGH_GRADE_BAND: "You finished the passage", // Edit v2
  all_done: "All Done",
  speed: "Speed",
  average_speed: "Average Speed",
  correct: "Correct",
  average_correct: "Average Correct",
  great_work: "Great work!",
  please_close_tab: "You can now close this tab.",
  finished: "Finished",
  read_more: "Read More",

  //GENERAL DISPLAY
  example: "example",
  go_to_the: "Go To The",
  tracking_report: "Tracking Report",
  recommendation_intervention: "Catch Up",
  recommendation_catch_up: "On Track",
  recommendation_at_above: "At/Above",
  print_letters: "Print Letters",

  //ERROR MODALS
  audio_error_speech: "I'm having trouble understanding you, so we'll have to start over. Please make sure that your microphone is unmuted and that you are speaking loudly and clearly. When you are ready to try again, click the 'restart' button",
  error_speech: "I'm sorry, an error has occured so we'll have to start over. When you are ready to try again, click the 'sign out and restart' button",
  mute_error_speech: "It looks like your microphone is muted. Please unmute and then click 'I'm Ready' to continue",
  disabled_error_speech: "It looks like you have not enabled access to your microphone. Please enable your microphone and then click the button to continue",
  kid_error_speech: "Oops! We need help! Please ask your teacher to come over and help us.",
  kid_error_speech_MID_GRADE_BAND: "Please ask your teacher to come over and help us.", // Edit v1
  kid_error_speech_HIGH_GRADE_BAND: "Please ask your teacher to come over and help us.", // Edit v1
  audio_input_changed_error_title: "Raise your hand",
  audio_input_changed_error_text: "It looks like your microphone or audio input device has changed. This might happen if you unplugged headphones or switched audio devices. Please restart your session to continue.",
  audio_input_changed_error_speech: "I noticed that your microphone or audio device has changed. This might happen if you unplugged headphones or switched audio devices. We'll need to restart to continue working together.",
  help_link: "help link",
  webgl_error_text: "Error code 0015: \nI'm sorry, but something went wrong and I will need to try again.",
  error_text: "I'm sorry, but something went wrong and I will need to restart your assessment.",
  mute_error_text: "It looks like you're on mute. Please make sure that your microphone is unmuted, then click the button below to begin",
  audio_error_text: "I can't understand you. Please make sure that your microphone is unmuted and that you are speaking loudly and clearly",
  compat_error_text: "It looks like your browser is not supported, or is out of date. Please update to Chrome 70 or higher in order to read.",
  compat_error_text_os: "It looks like your operating system is not supported, or is out of date.",
  compat_error_no_spanish: "Your browser does not support Spanish practice. Hit 'I'm ready' to go back to the main menu",
  compat_error_text_mobile: "It looks like your mobile device is not supported.",
  compat_error_text_ipad: "It looks like your browser is not supported, or is out of date. Please use Safari and update to iOS 16 or higher in order to read.",
  product_access_disabled_text: "No active subscriptions were found for your school. Please ask your teacher for help.",
  product_access_disabled_title: (brandedAppName) => `${brandedAppName} isn't available right now`,
  disabled_error_continue: "It looks like you have not enabled access to your microphone. Please enable microphone access for this web page to continue.",
  disabled_error_text: "It looks like you have not enabled access to your microphone. Please log back in and select Allow when asked for the microphone.",
  blank_error_text: "I'm having trouble listening to your speech. Please hit Logout to refresh your browser. You will need to log in again",
  ipad_error_text: (brandedAppName) => `${brandedAppName} for Teachers is not currently supported on iPad. To continue as a student, click OK and then log back in with student credentials.`,
  raise_your_hand: "Raise Your Hand",
  logout: "Logout",
  im_ready: "I'm ready",
  restart: "Restart",
  logout_and_restart: "Logout and restart",
  browser_not_supported: "Your browser is not supported",
  os_not_supported: "Your operating system is not supported",
  mobile_not_supported: "Your mobile device is not support",
  wait_modal_text: "Please wait while I save your reading",
  scoring_wait_modal_text: "Please wait while I save your scored activity",
  wait_modal_title: "Saving",
  no_stories_for_you: "You've read all the stories that are available to you. Please raise your hand and ask the teacher to help.",
  no_stories_for_you_MID_GRADE_BAND: "You've read all the passages that are available to you. Please raise your hand and ask the teacher to help.", // Edit v2
  no_stories_for_you_HIGH_GRADE_BAND: "You've read all the passages that are available to you. Please raise your hand and ask the teacher to help.", // Edit v2
  no_stories_for_you_text: "All the stories for this screening window have been taken. The student can continue to read non-assessment stories",
  no_stories_for_you_text_MID_GRADE_BAND: "All the passages for this screening window have been taken. The student can continue to read non-assessment passages", // Edit v2
  no_stories_for_you_text_HIGH_GRADE_BAND: "All the passages for this screening window have been taken. The student can continue to read non-assessment passages", // Edit v2
  all_stories_taken: "No available stories",
  all_stories_taken_MID_GRADE_BAND: "No available passages", // Edit v2
  all_stories_taken_HIGH_GRADE_BAND: "No available passages", // Edit v2
  play_video_with_button: "Please click on the play button to start.",
  error_fetching_stories: "Oops! I couldn't find your stories. Press the big green button to try again.",
  error_fetching_stories_MID_GRADE_BAND: "I couldn't find your passages. Press the big green button to try again.", // Edit v2
  error_fetching_stories_HIGH_GRADE_BAND: "I couldn't find your passages. Press the big green button to try again.", // Edit v2
  error_fetching_stories_rec_code: "Error code 0001: We're having trouble retrieving your stories. Please try again or contact support for further help.",
  error_fetching_stories_rec_code_MID_GRADE_BAND: "Error code 0001: We're having trouble retrieving your passages. Please try again or contact support for further help.", // Edit v2
  error_fetching_stories_rec_code_HIGH_GRADE_BAND: "Error code 0001: We're having trouble retrieving your passages. Please try again or contact support for further help.", // Edit v2
  error_fetching_stories_story_code: "Error code 0002: We're having trouble retrieving your stories. Please try again or contact support for further help.",
  error_fetching_stories_story_code_MID_GRADE_BAND: "Error code 0002: We're having trouble retrieving your passages. Please try again or contact support for further help.", // Edit v2
  error_fetching_stories_story_code_HIGH_GRADE_BAND: "Error code 0002: We're having trouble retrieving your passages. Please try again or contact support for further help.", // Edit v2
  error_fetching_stories_put_activity_code: "Error code 0003: We're having trouble retrieving your stories. Please try again or contact support for further help.",
  error_fetching_stories_put_activity_code_MID_GRADE_BAND: "Error code 0003: We're having trouble retrieving your passages. Please try again or contact support for further help.", // Edit v2
  error_fetching_stories_put_activity_code_HIGH_GRADE_BAND: "Error code 0003: We're having trouble retrieving your passages. Please try again or contact support for further help.", // Edit v2
  error_fetching_stories_title: "Oops! I couldn't find your stories.",
  error_fetching_stories_title_MID_GRADE_BAND: "I couldn't find your passages.", // Edit v2
  error_fetching_stories_title_HIGH_GRADE_BAND: "I couldn't find your passages.", // Edit v2
  try_again: "Try Again",
  paused_from_bad_network_speech: "Uh oh. There is a problem with your internet. Let me try to reconnect.",
  paused_from_bad_network_speech_MID_GRADE_BAND: "There is a problem with your internet. Let me try to reconnect.", // Edit v1
  paused_from_bad_network_speech_HIGH_GRADE_BAND: "There is a problem with your internet. Let me try to reconnect.", // Edit v1
  paused_from_bad_network_title: "Oops!",
  paused_from_bad_network_title_MID_GRADE_BAND: "Hmm", // Edit v1
  paused_from_bad_network_title_HIGH_GRADE_BAND: "Hmm", // Edit v1
  resume_from_bad_network_ready: "Ready!",
  resume_from_bad_network_speech: "We're back! Press go when you are ready and start reading.",
  resume_from_bad_network_continue: "Go",
  retry_pause_network_speech: "I'm still having trouble. Let's count to three and then try again.",
  retry_pause_network_speech_MID_GRADE_BAND: "I'm still having trouble. Let's pause a few seconds and then try again.", // Edit v1
  retry_pause_network_speech_HIGH_GRADE_BAND: "I'm still having trouble. Let's pause a few seconds and then try again.", // Edit v1
  retry_pause_network_title: "Uh oh!",
  retry_pause_network_title_MID_GRADE_BAND: "Hmm, something isn't quite right.", // Edit v1
  retry_pause_network_title_HIGH_GRADE_BAND: "Hmm, something isn't quite right.", // Edit v1
  retry_pause_network_button: "Try Again",
  critical_network_speech: "Please ask your teacher to come over and help us.",
  critical_network_speech_MID_GRADE_BAND: "Please ask your teacher to come over and help us.", // Edit v1
  critical_network_speech_HIGH_GRADE_BAND: "Please ask your teacher to come over and help us.", // Edit v1

  //TUTOR
  read_with_me_mode: "Let's read some of this story together. I will read each phrase to you. After I have finished, you should try the phrase on your own.",
  end_read_with_me_mode: "Ok, I'll read one more phrase for you. After this phrase, you can read to me.",
  intervention_strings: EN_US_INTERVENTION_STRINGS,
  student_checks: {
    intro: "You're finally here!",
    intro_triple_yes: "Yes yes yes yes yes!!!!",
    intro_excited: "I’m so excited!",
    intro_continued: 'I feel like I`ve been waiting FOREVER to read with you!',
    intro_finished: (tutorName) => `Hi, I'm ${tutorName}!`,
    intro_microphone: "Sooo, how’s it going?<break time=\"1.5s\"/>",
    welcome_back: "Welcome back!",
    wait_while_i_check: "Please wait while I check a few things.",
    microphone_access_granted: "Let’s get this reading party started!?<break time=\"1s\"/>",
    intro_amira_moveon_one: "Okay okay. You’re not just here to dance – you’re here to READ!",
    intro_amira_moveon_two: "I’m your personal reading tutor",
    intro_amira_moveon_three: "and I'm going to help you become a great reader! And guess what!?",
    intro_screen: "This screen will let us read ANY story we want, and I’ll help you along the way.<break time=\".5s\"/>",
    intro_assessment_mode: "Let's make sure I can hear you so we can start!",
    volume_check_intro_one: "We’re going to meet all kinds of great characters.", // glance
    volume_check_intro_two: "But don’t just take my word for it, I’ll show you! This...",
    check_on_spot_intro: "is one of my favorite story characters!", // mid range point at 3 o clock
    check_on_spot_intro_part_two: "Let’s check out my buddy Spot!<break time=\"1s\"/>",
    oh_hes_sleeping: "Oh! He’s sleeping", // wide eyed animation
    lets_wake_him_up_one: "Let’s wake him up! We need to talk loud enough for him to hear us,", //pointdown
    talk_loud_enough: "We need to talk loud enough for him to hear us,",
    lets_wake_him_up_two: "but not SO loud that we scare him",
    lets_wake_him_up_three: "When this microphone turns green",
    wake_up_spot: "say Wake up, Spot!",
    he_heard_you: "He heard you! That’s exactly how you should do it when you’re reading with me. ", // excited //waves
    he_heard_you_loud: "Okay, I think Spot can hear you.",
    he_heard_you_two: "Well Spot, it’s been real, later!",
    he_heard_you_two_generative: "Well Spot, it’s been real... See ya later!",
    finish_asr_check: "Perfect! This is gonna be great!", // thumbs up
    handle_too_soft_one: "Hmm....He couldn't hear you, when the microphone turns green, say it again louder, \"Wake up, Spot\" <break time=\"1.5s\"/>",
    handle_too_soft_second_round: "Err, he still couldn't hear you! <break time=\"1.5s\"/>",
    handle_too_soft_second_round_two: "Is the microphone in front of your mouth? Can you make sure it is?<break time=\"1.5s\"/>",
    handle_too_soft_second_round_three: "Are you speaking in a loud, proud voice?",
    handle_too_soft_second_round_four: "Try to wake him up again.",
    handle_too_loud_one: "Whoa! We don't want to scare him! <break time=\"1.5s\"/>",
    handle_too_loud_two: "Is the microphone TOUCHING your mouth? Can you move it away a little bit?<break time=\"1.5s\"/>",
    handle_too_loud_three: "Now speaking a little bit softer, say Wake up, Spot! <break time=\"1.5s\"/>",
    handle_no_audio_one: "uhhh, I couldn't hear you! If you're using a headset, try pressing the button on your cord to unmute.<break time=\"2s\"/>",
    handle_no_audio_part_two: "when the microphone turns green, in a loud, proud voice",
    handle_no_audio_two: "I still can't hear you. Let's try one more time.<break time=\"1s\"/>",
    handle_get_teacher: "Please ask your teacher to come over and help us. Please raise your hand.",
    handle_get_teacher_two: "Please ask your teacher to come over and help us.",
    teacher_modal_landing: "Thanks for coming to help. I can't hear the student. Let's go through a few quick steps to help me hear your student clearly.",
    teacher_modal_default_retry_patter: "Okay, please make sure your student speaks with a clear voice. Please let the student try again.",
    teacher_modal_retry_return_1: "Okay, please make sure your student puts the microphone at the same distance as you and speaks with a clear voice. Please let the student try again.",
    teacher_mode_volume_welcome_one: "Thanks for coming to help. I can't hear the student reading. Can we see if I can hear you, please say, \"Wake up, Spot\"",
    teacher_mode_volume_success_one: "Great! I can hear you. Can you please make sure the student is close to the microphone and using a clear voice.",
    teacher_mode_volume_student_retry: "Please let the student try again.",
    teacher_mode_volume_success_but_loud_one: "It still sounds loud on my end. Can you talk quieter or adjust the volume on the microphone and have the student try again?",
    teacher_mode_volume_failure_one: "Oh no! I can't quite hear you. Let's check this article to make sure we have everything set-up in the best possible way. This might take a few steps.",
    network_ping_error: "You're finally here! I’m so excited! Um...looks like there's a problem with the Internet.",
    return_user_wake_up_prompt: "Can you wake up my buddy, Spot? <break time=\"1s\"/>",
    return_user_talk_loud_enough: "We need you to talk loud enough to wake him up.",
    student_hardware_denied: "Hmm, sounds like there's a problem with the microphone.",
    student_hardware_denied_two: "Please ask your teacher to come over and help us. Please raise your hand.<break time=\"1s\"/>",
    student_images_blocked: "Hmm, it looks like pictures are turned off in your browser, so you can't see me!<break time=\"1s\"/>",
    student_hardware_prompt_intro: "Ah! I almost forgot! You have to turn your MICROPHONE on so I can hear you.",
    student_hardware_prompt_initial: "Just tap 'Allow' and we can get started!",
    student_hardware_prompt: "You can do it! Tap Allow so we can start!",
    student_hardware_prompt_two: "Are you still there? Tap the button that says Allow.",
    student_hardware_manually_fixed: "Thanks! Just close down and restart. See you in a minute.",
    prompt_ios_device_mic_modal_error: "Nope. Tap the button on the right that says allow",
    prompt_ios_device_mic_modal_success: "Tap it again, one more time",
    prompt_ios_device_mic_modal_got_it: "you got it!",
    student_asr_on_screen_text: "",
    student_asr_initial_prompt: "Go ahead and say -- It's time to read now!",
    student_asr_reminder_one: "I didn't hear you, please say -- It's time to read now.",
    student_asr_reminder_two: "Can you try again? Speak into the microphone and say, \"It's time to read now\"",
    student_asr_reminder_three: "I still can't hear anything. Can you please say, \"It's time to read now\".",
    student_asr_get_teacher: "Please ask your teacher to come over and help us. Please raise your hand.",
    teacher_mode_asr_initial_prompt_one: "Thanks for coming to help. I can't hear the student reading. Can we see if I can hear you?",
    teacher_mode_asr_initial_prompt_two: "Can you please say, \"It's time to read now\"",
    teacher_mode_asr_reminder_one: "I couldn't hear you. Can you try again? When the microphone turns green say, \"It's time to read now.\"",
    teacher_mode_asr_success: "Great! It sounds like I can hear you.",
    teacher_mode_asr_failure_flagging_prompt_one: "Do you have trouble understanding this student's speech?",
    teacher_mode_asr_failure_flagging_prompt_yes_one: "I understand. I will make some adjustments for this particular student. Please make sure they have a quiet space and the microphone close to their mouth.",
    teacher_mode_asr_failure_flagging_prompt_no_one: "Okay- please make sure your student puts the microphone close to their mouth and speaks with a clear voice.",
    teacher_mode_asr_failure_high_bgn_one: "I am hearing a lot of background noise. Please help the student find a quieter space. Also, remind them to use a loud and clear voice into the microphone.",
    teacher_mode_asr_failure_none_worked_one: "Oh no! I can't quite hear you. Let's check this article to make sure we have everything set-up in the best possible way. This might take a few steps.",
    teacher_mode_asr_mic_check: "Let's make sure the audio input is correct before testing the microphone.",
  },
  student_checks_MID_GRADE_BAND: {
    intro: "You're here!",
    intro_triple_yes: "Fantastic.",
    intro_excited: "I'm so excited!",
    intro_continued: "I've been waiting to read with you.",
    intro_finished: (tutorName) => `Hi, I'm ${tutorName}!`,
    intro_microphone: "How are you doing today?<break time=\"1.5s\"/>",
    welcome_back: "Welcome back!",
    wait_while_i_check: "Before we jump in, I need to check a few things.",
    microphone_access_granted: "Let's start practicing together.<break time=\"1s\"/>",
    intro_amira_moveon_one: "and explore some new passages.",
    intro_amira_moveon_two: "I’m your personal reading tutor",
    intro_amira_moveon_three: "and I'm here to help you become an even better reader.",
    intro_screen: "You'll get to read a variety of passages on this screen, and I'll help you along the way.<break time=\".5s\"/>",
    intro_assessment_mode: "Let's make sure I can hear you.",
    volume_check_intro_one: "We'll meet some interesting characters in our reading.",
    volume_check_intro_two: "I can show you what I mean.",
    check_on_spot_intro: "My favorite character happens to be a real one - Spot!",
    check_on_spot_intro_part_two: "Let's see what he is up to.<break time=\"1s\"/>",
    oh_hes_sleeping: "Oh, he's resting right now.",
    lets_wake_him_up_one: "Let's wake him up. We need to talk loud enough for him to hear us.",
    talk_loud_enough: "We need to talk loud enough for him to hear us,",
    lets_wake_him_up_two: "but not so loud that we startle him.",
    lets_wake_him_up_three: "When this microphone turns green",
    wake_up_spot: "say Wake up, Spot!",
    he_heard_you: "Nice! That's the kind of volume I need when you read with me.", // excited //waves
    he_heard_you_loud: "Okay, I think Spot can hear you.",
    he_heard_you_two: "Thanks, Spot - we'll catch you later.",
    he_heard_you_two_generative: "Thanks, Spot - we'll catch you later.",
    finish_asr_check: "Awesome. Let's get going!", // thumbs up
    handle_too_soft_one: 'I don\'t think Spot heard you. When the microphone turns green, say \'Wake up, Spot!\' louder this time.',
    handle_too_soft_second_round: 'Err, he still couldn\'t hear you! <break time="1.5s"/>',
    handle_too_soft_second_round_two: "Is the microphone in a good position?",
    handle_too_soft_second_round_three: "Can you speak a little louder?",
    handle_too_soft_second_round_four: "Try to wake him up again.",
    handle_too_loud_one: 'Whoa. That might have been too loud for him.',
    handle_too_loud_two: "Is the microphone in a good position?<break time=\"1.5s\"/>",
    handle_too_loud_three: 'Now speaking a little bit softer, say Wake up, Spot! <break time="1.5s"/>',
    handle_no_audio_one: "uhhh, I couldn't hear you! If you're using a headset, try pressing the button on your cord to unmute.<break time=\"2s\"/>",
    handle_no_audio_part_two: "when the microphone turns green, in a loud, proud voice",
    handle_no_audio_two: "I still can't hear you. Let's try one more time.<break time=\"1s\"/>",
    handle_get_teacher: "Something's not working. Please ask your teacher to come over and help us.",
    handle_get_teacher_two: "This isn't quite working yet. Please ask your teacher to come over and help us.",
    teacher_modal_landing: "Thanks for coming to help. I can't hear the student. Let's go through a few quick steps to help me hear your student clearly.",
    teacher_modal_default_retry_patter: "Okay, please make sure your student speaks with a clear voice. Please let the student try again.",
    teacher_modal_retry_return_1: "Okay, please make sure your student puts the microphone at the same distance as you and speaks with a clear voice. Please let the student try again.",
    teacher_mode_volume_welcome_one: 'Thanks for coming to help. I can\'t hear the student reading. Can we see if I can hear you, please say, "Wake up, Spot"',
    teacher_mode_volume_success_one: "Great! I can hear you. Can you please make sure the student is close to the microphone and using a clear voice.",
    teacher_mode_volume_student_retry: "Please let the student try again.",
    teacher_mode_volume_success_but_loud_one: "It still sounds loud on my end. Can you talk quieter or adjust the volume on the microphone and have the student try again?",
    teacher_mode_volume_failure_one: "I can't quite hear you. Let's check this article to make sure we have everything set-up in the best possible way. This might take a few steps.",
    network_ping_error: "You're here - but looks like there's a problem with the Internet.",
    return_user_wake_up_prompt: "Can you help me wake up, Spot?<break time=\"1s\"/>",
    return_user_talk_loud_enough: "We need you to talk loud enough to wake him up.",
    student_hardware_denied: "Hmm, sounds like there's a problem with the microphone.",
    student_hardware_denied_two: 'Please ask your teacher to come over and help us. Please raise your hand.<break time="1s"/>',
    student_images_blocked: "It looks like images are turned off in your browser, so you can't see me.<break time=\"1s\"/>",
    student_hardware_prompt_intro: "Check if your microphone is on, please.",
    student_hardware_prompt_initial: "Just tap 'Allow' and we can get started!",
    student_hardware_prompt: "Tap allow so I can hear you.",
    student_hardware_prompt_two: "Are you still there? Tap the button that says Allow.",
    student_hardware_manually_fixed: "Thanks! Just close down and restart. See you in a minute.",
    prompt_ios_device_mic_modal_error: "Try again. Look for the Allow button.",
    prompt_ios_device_mic_modal_success: "Tap it again, one more time",
    prompt_ios_device_mic_modal_got_it: "you got it!",
    student_asr_on_screen_text: "It's time to read now.",
    student_asr_initial_prompt: "Now say - It's time to read now!",
    student_asr_reminder_one: "I didn't hear you, please say -- It's time to read now.",
    student_asr_reminder_two: 'Can you try again? Speak into the microphone and say, "It\'s time to read now"',
    student_asr_reminder_three: "I still can't hear anything. Can you please say, \"It's time to read now\".",
    student_asr_get_teacher: "Please ask your teacher to come over and help us.",
    teacher_mode_asr_initial_prompt_one: "Thanks for coming to help. I can't hear the student reading. Can we see if I can hear you?",
    teacher_mode_asr_initial_prompt_two: 'Can you please say, "It\'s time to read now"',
    teacher_mode_asr_reminder_one: "I couldn't hear you. Can you try again? When the microphone turns green say, \"It's time to read now.\"",
    teacher_mode_asr_success: "Great! It sounds like I can hear you.",
    teacher_mode_asr_failure_flagging_prompt_one: "Do you have trouble understanding this student's speech?",
    teacher_mode_asr_failure_flagging_prompt_yes_one: "I understand. I will make some adjustments for this particular student. Please make sure they have a quiet space and the microphone close to their mouth.",
    teacher_mode_asr_failure_flagging_prompt_no_one: "Okay- please make sure your student puts the microphone close to their mouth and speaks with a clear voice.",
    teacher_mode_asr_failure_high_bgn_one: "I am hearing a lot of background noise. Please help the student find a quieter space. Also, remind them to use a loud and clear voice into the microphone. ",
    teacher_mode_asr_failure_none_worked_one: "I can't quite hear you. Let's check this article to make sure we have everything set-up in the best possible way. This might take a few steps.",
  },
  student_checks_HIGH_GRADE_BAND: {
    intro: "You made it!",
    intro_triple_yes: "Great to see you.",
    intro_excited: "I'm glad you're here.",
    intro_continued: "I've been looking forward to reading with you.",
    intro_finished: (tutorName) => `Hi, I'm ${tutorName}!`,
    intro_microphone: "How are you doing today?<break time=\"1.5s\"/>",
    welcome_back: "Welcome back.",
    wait_while_i_check: "Before we jump in, I need to check a few things.",
    microphone_access_granted: '',
    intro_amira_moveon_one: "",
    intro_amira_moveon_two: "I’m your personal reading tutor",
    intro_amira_moveon_three: "and I'm here to help you develop your reading skills.",
    intro_screen: "You'll get to read a passage on this screen, and I'll guide you as we go.<break time=\".5s\"/>",
    intro_assessment_mode: "Let's make sure your microphone is working.",
    volume_check_intro_one: "",
    volume_check_intro_two: "",
    check_on_spot_intro: "",
    check_on_spot_intro_part_two: "",
    oh_hes_sleeping: "",
    lets_wake_him_up_one: "But first, let's make sure your voice comes through clearly,",
    talk_loud_enough: "Let's make sure your voice comes through clearly,",
    lets_wake_him_up_two: "",
    lets_wake_him_up_three: "When the microphone turns green, go ahead and say",
    wake_up_spot: "testing, one, two, three.",
    he_heard_you: "Loud and clear. That's the volume I need when you read with me.",
    he_heard_you_loud: "",
    he_heard_you_two: "Thanks - you're good to go.",
    he_heard_you_two_generative: "Thanks - you're good to go.",
    finish_asr_check: "Great, let's do this.",
    handle_too_soft_one: "I couldn't hear you. When the microphone turns green, say 'Testing, one, two, three' more loudly this time.",
    handle_too_soft_second_round: '',
    handle_too_soft_second_round_two: 'Check that your microphone is positionied properly.<break time="1.5s"/>',
    handle_too_soft_second_round_three: "Can you speak a little louder?",
    handle_too_soft_second_round_four: "",
    handle_too_loud_one: "That might have beeen a bit too loud.<break time=\"1.5s\"/>",
    handle_too_loud_two: "Check that your microphone is positioned properly.<break time=\"1.5s\"/>",
    handle_too_loud_three: "Now speaking a bit softer, say 'testing, one, two, three.'<break time=\"1.5s\"/>",
    handle_no_audio_one: "uhhh, I couldn't hear you! If you're using a headset, try pressing the button on your cord to unmute.<break time=\"2s\"/>",
    handle_no_audio_part_two: "when the microphone turns green, in a clear, loud voice",
    handle_no_audio_two: "I still can't hear you. Let's try one more time.<break time=\"1s\"/>",
    handle_get_teacher: "Something's not working. Please ask your teacher to come over and help us.",
    handle_get_teacher_two: "This isn't quite working yet. Please ask your teacher to come over and help us.",
    teacher_modal_landing: "Thanks for coming to help. I can't hear the student. Let's go through a few quick steps to help me hear your student clearly.",
    teacher_modal_default_retry_patter: "Okay, please make sure your student speaks with a clear voice. Please let the student try again.",
    teacher_modal_retry_return_1: "Okay, please make sure your student puts the microphone at the same distance as you and speaks with a clear voice. Please let the student try again.",
    teacher_mode_volume_welcome_one: 'Thanks for coming to help. I can\'t hear the student reading. Can we see if I can hear you, please say, "Testing, one, two, three"',
    teacher_mode_volume_success_one: "Great! I can hear you. Can you please make sure the student is close to the microphone and using a clear voice.",
    teacher_mode_volume_student_retry: "Please let the student try again.",
    teacher_mode_volume_success_but_loud_one: "It still sounds loud on my end. Can you talk quieter or adjust the volume on the microphone and have the student try again?",
    teacher_mode_volume_failure_one: "I can't quite hear you. Let's check this article to make sure we have everything set-up in the best possible way. This might take a few steps.",
    network_ping_error: "You're here - but looks like there's a problem with the Internet.",
    return_user_wake_up_prompt: "We need your voice to come through clearly.",
    return_user_talk_loud_enough: "",
    student_hardware_denied: "Hmm, sounds like there's a problem with the microphone.",
    student_hardware_denied_two: "Please ask your teacher to come over and help us.<break time=\"1s\"/>",
    student_images_blocked: "It looks like images are turned off in your browser, so you can't see me.<break time=\"1s\"/>",
    student_hardware_prompt_intro: "Check if your microphone is on, please.",
    student_hardware_prompt_initial: "Just tap 'Allow' and we can get started!",
    student_hardware_prompt: "Tap allow and we can begin.",
    student_hardware_prompt_two: "Are you still there? Tap the button that says: 'Allow'.",
    student_hardware_manually_fixed: "Thanks! Just close down and restart. See you in a minute.",
    prompt_ios_device_mic_modal_error: "Try again. Look for the 'Allow' button.",
    prompt_ios_device_mic_modal_success: "Tap it again, one more time",
    prompt_ios_device_mic_modal_got_it: "you got it!",
    student_asr_on_screen_text: "It's time to read now.",
    student_asr_initial_prompt: "Now say -- It's time to read now!",
    student_asr_reminder_one: "I didn't hear you, please say -- It's time to read now.",
    student_asr_reminder_two: 'Can you try again? Speak into the microphone and say, "It\'s time to read now".',
    student_asr_reminder_three: "I still can't hear anything. Can you please say, \"It's time to read now\".",
    student_asr_get_teacher: "Please ask your teacher to come over and help us.",
    teacher_mode_asr_initial_prompt_one: "Thanks for coming to help. I can't hear the student reading. Can we see if I can hear you?",
    teacher_mode_asr_initial_prompt_two: 'Can you please say, "It\'s time to read now"',
    teacher_mode_asr_reminder_one: "I couldn't hear you. Can you try again? When the microphone turns green say, \"It's time to read now.\"",
    teacher_mode_asr_success: "Great! It sounds like I can hear you.",
    teacher_mode_asr_failure_flagging_prompt_one:
      "Do you have trouble understanding this student's speech?",
    teacher_mode_asr_failure_flagging_prompt_yes_one:
      "I understand. I will make some adjustments for this particular student. Please make sure they have a quiet space and the microphone close to their mouth.",
    teacher_mode_asr_failure_flagging_prompt_no_one:
      "Okay- please make sure your student puts the microphone close to their mouth and speaks with a clear voice.",
    teacher_mode_asr_failure_high_bgn_one:
      "I am hearing a lot of background noise. Please help the student find a quieter space. Also, remind them to use a loud and clear voice into the microphone.",
    teacher_mode_asr_failure_none_worked_one:
      "I can't quite hear you. Let's check this article to make sure we have everything set-up in the best possible way. This might take a few steps.",
  },
  student_raise_hand: {
    title: "Please get your teacher. I can't hear you.",
    try_again: "Try again?",
    teacher_troubleshoot: "Teacher Troubleshoot",
    troubleshoot_title: "CHECK MICROPHONE",
    troubleshoot_instruction: "There's a problem with your student's microphone.",
    troubleshoot_tip_unmute: "•  Ensure the device or headset is unmuted",
    troubleshoot_tip_correct_mic: "•  Check that the correct microphone is enabled",
    troubleshoot_tip_volume: "•  Make sure the microphone volume is set to around 50%",
    troubleshoot_article_label: "Useful Article — ",
    troubleshoot_article_link_text: "How To: Always Enable The Microphone",
    troubleshoot_restart_text: "Please restart after trying these steps.",
    mic_muted_teacher_instructions: "Please get your teacher. There's a problem with your microphone.",
    restart_button: "Restart",
  },
  // Comprehension Dialogue (Interaction Component)
  interactions: {
    FTUE: {
      displayPrompt: "What is the main thing you learned from the story?",
      displayPrompt_MID_GRADE_BAND: "What is the main thing you learned from the passage?", // Edit v1
      displayPrompt_HIGH_GRADE_BAND: "What is the main thing you learned from the passage?", // Edit v1
      // Each step
      start: "I'm going to ask you a question about what you’ve read.",
      microhpone: "You can answer by speaking into your microphone.",
      microphone2: "When the microphone icon looks like this, you'll know I'm listening.",
      text: "You can answer by typing into this box.",
      timer: "The timer will show you how much time you have left to answer.",
      repeatButton: "If you want me to repeat the question, use the speaker button.",
      excerptsButton: "If you want to see the text again, use the passage button.",
      hintButton: "If you’re not sure how to answer, use the hint button and I can help you.", // Edit v2
      submit: "When you're done answering, use the share button to hear what I think.", // Edit v1
      ready: "Are you ready to give it a try? Ok, here’s my question...",
      ready_MID_GRADE_BAND: "Are you ready? Ok, here’s my question...", // Edit v1
      ready_HIGH_GRADE_BAND: "Are you ready? Ok, here’s my question...", // Edit v1
    },
    DEFAULT_RESPONSES: [
      "Thanks for your thoughts on this.", // Edit v2
                        "Thanks for your thoughts on this!",
      "Appreciate you providing your thoughts.",
                        "Appreciate you providing your thoughts.",
      "Thank you for your response!",
                        "Thank you for your response!",
    ],
    DEFAULT_RESPONSES_MID_GRADE_BAND: [
      "Thanks for your thoughts on this.", // Edit v1
      "Appreciate you providing your thoughts.", // Edit v1
      "Thank you for your response.", // Edit v1
    ],
    DEFAULT_RESPONSES_HIGH_GRADE_BAND: [
      "Thanks for your thoughts on this.", // Edit v1
      "Appreciate you providing your thoughts.", // Edit v1
      "Thank you for your response.", // Edit v1
    ],
    NO_INPUT_VOICE_PROMPT:  "Oops! I didn't hear you. Let's try again. I'm going to ask you a question and when the microphone turns green, speak with a loud, prod voice to answer!",
    NO_INPUT_VOICE_PROMPT_MID_GRADE_BAND: "I didn't hear you. Let's try again. I'm going to ask you a question and when the microphone turns green, speak with a loud, proud voice to answer.", // Edit v2
    NO_INPUT_VOICE_PROMPT_HIGH_GRADE_BAND: "I didn't hear you. Let's try again. I'm going to ask you a question and when the microphone turns green, speak with a loud voice to answer.", // Edit v2
    NO_INPUT_TEXT_PROMPT: "Oops! Let's try again.  I'm going to ask you a question and when I am done, please type your answer in the text box.",
    NO_INPUT_TEXT_PROMPT_MID_GRADE_BAND: "Let's try again.  I'm going to ask you a question and when I am done, please type your answer in the text box.", // Edit v1
    NO_INPUT_TEXT_PROMPT_HIGH_GRADE_BAND: "Let's try again.  I'm going to ask you a question and when I am done, please type your answer in the text box.", // Edit v1
    NO_INPUT_FINAL_SUBMISSION_RESPONSE: "Thanks for the contribution.",
    TIME_STALLS: ["Hmm...", "Thinking...", "One moment...", "Let's see...",],
  },
  // Cursor-Free Tutor FTUE
  cursor_free_ftue: {
    intro: "Wow! Your reading skills are next level! I'm going to change things up to suit your abilities.",
    lets_go: "I will be here if you need any help, okay? Let's go!",
    next_button_explanation: "If I'm having trouble hearing you, this button will appear. Click it to let me know you're done reading. Make sure you read the whole phrase before clicking it.",
    automatic_progression: "If I can hear you clearly, we'll move on to the next phrase automatically.",
    no_cursor_explanation: "I'm going to stop underlining the words. Read at your own pace.",
    post_assess_intro: "We're going to read together. Here's how it works.",
    post_assess_no_cursor: "Read at your own pace.",
    demo_phrase_1: "Like all fish, sharks breathe through slits called gills. To breathe, a shark must move.",
    demo_phrase_2: "So if a shark is unable to swim, it will quickly die. When most people think about sharks, they see teeth.",
  },
  // Tap-to-Read Tutor FTUE
  tap_to_read_ftue: {
    intro: "Something went wrong with your device or internet. I'm going to make some adjustments to help this go more smoothly.",
    how_it_works: "Here's how it will work...",
    read_underlined: "Read the underlined word...",
    tap_next: "...then tap the next word to keep reading.",
    next_button_explanation: "When you get to the end of the phrase you'll see a big green next button. Click that button to go to the next phrase.",
    lets_go: "I will be here if you need any help, okay? Let's go!",
    demo_phrase_1: "Like all fish, sharks breathe through slits called gills.",
  },
  retell: { // Lower grade band
      introduction: "My friend is going to tell you a story. I won't hear the story. After they tell you the story, I will ask you to tell me the story.",
      after_video_prompt: "Do you want to listen to the story again before you tell me the story?  If you want to hear the story again, tap the white 'Replay' button.  If you are ready to tell me the story, tap the green 'Next' button.",
      dialog_instructions: "I didn't hear the story. Can you tell me the story you just heard? Please tell as much detail as you can. When you're done, tap the green arrow.",
      submit_confirmation: "Thanks for telling me about the story!",
      what_happened_prompt: "What happened in the story?"
  },
  retell_MID_GRADE_BAND: { // Mid grade band
    introduction: "My friend is going to read a passage to you. I won't hear the passage. After you hear it, I will ask you to tell me what happened.",
    after_video_prompt: "Do you want to listen to the passage again before you retell it to me?  If you want to hear it again, tap the white 'Replay' button.  If you're ready to retell the passage, tap the green 'Next' button.",
    dialog_instructions: "I didn't hear the passage. Can you tell me what happened? Try to include as much detail as you can. When you're done, tap the green arrow.",
    submit_confirmation: "Thanks for telling me about the passage.",
    what_happened_prompt: "What happened in the passage?"
  },
  retell_HIGH_GRADE_BAND: { // high grade band
    introduction: "My friend is going to read a passage to you. I won't hear the passage. After you hear it, I will ask you to tell me what happened.",
    after_video_prompt: "Do you want to listen to the passage again before you retell it to me?  If you want to hear it again, tap the white 'Replay' button.  If you're ready to retell the passage, tap the green 'Next' button.",
    dialog_instructions: "I didn't hear the passage. Can you tell me what happened? Try to include as much detail as you can. When you're done, tap the green arrow.",
    submit_confirmation: "Thanks for telling me about the passage.",
    what_happened_prompt: "What happened in the passage?"
  },
  freeAnswer: { // Lower grade band
    submit_confirmation: "Thanks for telling me!"
  },
  freeAnswer_MID_GRADE_BAND: { // Mid grade band
    submit_confirmation: "Thanks for your answer."
  },
  freeAnswer_HIGH_GRADE_BAND: { // high grade band
    submit_confirmation: "Thanks for your answer."
  },
  blendingSelection: { // Same for all grade bands
    introduction: "You are going to see some pictures. I will say their names.",
    introduce_video: "After I say the names of the pictures, my friend in the video will say the sounds in one of those names.",
    select_picture_instructions: "You put the sounds together and decide which picture my friend said. You'll tap on the correct picture to choose it.",
    your_turn: "Now it's your turn.",
    your_turn_instructions: "Choose a picture for the word you make by blending these sounds together.",
    idle_encouragement_1: "You can do it. Choose a picture for the word you make by blending these sounds together.",
    idle_encouragement_2: "Tap the green arrow when you're ready for the next word.",
    idle_timeout_message: "Let's move on."
  }
}

export const ES_MX_COPY_STRINGS = {
  //INTRODUCTION
  ready_to_start: "¿Comenzamos?",
  lets_do_it: "¡Vamos!",
  skip_intro_video: "Saltar el video",
  ready: "En sus marcas",
  set: "listos",
  start_bang: "¡fuera!",
  generative_start: "¡fuera!",
  generative_start_HIGH_GRADE_BAND: "fuera", // Edit v1
  and: "y",
  by: "por",
  or: "o",
  hello: "Hola",
  assigned_amira_intro: (tutorName) => `Tu maestro quiere que leas conmigo. ¿Listo?`,
  assigned_amira_intro_non_verbal: (tutorName) => `Tu maestro quiere que trabajemos juntos. ¿Listo?`,
  amira_intro: (tutorName) => `Me gustaría leer contigo hoy`,
  great_to_see_you: "¡Qué bueno verte!",
  enter: "Intro",
  blank: "en blanco",

   // Tutor Picker
   select_tutor: "Selecciona un tutor", 
   save: "Guardar", 

  //BADGE AWARD NOTIFICATION
  you_earned_badges: [`¡Has ganado insignias!`, `Desde la última vez que leímos, ¡has ganado insignias!`],
  im_awarding_you: ({badgeName}) => `¡Ganaste la insignia ${badgeName}!`,
  and: "Y...",
  to_see_your_badges: "Veamos qué insignia ganaste. Ahora a celebrar... ¡hora de bailar!",
  to_see_your_badges_early_reader: "¡Es hora de celebrar! ¡A bailar!",
  to_see_your_badges_mature_reader: "¡Veamos qué insignia ganaste!",
  you_are_badge_level: ({rewardLevelId}) => `¡Estás leyendo como un ${rewardLevelId}!`,
  badging_speed: "VELOCIDAD",
  badging_words: "Palabras",
  badging_correct: "CORRECTO",
  badging_your_reading: "TU LECTURA",
  badging_level: "Nivel",
  badging_next_be: "Ahora, conviértete en un",
  BADGE_TITLE: {
    NUM_SESSIONS: {
      'PAL': "5 sesiones",
      "BUDDY": "10 sesiones",
      "RANGER": "20 sesiones",
      "TITAN": "50 sesiones",
      "GURU": "75 sesiones",
      "WIZARD": "100 sesiones"
    },
    NUM_MINUTES: {
      "BUDDY": "20 minutos por semana",
      "GURU": "30 minutos por semana",
    },
    NEW_WCPM_HIGH: {
      'PAL': "10 palabras por minuto",
      "BUDDY": "20 palabras por minuto",
      "RANGER": "30 palabras por minuto",
      "TITAN": "40 palabras por minuto",
      "GURU": "60 palabras por minuto",
      "WIZARD": "100 palabras por minuto",
    },
    SKILLS_SCAFFOLD_GRADUATION: {
      'PAL': "Primera habilidad",
      "GURU": "Habilidades dominadas",
    },
    NEW_HIGH: {
      "RANGER": "Nuevo récord de puntuación",
      "GURU": "Nuevo récord de puntuación x2",
      "WIZARD": "Nuevo récord de puntuación x3",
    },
    CUSTOM: {
      'PAL': "Personalizada",
      "BUDDY": "Personalizada",
      "RANGER": "Personalizada",
      "TITAN": "Personalizada",
      "GURU": "Personalizada",
      "WIZARD": "Personalizada"
    }
  },

  //STUDENT HISTORY
  you_read_stories: (numberOfStories, numberOfTests) => `¡Leíste ${numberOfStories} cuentos y completaste ${numberOfTests} pruebas!`,
  you_read_stories_MID_GRADE_BAND: (numberOfStories, numberOfTests) => `Has leído ${numberOfStories} textos conmigo y también has completado ${numberOfTests} pruebas.`, // Edit v1
  you_read_stories_HIGH_GRADE_BAND: (numberOfStories, numberOfTests) => `Has leído ${numberOfStories} textos conmigo y también has completado ${numberOfTests} pruebas.`, // Edit v1
  you_usually_read_stats: (avgWPM, avgAccuracy) => `¡Lees ${avgWPM} palabras por minuto y pronuncias muy bien!`,
  no_student_history: "Todavía no he leído contigo, pero tengo muchas ganas de hacerlo. Regresa después de tomar una prueba.",
  nice_to_meet_you: "¡Me alegra conocerte!",
  getting_history: "Estoy buscando tu historial",
  how_you_are_doing: "Mira tus resultados",
  enjoy_reading_together: "Me encanta leer contigo.",
  enjoy_reading_together_MID_GRADE_BAND: "¡Me alegra ver tu esfuerzo!", // Edit v1
  enjoy_reading_together_MIHIGHRADE_BAND: "¡Me alegra ver tu esfuerzo!", // Edit v1

  progress: {
    stories: `historias`,
    welcome: [
      "¡Mira todo lo que hemos hecho!",
      "¡Mira cuánto has avanzado!",
      "¡Buenas noticias! ¡Hemos avanzado mucho!",
      "Te mostraré todo lo que has logrado."
    ],
    sessions: ({numberOfStories}) => [
      `¡Hemos leído ${numberOfStories} historias juntos!`,
      `¡Hemos leído ${numberOfStories} historias!`,
      `Hemos leído ${numberOfStories}.`,
    ],
    sessions_estimated: ({numberOfStories}) => [
      `¡Hemos leído más de ${numberOfStories} historias!`,
      `¡Hemos leído más de ${numberOfStories} historias!`,
      `Hemos leído más de ${numberOfStories} historias.`,
    ],
    badges_earned: [
      `Insignias ganadas:`,
      `Insignias recibidas:`,
      `El número de insignias es`,
    ],
    metrics: [
      `Tu velocidad y precisión de lectura.`,
      `La pantalla muestra tu velocidad y precisión de lectura.`
    ],
    praise: [
      `Me encanta leer contigo. ¡Ojalá pudiéramos leer juntos todos los días!`,
      `Espero que sigamos leyendo juntos.`,
      `Gracias por ser mi`
    ],
    level: `Y aquí está la mejor parte, eres un`,
    next: [
      `Si sigues leyendo conmigo, llegarás al nivel`,
      `Sigue leyendo y llegarás al siguiente nivel:`,
      `Tu próximo premio es`
    ]
  },
  progress_MID_GRADE_BAND: { // Edit v1
    stories: `historias`,
    welcome: [
      "Veamos cuánto hemos avanzado.",
      "Mira todo lo que has avanzado.",
      "¡Buenas noticias! Hemos avanzado mucho.",
      "Te mostraré todo lo que has logrado."
    ],
    sessions: ({numberOfStories}) => [
      `Hasta ahora hemos leído ${numberOfStories} textos.`,
      `Hasta ahora hemos leído ${numberOfStories} textos.`,
      `Hemos leído ${numberOfStories}.`,
    ],
    sessions_estimated: ({numberOfStories}) => [
      `Hasta ahora hemos leído más de ${numberOfStories} textos.`,
      `Hasta el momento hemos leído más de ${numberOfStories} textos.`,
      `Hemos leído más de ${numberOfStories} textos.`,
    ],
    badges_earned: [
      `Insignias ganadas:`,
      `Insignias recibidas:`,
      `El número de insignias es`,
    ],
    metrics: [
      `La pantalla muestra tu velocidad y precisión promedio de lectura.`,
      `La pantalla muestra tu velocidad y precisión de lectura.`
    ],
    praise: [
      "¡Esta sesión estuvo muy bien! Sigamos así.",
      "Nos vemos pronto para seguir leyendo juntos.",
      "Gracias por leer conmigo hoy.",
    ],
    level: "Y aquí viene lo mejor: eres un",
    next: [
      `Si sigues leyendo conmigo, llegarás al nivel`,
      `Sigue leyendo y llegarás al siguiente nivel:`,
      `Tu próximo premio es`
    ]
  },
  progress_HIGH_GRADE_BAND: {
    stories: `historias`,
    welcome: [
      "Veamos cuánto hemos avanzado.",
      "Mira todo lo que has avanzado.",
      "¡Buenas noticias! Hemos avanzado mucho.",
      "Te mostraré todo lo que has logrado."
    ],
    sessions: ({numberOfStories}) => [
      `Hasta ahora hemos leído ${numberOfStories} textos.`,
      `Hasta ahora hemos leído ${numberOfStories} textos.`,
      `Hemos leído ${numberOfStories}.`,
    ],
    sessions_estimated: ({numberOfStories}) => [
      `Hasta ahora hemos leído más de ${numberOfStories} textos.`,
      `Hasta el momento hemos leído más de ${numberOfStories} textos.`,
      `Hemos leído más de ${numberOfStories} textos.`,
    ],
    badges_earned: [
      `Insignias ganadas:`,
      `Insignias recibidas:`,
      `El número de insignias es`,
    ],
    metrics: [
      `La pantalla muestra tu velocidad y precisión promedio de lectura.`,
      `La pantalla muestra tu velocidad y precisión de lectura.`
    ],
    praise: [
      "¡Esta sesión estuvo muy bien! Sigamos así.",
      "Nos vemos pronto para seguir leyendo juntos.",
      "Gracias por leer conmigo hoy.",
    ],
    level: "Y aquí viene lo mejor: eres un",
    next: [
      `Si sigues leyendo conmigo, llegarás al nivel`,
      `Sigue leyendo y llegarás al siguiente nivel:`,
      `Tu próximo premio es`
    ]
  },

  //VOICE PICKER OPTIONS
  ive_selected_x_stories: (numStories) => `He seleccionado ${numStories} cuentos para ti:`,
  ive_selected_x_stories_MID_GRADE_BAND: (numStories) => `He seleccionado ${numStories} textos para ti:`, // Edit v1
  ive_selected_x_stories_HIGH_GRADE_BAND: (numStories) => `He seleccionado ${numStories} textos para ti:`,
  which_story: (readAloud) => `¿Qué te gustaría ${readAloud ? 'escuchar' : 'leer'}?`,
  which_story_MID_GRADE_BAND: (readAloud) => `¿Qué te gustaría ${readAloud ? 'escuchar' : 'leer'}?`, // Edit v1
  which_story_HIGH_GRADE_BAND: (readAloud) => `¿Qué te gustaría ${readAloud ? 'escuchar' : 'leer'}?`,
  back_to_inbox: "Atrás",
  id_like_you_to_read: "Me gustaría que leyeras:",
  click_story_to_start: "Para comenzar, haz clic en el título o dilo en voz alta.",
  click_story_to_start_MID_GRADE_BAND: "Para comenzar, haz clic en el título o dilo en voz alta.", // Edit v1
  click_story_to_start_HIGH_GRADE_BAND: "Para comenzar, haz clic en el título o dilo en voz alta.",
  no_stories_speech: "Lo siento, algo no salió bien. No hay ningún cuento para ti.",
  no_stories_speech_MID_GRADE_BAND: "Lo siento, algo no salió bien. No hay ningún cuento para ti.", // Edit v1
  no_stories_speech_HIGH_GRADE_BAND: "Lo siento, algo no salió bien. No hay ningún cuento para ti.",
  no_stories_text: "No hay cuentos disponibles.",
  no_stories_text_MID_GRADE_BAND: "No hay cuentos disponibles.", // Edit v1
  no_stories_text_HIGH_GRADE_BAND: "No hay cuentos disponibles.",
  kindergarten: "Kínder",
  first_grade: "Primer grado",
  second_grade: "Segundo grado",
  third_grade: "Tercer grado",
  what_grade: "¿En qué grado estás?",
  didnt_understand: "Lo siento, no entendí eso.",
  what_activity_today: "¿Qué quieres hacer hoy?",
  what_activity_next: "¿Qué quieres hacer ahora?",
  take_a_test: "Hacer una prueba",
  take_a_test_speech: "Hacer una prueba",
  // BTS bilingual chooser cards always show both languages regardless of UI locale, so these are fixed labels.
  take_a_test_english: "Hacer una prueba (Inglés)",
  hacer_una_prueba_spanish: "Hacer una prueba (Español)",
  read_a_story: "Leer un cuento en inglés",
  read_a_story_MID_GRADE_BAND: "Leer un texto en inglés", // Edit v1
  read_a_story_HIGH_GRADE_BAND: "Leer un texto en inglés",
  read_a_story_speech: "Léeme un cuento en inglés",
  read_a_story_speech_MID_GRADE_BAND: "Leer un texto en inglés", // Edit v1
  read_a_story_speech_HIGH_GRADE_BAND: "Leer un texto en inglés",
  read_a_story_in_spanish: "Leer un cuento en español",
  read_a_story_in_spanish_MID_GRADE_BAND: "Leer un texto en español", // Edit v1
  read_a_story_in_spanish_HIGH_GRADE_BAND: "Leer un texto en español",
  read_a_story_in_spanish_speech: "Léeme un cuento en español",
  read_a_story_in_spanish_speech_MID_GRADE_BAND: "Léeme un texto en español", // Edit v1
  read_a_story_in_spanish_speech_HIGH_GRADE_BAND: "Léeme un texto en español",
  see_progress: "Ver tu progreso",
  see_progress_speech: "Mira tu progreso",
  no_activities_speech: "Tu maestro no te ha asignado ninguna actividad.",
  would_you_like: "¿Te gustaría",
  loading: "Cargando",


//ASSESSMENT INSTRUCTIONS
  orf_instructions: "Escucha las siguientes instrucciones antes de comenzar a leer. <break time=\"1s\"/> Quiero que leas esta historia en voz alta. Lee hasta terminar la historia o hasta que yo te indique que te detengas. Intenta leer todas las palabras. Si te topas con una palabra que no conoces, <break time=\"0.5s\"/> puedes saltarla <break time=\"0.5s\"/> y leer la siguiente palabra que conozcas. <break time=\"0.25s\"/> Comenzaré la cuenta regresiva para que empieces a leer. Recuerda leer lo suficientemente alto como para que pueda escucharte. ¡Comencemos!",
  orf_instructions_MID_GRADE_BAND: "Escucha las siguientes instrucciones antes de comenzar a leer. <break time=\"1s\"/> Quiero que leas este texto en voz alta. Lee hasta terminar el texto o hasta que yo te indique que te detengas. Intenta leer todas las palabras. Si te topas con una palabra que no conoces, <break time=\"0.5s\"/> puedes saltarla <break time=\"0.5s\"/> y leer la siguiente palabra que conozcas. <break time=\"0.25s\"/> Comenzaré la cuenta regresiva para que empieces a leer. Recuerda leer lo suficientemente alto como para que pueda escucharte. ¡Comencemos!", // Edit v1
  orf_instructions_HIGH_GRADE_BAND: "Escucha las siguientes instrucciones antes de comenzar a leer. <break time=\"1s\"/> Quiero que leas este texto en voz alta. Lee hasta terminar el texto o hasta que yo te indique que te detengas. Intenta leer todas las palabras. Si te topas con una palabra que no conoces, <break time=\"0.5s\"/> puedes saltarla <break time=\"0.5s\"/> y leer la siguiente palabra que conozcas. <break time=\"0.25s\"/> Comenzaré la cuenta regresiva para que empieces a leer. Recuerda leer lo suficientemente alto como para que pueda escucharte. ¡Comencemos!", // Edit v1
  orf_with_page_navigation_instructions: "Escucha las siguientes instrucciones antes de comenzar a leer. <break time=\"1s\"/> Quiero que leas esta historia en voz alta. Cuando llegues al final de una página, usa el botón de flecha para continuar. Lee hasta terminar la historia o hasta que yo te indique que te detengas. Intenta leer todas las palabras. Si te topas con una palabra que no conoces, <break time=\"0.5s\"/> puedes saltarla <break time=\"0.5s\"/> y leer la siguiente palabra que conozcas. <break time=\"0.25s\"/> Comenzaré la cuenta regresiva para que empieces a leer. Recuerda leer lo suficientemente alto como para que pueda escucharte. ¡Comencemos!",
  orf_with_page_navigation_instructions_MID_GRADE_BAND: "Escucha las siguientes instrucciones antes de comenzar a leer. <break time=\"1s\"/> Quiero que leas este texto en voz alta. Cuando llegues al final de una página, usa el botón de flecha para continuar. Lee hasta terminar el texto o hasta que yo te indique que te detengas. Intenta leer todas las palabras. Si te topas con una palabra que no conoces, <break time=\"0.5s\"/> puedes saltarla <break time=\"0.5s\"/> y leer la siguiente palabra que conozcas. <break time=\"0.25s\"/> Comenzaré la cuenta regresiva para que empieces a leer. Recuerda leer lo suficientemente alto como para que pueda escucharte. ¡Comencemos!", // Edit v1
  orf_with_page_navigation_instructions_HIGH_GRADE_BAND: "Escucha las siguientes instrucciones antes de comenzar a leer. <break time=\"1s\"/> Quiero que leas este texto en voz alta. Cuando llegues al final de una página, usa el botón de flecha para continuar. Lee hasta terminar el texto o hasta que yo te indique que te detengas. Intenta leer todas las palabras. Si te topas con una palabra que no conoces, <break time=\"0.5s\"/> puedes saltarla <break time=\"0.5s\"/> y leer la siguiente palabra que conozcas. <break time=\"0.25s\"/> Comenzaré la cuenta regresiva para que empieces a leer. Recuerda leer lo suficientemente alto como para que pueda escucharte. ¡Comencemos!", // Edit v1
  dyslexia_instructions: "Empezaremos con unas actividades de lectura cortas. Espera a que te dé las instrucciones para cada parte. Después te escucharé leer. Recuerda hablar alto y claro. ¡Comencemos!",
  dyslexia_instructions_non_verbal: "Empezaremos con unas actividades cortas. Espera a que te dé las instrucciones para cada parte. ¡Comencemos!",
  nwf_instructions:  "Cuando no conozcas una palabra, intenta pronunciar sus sonidos. En la siguiente sección, practicaremos esto con palabras que no son reales, pero que podrían serlo. Tendrás que unir los diferentes sonidos que hacen las letras para formar una palabra completa.",
  spelling_intro:  "En esta sección, trabajaremos con la ortografía.",
  spelling_idle_letter_click_encouragement: "¡Tú puedes! Haz clic en las letras para escribir tu respuesta. La palabra es: ",
  spelling_idle_letter_click_encouragement_MID_GRADE_BAND: "Sigue adelante. Haz clic en las letras para ingresar tu respuesta. La palabra es: ", 
  spelling_idle_typing_encouragement: "¡Tú puedes! Escribe tu respuesta en el cuadro. La palabra es: ", 
  spelling_idle_typing_encouragement_MID_GRADE_BAND: "Sigue adelante. Escribe tu respuesta en el cuadro. La palabra es: ", 
  listening_comprehension_intro:  "Escucha con atención la siguiente historia. Al final, te haré algunas preguntas.",
  listening_comprehension_overlay_replay_label: "Repetir",
  listening_comprehension_overlay_next_label: "Siguiente",
  listening_comprehension_overlay_replay_aria: "Escuchar el cuento o las instrucciones otra vez",
  listening_comprehension_overlay_next_aria: "Siguiente",
  sentence_builder_idle_encouragement: "Haz clic en las palabras para formar una oración.",
  reading_comprehension_intro:  "¡Leíste muy bien! Ahora te haré algunas preguntas sobre esa historia. Leeré la pregunta y las opciones de respuesta. ¡Intenta responder lo mejor que puedas!",
  reading_comprehension_intro_MID_GRADE_BAND:  "Leíste muy bien. Ahora te haré algunas preguntas sobre ese texto. Leeré la pregunta y las opciones de respuesta. ¡Intenta responder lo mejor que puedas!", // Edit v1
  reading_comprehension_intro_HIGH_GRADE_BAND:  "Leíste muy bien. Ahora te haré algunas preguntas sobre ese texto. Leeré la pregunta y las opciones de respuesta. ¡Intenta responder lo mejor que puedas!", // Edit v1
  reading_comprehension_intro_NON_VERBAL:  "Voy a leer la pregunta y también cada una de las respuestas. Para revisar el texto, haz clic en el botón al lado de la pregunta. ¡Haz tu mejor esfuerzo!",
  reading_comprehension_intro_NON_VERBAL_ONE: "Te voy a mostrar un texto para leer. Cuando termines, te haré algunas preguntas.",
  reading_comprehension_intro_NON_VERBAL_TWO: "Haz clic en el botón cuando estés listo para comenzar.",
  reading_comprehension_intro_NON_VERBAL_THREE: "Voy a leer la pregunta y también cada una de las respuestas.",
  reading_comprehension_intro_NON_VERBAL_FOUR: "Para revisar el texto, haz clic en este botón.",
  reading_comprehension_intro_NON_VERBAL_FIVE: "¡Haz tu mejor esfuerzo!",
  vocabulary_screener_intro: "En la siguiente actividad, quiero que elijas la palabra más adecuada. Te leeré las palabras.",
  letter_name_and_sounds_intro: "Para esta próxima actividad, vamos a trabajar con letras.",
  abbreviated_instructions: "Instrucciones para saltar palabras",
  relevel_instructions: "Ahora vamos a prepararnos para leer otra vez. Debes hablar alto y claro. Si te topas con una palabra que no conoces, recuerda que puedes saltarla. Comenzaré la cuenta regresiva para que empieces a leer.",
  next_section_transition: "¡Buen trabajo en esa parte! Ahora intentaremos algo distinto.",
  please_wait: (tutorName) => `Por favor, espera a que ${tutorName} te indique que puedes comenzar`,
  end_assessment: "CONCLUIR LA EVALUACIÓN",
  try_different_story: "Vamos a intentarlo con un cuento diferente.",
  try_different_story_MID_GRADE_BAND: "Es un buen momento para cambiar a otro texto.", // Edit v1
  try_different_story_HIGH_GRADE_BAND: "Es un buen momento para cambiar a otro texto.", // Edit v1
  try_different_story_ran: "Creo que debemos intentarlo con algo diferente.",
  please_keep_reading: "Aún no has terminado, sigue leyendo.",
  lets_move_on: "Sigamos adelante.",

  // Inactivity modal and Next button reminder
  inactivity_modal_alert: "¿Sigues ahí?",
  inactivity_modal_explanation: "¡Toca OK para seguir leyendo!",
  inactivity_modal_voice_over: "Parece que llevas un rato sin leer. ¡Toca OK para seguir!",
  inactivity_modal_button: "OK",
  next_button_reminder: "Recuerda hacer clic en el botón siguiente para continuar.",

  // ASSESSMENT - Word-part deletion
  word_part_deletion: {
    intro_instruction_1: "Le diremos a Spot varias palabras misteriosas. Yo mencionaré una palabra larga y te indicaré una parte de esa palabra que no debes decir.",
    intro_instruction_2: ({
      word, omit, target, skipTranslationWord, skipTranslationTarget, skipTranslationOmit
    }) => {
      var formattedWord = skipTranslationWord ? `<mark name="skipTranslation: start"/>${word}<mark name="skipTranslation: end"/>` : word;
      var formattedTarget = skipTranslationTarget ? `<mark name="skipTranslation: start"/>${target}<mark name="skipTranslation: end"/>` : target;
      var formattedOmit = skipTranslationOmit ? `<mark name="skipTranslation: start"/>${omit}<mark name="skipTranslation: end"/>` : omit;
      return `Por ejemplo, te pediré que repitas la palabra ${formattedWord} sin decir ${formattedOmit}. Luego, tú dirás ${formattedTarget}. ¿Puedes repetir la palabra ${formattedWord} sin decir ${formattedOmit}?`
    },
    intro_end: "¡Muy bien! Spot ladrará cuando te oiga.",
    actual_instruction: ({
      word, omit, skipTranslationWord, skipTranslationTarget, skipTranslationOmit
    }) => {
      var formattedWord = skipTranslationWord ? `<mark name="skipTranslation: start"/>${word}<mark name="skipTranslation: end"/>` : word;
      var formattedOmit = skipTranslationOmit ? `<mark name="skipTranslation: start"/>${omit}<mark name="skipTranslation: end"/>` : omit;
      return `Repite la palabra ${formattedWord} sin decir ${formattedOmit}.`
    },
    prompt_to_try: ({
      word, omit, skipTranslationWord, skipTranslationOmit
    }) => {
      var formattedWord = skipTranslationWord ? `<mark name="skipTranslation: start"/>${word}<mark name="skipTranslation: end"/>` : word;
      var formattedOmit = skipTranslationOmit ? `<mark name="skipTranslation: start"/>${omit}<mark name="skipTranslation: end"/>` : omit;
      return `¡Tú puedes! Repite la palabra ${formattedWord} sin decir ${formattedOmit}.`
    },
    end: "¡Gracias!",
    end_with_more_activities: "¡Gracias! Pasemos al siguiente grupo de actividades.",
  },
  word_part_deletion_HIGH_GRADE_BAND: {
    intro_instruction_1: "Le diremos a Spot varias palabras misteriosas. Yo mencionaré una palabra larga y te indicaré una parte de esa palabra que no debes decir.",
    intro_instruction_2: ({word, omit, target, skipTranslationWord, skipTranslationTarget, skipTranslationOmit}) => {
      var formattedWord = skipTranslationWord ? `<mark name="skipTranslation: start"/>${word}<mark name="skipTranslation: end"/>` : word;
      var formattedTarget = skipTranslationTarget ? `<mark name="skipTranslation: start"/>${target}<mark name="skipTranslation: end"/>` : target;
      var formattedOmit = skipTranslationOmit ? `<mark name="skipTranslation: start"/>${omit}<mark name="skipTranslation: end"/>` : omit;
      return `Por ejemplo, te pediré que repitas la palabra ${formattedWord} sin decir ${formattedOmit}. Luego, tú dirás ${formattedTarget}. ¿Puedes repetir la palabra ${formattedWord} sin decir ${formattedOmit}?`
    },
    intro_end: "¡Excelente! Spot ladrará cuando te escuche.",
    actual_instruction: ({word, omit, skipTranslationWord, skipTranslationOmit}) => {
      var formattedWord = skipTranslationWord ? `<mark name="skipTranslation: start"/>${word}<mark name="skipTranslation: end"/>` : word;
      var formattedOmit = skipTranslationOmit ? `<mark name="skipTranslation: start"/>${omit}<mark name="skipTranslation: end"/>` : omit;
      return `¡Tú puedes! Repite la palabra ${formattedWord} sin decir ${formattedOmit}.`
    },
    prompt_to_try: ({
      word, omit, skipTranslationWord, skipTranslationOmit
    }) => {
      var formattedWord = skipTranslationWord ? `<mark name="skipTranslation: start"/>${word}<mark name="skipTranslation: end"/>` : word;
      var formattedOmit = skipTranslationOmit ? `<mark name="skipTranslation: start"/>${omit}<mark name="skipTranslation: end"/>` : omit;
      return `¡Tú puedes! Repite la palabra ${formattedWord} sin decir ${formattedOmit}.`
    },
    end: "¡Gracias!",
    end_with_more_activities: "Gracias. Sigamos con las siguientes actividades.", // Edit v1
  },

  // ASSESSMENT - Nonsense word repetition
  nonsense_word_repetition: {
    intro: ({modelName, nonsenseWord, skipTranslation}) => `¡Te presento a mi amiga! Mi amiga dirá algunas palabras que no son reales, como ${skipTranslation ? `<mark name="skipTranslation: start"/>` : ''}${nonsenseWord}${skipTranslation ? `<mark name="skipTranslation: end"/>` : ''}`,
    intro_prompt: ({modelName, nonsenseWord, skipTranslation}) => `Repítele la palabra ${skipTranslation ? `<mark name="skipTranslation: start"/>` : ''}${nonsenseWord}${skipTranslation ? `<mark name="skipTranslation: end"/>` : ''} a mi amiga.`,
    intro_end: ({modelName, nonsenseWord, skipTranslation}) => `¡Buen trabajo! Ahora mi amiga dirá más palabras que no son reales. Tú nos las repetirás a mi amiga y a mí como hiciste con la palabra ${skipTranslation ? `<mark name="skipTranslation: start"/>` : ''}${nonsenseWord}${skipTranslation ? `<mark name="skipTranslation: end"/>` : ''}. Si quieres que mi amiga vuelva a decir las palabras, presiona el botón grande.`,
    prompt_to_try: ({modelName}) => `Si quieres que mi amiga repita la palabra, presiona el botón.`,
    subsequent_prompt_to_try: "¡Tú puedes! Inténtalo.",
    subsequent_end: "¡Muy bien!",
    end: "¡Muy bien! Gracias.",
    end_with_more_activities: "¡Gracias! Pasemos al siguiente grupo de actividades.",
  },
  nonsense_word_repetition_HIGH_GRADE_BAND: {
    intro: ({modelName, nonsenseWord, skipTranslation}) => `¡Te presento a mi amiga! Mi amiga dirá algunas palabras que no son reales, como ${skipTranslation ? `<mark name="skipTranslation: start"/>` : ''}${nonsenseWord}${skipTranslation ? `<mark name="skipTranslation: end"/>` : ''}`,
    intro_prompt: ({modelName, nonsenseWord, skipTranslation}) => `Repítele la palabra ${skipTranslation ? `<mark name="skipTranslation: start"/>` : ''}${nonsenseWord}${skipTranslation ? `<mark name="skipTranslation: end"/>` : ''} a mi amiga.`,
    intro_end: ({modelName, nonsenseWord, skipTranslation}) => `¡Buen trabajo! Ahora mi amiga dirá más palabras que no son reales. Tú nos las repetirás a mi amiga y a mí como hiciste con la palabra ${skipTranslation ? `<mark name="skipTranslation: start"/>` : ''}${nonsenseWord}${skipTranslation ? `<mark name="skipTranslation: end"/>` : ''}. Si quieres que mi amiga vuelva a decir las palabras, presiona el botón grande.`,
    prompt_to_try: ({modelName}) => `Si quieres que mi amiga repita la palabra, presiona el botón.`,
    subsequent_prompt_to_try: "Haz un intento.", // Edit v1
    subsequent_end: "¡Muy bien!",
    end: "¡Muy bien! Gracias.",
    end_with_more_activities: "Gracias. Ahora continuamos con el siguiente conjunto de actividades.", // Edit v1
  },

  //INTERVENTIONS
  keep_reading: "¡Sigamos leyendo!",
  try_again: "Vamos a intentarlo otra vez",
  start_reading: "Comienza a leer",
  wordAttackPrompt: [
    "¿Conoces el primer sonido de esta palabra?",
    "¿Puedes pronunciar los sonidos que forman esta palabra?",
  ],

  //STATUS STRINGS
  onFire: [
    "¡Hiciste un excelente trabajo!",
    "¡Buen trabajo!",
    "¡Muy buena lectura!", // Edit v1
    "¡Eres toda una estrella!",
    "¡Qué bien leíste!",
    "¡Bien hecho!",
  ],
  onFire_MID_GRADE_BAND: [
    "¡Hiciste un excelente trabajo!",
    "¡Buen trabajo!",
    "Increíble progreso.", // Edit v1
    "Lo estás haciendo excelente.", // Edit v1
    "Leíste eso muy bien.", // Edit v1
    "¡Bien hecho!",
  ],
  onFire_HIGH_GRADE_BAND: [
    "¡Hiciste un excelente trabajo!",
    "¡Buen trabajo!",
    "Increíble progreso.", // Edit v1
    "Lo estás haciendo excelente.", // Edit v1
    "Leíste eso muy bien.", // Edit v1
    "Bien hecho.",
  ],
  goodAccuracy: [
    "¡Bien hecho! Leíste correctamente muchas palabras.",
    "¡Buen trabajo! Cometiste muy pocos errores.",
    "Leíste correctamente muchas palabras difíciles.",
    "Hoy leíste muy bien.",
    "Leíste muy bien.",
  ],
  goodAccuracy_MID_GRADE_BAND: [
    "¡Bien hecho! Leíste correctamente muchas palabras.",
    "¡Buen trabajo! Cometiste muy pocos errores.",
    "Leíste bien varias palabras complicadas.", // Edit v1
    "Hoy leíste muy bien.",
    "Leíste muy bien.",
  ],
  goodAccuracy_HIGH_GRADE_BAND: [
    "Sigue así, leíste muchas palabras correctamente.", // Edit v1
    "¡Buen trabajo! Cometiste muy pocos errores.",
    "Leíste bien varias palabras complicadas.", // Edit v1
    "Hoy leíste muy bien.",
    "Leíste muy bien.",
  ],
  workOn: [
    "Seguiremos trabajando para mejorar.",
    "Sé que lo darás todo la próxima vez.",
    "Sigue esforzándote.",
    "La próxima vez, lo haremos aún mejor.",
    "Si sigues leyendo conmigo, lo harás cada vez mejor.",
    "¡Sigamos practicando!",
    "Espero que sigas leyendo conmigo.",
    "¡Sigamos leyendo juntos!"
  ],
  workOn_MID_GRADE_BAND: [
    "Seguiremos trabajando para mejorar.",
    "Sé que lo darás todo la próxima vez.",
    "Sigue esforzándote.",
    "La próxima vez, lo haremos aún mejor.",
    "Leer conmigo te ayudará a seguir mejorando.", // Edit v1
    "¡Sigamos practicando!",
    "Sigamos practicando juntos.", // Edit v1
    "¡Sigamos leyendo juntos!"
  ],
  workOn_HIGH_GRADE_BAND: [
    "Seguiremos trabajando para mejorar.",
    "La práctica te ayudará a seguir avanzando.", // Edit v1
    "Sigue esforzándote.",
    "La próxima vez podemos hacerlo aún mejor.", // Edit v1
    "Leer conmigo te ayudará a seguir mejorando.", // Edit v1
    "¡Sigamos practicando!",
    "Sigamos practicando juntos.", // Edit v1
    "¡Sigamos leyendo juntos!"
  ],
  goodSpeed: [
    "¡Me alegra que hayas leído esta historia!",
    "Hoy leíste a un buen ritmo.",
    "Leíste con fluidez.",
    "Hoy leíste muy bien.",
   "Leíste muy bien.",
  ],
  noImprovement: [
    "¡Me divertí mucho leyendo esta historia contigo! ¡Buen trabajo!",
    "¡Qué buena historia! ¡Seguro que la disfrutaste!",
    "¡Esa historia fue muy divertida!",
    "¡Guau! ¡Terminamos la historia! ¡Qué bien te concentraste!",
    "¡Me encantó leer contigo! Estuviste muy atento de principio a fin. ¡Bien hecho!",
    "¡Bien hecho! Leíste correctamente muchas palabras.",
    "Sigue esforzándote.",
    "¡Muy bien! Si sigues leyendo conmigo, lo harás cada vez mejor.",
    "¡Buen trabajo! La próxima vez, lo haremos aún mejor.",
    "¡Bien hecho! Si sigues leyendo conmigo, lo harás cada vez mejor.",
    "¡Leíste muy bien! ¡Sigamos practicando!",
  ],
  noImprovement_MID_GRADE_BAND: [ // Edit v1
    "Gracias por leer conmigo.",
    "Espero que hayas disfrutado el texto.",
    "Terminamos todo el texto. Muy buen trabajo manteniéndote concentrado.",
    "Buena lectura hoy. Llegaste hasta el final.",
    "¡Bien hecho! Leíste correctamente muchas palabras.",
    "Sigue esforzándote.",
    "Muy bien leído. Leer juntos te ayudará a mejorar cada vez más.",
    "Bien hecho. La próxima sesión iremos más lejos.",
    "Leíste muy bien. Si mantenemos este ritmo, serás cada vez mejor.",
    "¡Leíste muy bien! ¡Sigamos practicando!",
  ],
  noImprovement_HIGH_GRADE_BAND: [ // Edit v1
    "Gracias por leer conmigo.",
    "Espero que hayas disfrutado el texto.",
    "Muy bien, terminaste el texto completo y te mantuviste enfocado.",
    "Buena lectura hoy. Llegaste hasta el final.",
    "Sigue así, leíste bien muchas palabras.",
    "Sigue esforzándote.",
    "Muy bien leído. Leer juntos te ayudará a mejorar cada vez más.",
    "Bien hecho. La próxima sesión iremos más lejos.",
    "Leíste muy bien. Si mantenemos este ritmo, serás cada vez mejor.",
    "¡Leíste muy bien, sigamos practicando!",
  ],
  wrapUp: [
    "Gracias por leer conmigo.",
    "Gracias por leerme eso.",
    "Me encantó leer contigo.",
    "¡Gracias por leer hoy conmigo!",
    "¡Gracias!",
    "¡Me gustó mucho leer contigo!",
    "Gracias por leer conmigo.",
  ],
  wrapUp_MID_GRADE_BAND: [ // Edit v1
    "Gracias por leer conmigo.",
    "Aprecio tu esfuerzo de hoy.",
    "Buen trabajo durante la sesión de lectura de hoy.",
    "¡Gracias por leer hoy conmigo!",
    "¡Gracias!",
    "¡Me gustó mucho leer contigo!",
    "Gracias por acompañarme en esta lectura.",
  ],
  wrapUp_HIGH_GRADE_BAND: [ // Edit v1
    "Gracias por leer conmigo.",
    "Aprecio tu esfuerzo de hoy.",
    "Buen trabajo durante la sesión de lectura de hoy.",
    "¡Gracias por leer hoy conmigo!",
    "¡Gracias!",
    "¡Me gustó mucho leer contigo!",
    "Gracias por acompañarme en esta lectura.",
  ],
  keep_up: "¡Sigue así!",
  status_stats_speech_front: (wcpm, accuracy) => `Leíste ${wcpm} palabras por minuto y pronunciaste bien el ${accuracy} por ciento de ellas.`,
  stats_compare_improved: (wpmDifference, accuracyDifference) => `Leíste ${wpmDifference} palabras más rápido y con un ${accuracyDifference} por ciento más de precisión que de costumbre.`,
  stats_compare_improved_wpm: (wpmDifference) => `Leíste ${wpmDifference} palabras más rápido que lo habitual.`,
  stats_compare_improved_accuracy: (accuracyDifference) => `Leíste correctamente un ${accuracyDifference} por ciento más que lo habitual.`,
  times_up_speech: "Se acabó el tiempo. ¡Excelente trabajo!",
  finished_story_speech: "¡Buen trabajo! ¡Terminaste la historia!",
  finished_story_speech_MID_GRADE_BAND: "¡Buen trabajo! Llegaste al final del texto.", // Edit v1
  finished_story_speech_HIGH_GRADE_BAND: "¡Buen trabajo! Llegaste al final del texto.", // Edit v1
  finished_assessment_speech: "¡Buen trabajo, ya terminaste! Ahora puedes seguir con tu día. ¡Hasta la próxima!",
  all_done_speech: "¡Buen trabajo! Ya terminaste.",
  another_textset_story_speech: "¡Buen trabajo! Hay más en esta historia. ¡Sigamos adelante!",
  another_story_speech: "¡Buen trabajo! ¡Sigamos adelante!",
  stats_speech_one: "Leíste",
  stats_speech_two: "palabras por minuto y pronunciaste correctamente un",
  stats_speech_three: "por ciento de ellas.",
  no_historic_data_speech: [
    "¡Me divertí mucho leyendo esta historia contigo! ¡Buen trabajo!",
    "¡Qué buena historia! ¡Seguro que la disfrutaste!",
    "¡Esa historia fue muy divertida!",
    "¡Guau! ¡Terminamos la historia! ¡Qué bien te concentraste!",
    "¡Me encantó leer contigo! Estuviste muy atento de principio a fin. ¡Bien hecho!",
  ],
  no_historic_data_speech_MID_GRADE_BAND: [ // Edit v1
    "Gracias por leer conmigo.",
    "¡Ojalá te haya gustado el texto!",
    "Terminamos todo el texto. Muy buen trabajo manteniéndote concentrado.",
    "¡Buen trabajo! Leíste todo el texto con atención.",
  ],
  no_historic_data_speech_HIGH_GRADE_BAND: [ // Edit v1
    "Gracias por leer conmigo.",
    "¡Ojalá te haya gustado el texto!",
    "Muy bien, terminaste el texto completo y te mantuviste enfocado.",
    "Hoy leíste muy bien, no te detuviste y terminaste todo el texto.",
  ],
  stats_speech_compare_improved: (wpmDifference) => `Leíste esta historia ${wpmDifference} palabras más rápido de lo habitual y con mayor precisión.`,
  stats_speech_compare_improved_wpm_one: "Leíste esta historia",
  stats_speech_compare_improved_wpm_one_MID_GRADE_BAND: "Leíste este texto", // Edit v1
  stats_speech_compare_improved_wpm_one_HIGH_GRADE_BAND: "Leíste este texto", // Edit v1
  stats_speech_compare_improved_wpm_two: "palabras más rápido de lo habitual. Tu precisión fue del",
  stats_speech_compare_improved_wpm_three: "por ciento.",
  // Spoken alone by StudentStatus (IMPROVED_ACCURACY); the companion
  // "..._accuracy_two" and the percentage are never appended, so this must read
  // as a complete sentence on its own (TT-1135).
  stats_speech_compare_improved_accuracy_one: "Tu precisión fue increíble.",
  stats_speech_compare_improved_accuracy_two: "por ciento mayor que la habitual.",
  even_better: "Seguiremos trabajando para mejorar aún más.",
  work_to_get_better: "Podemos seguir mejorando.",
  times_up: "Se acabó el tiempo",
  finished_story: "Terminaste la historia.",
  finished_story_MID_GRADE_BAND: "Terminaste el texto.", // Edit v1
  finished_story_HIGH_GRADE_BAND: "Terminaste el texto.", // Edit v1
  all_done: "Ya terminaste.",
  speed: "Velocidad",
  average_speed: "Velocidad promedio",
  correct: "Correcto",
  average_correct: "Promedio de palabras correctas",
  great_work: "¡Buen trabajo!",
  please_close_tab: "Ya puedes cerrar esta pestaña.",
  finished: "Terminado",
  read_more: "Leer Más",

  //GENERAL DISPLAY
  example: "ejemplo",
  go_to_the: "Ir al",
  tracking_report: "Informe de seguimiento",
  recommendation_intervention: "Intervención",
  recommendation_catch_up: "Ponerse al día",
  recommendation_at_above: "En/Arriba",
  print_letters: "Imprimir Cartas",

  //ERROR MODALS
  audio_error_speech: "No logro entenderte, así que tendremos que empezar de nuevo. Revisa que tu micrófono no esté silenciado y habla alto y claro. Cuando quieras volver a intentarlo, haz clic en el botón 'Reiniciar'.",
  error_speech: "Lo siento, hubo un error y tendremos que empezar de nuevo. Cuando quieras volver a intentarlo, haz clic en el botón 'Cerrar y reiniciar'.",
  mute_error_speech: "Parece que tu micrófono está silenciado. Reactiva el audio del micrófono y haz clic en 'Continuemos' para seguir adelante.",
  disabled_error_speech: "Parece que no has habilitado el acceso a tu micrófono. Habilita tu micrófono y haz clic en el botón para continuar.",
  kid_error_speech: "¡Uy! ¡Necesitamos ayuda! Por favor, pídele a tu maestro que venga a ayudarnos.",
  kid_error_speech_MID_GRADE_BAND: "Por favor, pídele a tu maestro que venga a ayudarnos.", // Edit v1
  kid_error_speech_HIGH_GRADE_BAND: "Por favor, pídele a tu maestro que venga a ayudarnos.", // Edit v1
  audio_input_changed_error_title: "Levanta tu mano",
  audio_input_changed_error_text: "Parece que tu micrófono o dispositivo de entrada de audio cambió. Esto puede suceder si desconectaste los auriculares o cambiaste de dispositivo de audio. Por favor, reinicia tu sesión para continuar.",
  audio_input_changed_error_speech: "Noté que tu micrófono o dispositivo de audio cambió. Esto puede suceder si desconectaste los auriculares o cambiaste de dispositivo de audio. Necesitaremos reiniciar para continuar trabajando juntos.",
  error_text: "Lo siento, pero algo salió mal y tendré que reiniciar tu evaluación.",
  mute_error_text: "Parece que tu micrófono está silenciado. Revisa que el audio esté activado y haz clic en el siguiente botón para comenzar.",
  audio_error_text: "No logro entenderte. Revisa que tu micrófono no esté silenciado y habla alto y claro.",
  compat_error_text: "Parece que tu navegador no es compatible o no está actualizado. Instala Chrome 70 o una versión posterior para poder leer.",
  compat_error_text_os: "Parece que tu sistema operativo no es compatible o no está actualizado.",
  compat_error_no_spanish: "Tu navegador no es compatible con la práctica en español. Presiona 'Continuemos' para volver al menú principal.",
  compat_error_text_mobile: "Parece que tu dispositivo móvil no es compatible.",
  compat_error_text_ipad: "Parece que tu navegador no es compatible o no está actualizado. Instala Safari y iOS 16 o una versión posterior para poder leer.",
  product_access_disabled_text: "No se encontraron suscripciones activas para tu escuela. Pide ayuda a tu maestro.",
  product_access_disabled_title: (brandedAppName) => `${brandedAppName} no está disponible en este momento`,
  disabled_error_continue: "Parece que no has habilitado el acceso a tu micrófono. Habilita tu micrófono en esta página web para continuar.",
  disabled_error_text: "Parece que no has habilitado el acceso a tu micrófono. Vuelve a iniciar sesión y selecciona 'Permitir' cuando se solicite el micrófono.",
  blank_error_text: "No logro escucharte bien. Presiona 'Cerrar sesión' para actualizar tu navegador. Tendrás que volver a iniciar sesión.",
  ipad_error_text: (brandedAppName) => `${brandedAppName} para Maestros aún no es compatible con dispositivos iPad. Para continuar como estudiante, haz clic en 'Aceptar' y vuelve a iniciar sesión con credenciales de estudiante.`,
  raise_your_hand: "Levanta la mano.",
  logout: "Cerrar sesión",
  im_ready: "Continuemos",
  restart: "Reiniciar",
  logout_and_restart: "Cerrar y reiniciar",
  browser_not_supported: "Tu navegador no es compatible",
  os_not_supported: "Tu sistema operativo no es compatible",
  mobile_not_supported: "Tu dispositivo móvil no es compatible",
  wait_modal_text: "Espera mientras guardo tu lectura",
  scoring_wait_modal_text: "Espera mientras guardo tu actividad calificada",
  wait_modal_title: "Guardando",
  no_stories_for_you: "Ya leíste todas las historias de la prueba. Puedes seguir leyendo sin evaluación.",
  no_stories_for_you_MID_GRADE_BAND: "Ya completaste todos los textos. Pide ayuda a tu maestro para continuar.", // Edit v1
  no_stories_for_you_HIGH_GRADE_BAND: "Ya completaste todos los textos. Pide ayuda a tu maestro para continuar.", // Edit v1
  no_stories_for_you_text: "Ya se han leído todas las historias que forman parte de la prueba. Se puede continuar leyendo historias sin fines de evaluación.",
  no_stories_for_you_text_MID_GRADE_BAND: "Terminaste todos los textos de la evaluación. Ahora puedes leer más por gusto, sin evaluación.", // Edit v1
  no_stories_for_you_text_HIGH_GRADE_BAND: "Terminaste todos los textos de la evaluación. Ahora puedes leer más por gusto, sin evaluación.", // Edit v1
  all_stories_taken: "No hay historias disponibles",
  all_stories_taken_MID_GRADE_BAND: "No hay textos disponibles", // Edit v1
  all_stories_taken_HIGH_GRADE_BAND: "No hay textos disponibles", // Edit v1
  play_video_with_button: "Haz clic en el botón de reproducción para comenzar.",
  error_fetching_stories: "¡Vaya! No pude encontrar tus historias. Presiona el botón verde para intentarlo de nuevo.",
  error_fetching_stories_rec_code: "Error code 0001: Inténtalo de nuevo o comunícate con el equipo de soporte.",
  error_fetching_stories_story_code: "Error code 0002: Inténtalo de nuevo o comunícate con el equipo de soporte.",
  error_fetching_stories_put_activity_code: "Error code 0003: Inténtalo de nuevo o comunícate con el equipo de soporte.",
  error_fetching_stories_title: "¡Vaya! No pude encontrar tus historias. ",
  error_fetching_stories_title_MID_GRADE_BAND: "No pude encontrar tus textos. ", // Edit v1
  error_fetching_stories_title_HIGH_GRADE_BAND: "No pude encontrar tus textos. ", // Edit v1
  try_again: "Inténtalo otra vez",
  paused_from_bad_network_speech: "Parece que hay un problema con el internet. Voy a intentar reconectarme.",
  paused_from_bad_network_title: "¡Uy!",
  resume_from_bad_network_ready: "¡Podemos comenzar!",
  resume_from_bad_network_speech: "¡Estamos de vuelta! Haz clic en el botón de inicio y comienza a leer.",
  resume_from_bad_network_continue: "Continuar",
  retry_pause_network_speech: "Todavía hay un problema. Cuenta hasta tres e inténtalo otra vez",
  retry_pause_network_speech_MID_GRADE_BAND: "Aún tengo algunas dificultades. Tomémonos unos segundos y volvamos a intentarlo.", // Edit v1
  retry_pause_network_speech_HIGH_GRADE_BAND: "Aún tengo algunas dificultades. Tomémonos unos segundos y volvamos a intentarlo.", // Edit v1
  retry_pause_network_title: "¡Oh no!",
  retry_pause_network_title_MID_GRADE_BAND: "Algo no está funcionando del todo bien.", // Edit v1
  retry_pause_network_title_HIGH_GRADE_BAND: "Algo no está funcionando del todo bien.", // Edit v1
  retry_pause_network_button: "Inténtalo de nuevo",
  critical_network_speech: "Por favor, pídele a tu maestro que venga a ayudarnos.",
  critical_network_speech_MID_GRADE_BAND: "Por favor, pídele a tu maestro que venga a ayudarnos.", // Edit v1
  critical_network_speech_HIGH_GRADE_BAND: "Por favor, pídele a tu maestro que venga a ayudarnos.", // Edit v1

  //TUTOR
  read_with_me_mode: "Leamos en equipo una parte de esta historia. Yo leeré cada oración y, cuando termine, intentarás leerla tú.",
  end_read_with_me_mode: "Voy a leer una oración más. Luego, seguirás leyendo tú.",
  intervention_strings: ES_MX_INTERVENTION_STRINGS,
  student_checks: {
    intro: "¡Por fin estás aquí!",
    intro_triple_yes: "¡Sí, sí y sí!",
    intro_excited: "¡Qué emoción!",
    intro_continued: '¡Siento que llevo SIGLOS esperando para leer contigo!',
    intro_finished: (tutorName) => `¡Hola, soy ${tutorName}!`,
    intro_microphone: "¿Qué tal estás?<break time=\"1.5s\"/>",
    welcome_back: "¡Me alegra verte de nuevo!",
    wait_while_i_check: "Espera mientras reviso algunas cosas.",
    microphone_access_granted: "¡Que comience la fiesta de la lectura!<break time=\"1s\"/>",
    intro_amira_moveon_one: "Bueno, en realidad no viniste solo para bailar. ¡Estás aquí para LEER!",
    intro_amira_moveon_two: "¡Soy TU asistente de lectura personal",
    intro_amira_moveon_three: "y te ayudaré a leer con confianza! ¡¿Y adivina qué?!",
    intro_screen: "Esta pantalla nos permitirá leer CUALQUIER historia que queramos, y yo te ayudaré en el camino.<break time=\".5s\"/>",
    intro_assessment_mode: "Verifiquemos que puedo escucharte. ¡Así podremos comenzar!",
    volume_check_intro_one: "Conoceremos todo tipo de personajes extraordinarios.", // glance
    volume_check_intro_two: "Te doy mi palabra y ¡te lo demostraré! Este...",
    check_on_spot_intro: "¡es uno de mis personajes favoritos!", // mid range point at 3 o clock
    check_on_spot_intro_part_two: "¡Veamos qué hace mi amigo Spot!<break time=\"1s\"/>",
    oh_hes_sleeping: "¡Vaya! Está durmiendo.", // wide eyed animation
    lets_wake_him_up_one: "¡Vamos a despertarlo! Necesitamos hablar lo suficientemente alto como para que nos oiga,", //pointdown
    talk_loud_enough: "Necesitamos hablar lo suficientemente alto como para que nos oiga,",
    lets_wake_him_up_two: "pero no TAN alto como para asustarlo",
    lets_wake_him_up_three: "Cuando este micrófono se ponga verde",
    wake_up_spot: "tú dirás ¡Despierta, Spot!",
    he_heard_you: "¡Te oyó! Eso es exactamente lo que debes hacer al leer conmigo. ", // excited //waves
    he_heard_you_loud: "Bien, creo que Spot puede oírte.",
    he_heard_you_two: "Me alegró verte, Spot. ¡Hasta luego!",
    he_heard_you_two_generative: "Me alegró verte, Spot. ¡Hasta luego!",
    finish_asr_check: "¡Perfecto! ¡Esto será genial!", // thumbs up
    handle_too_soft_one: "No te oyó. Cuando el micrófono esté verde, vuelve a decirlo más alto: \"¡Despierta, Spot!\" <break time=\"1.5s\"/>",
    handle_too_soft_second_round: "¡Vaya! Aun así no pudo oírte. <break time=\"1.5s\"/>",
    handle_too_soft_second_round_two: "¿Tienes el micrófono frente a tu boca? ¿Puedes verificarlo?<break time=\"1.5s\"/>",
    handle_too_soft_second_round_three: "¿Estás hablando alto y claro?",
    handle_too_soft_second_round_four: "Intenta despertarlo otra vez.",
    handle_too_loud_one: "¡Cuidado! ¡No queremos asustarlo!<break time=\"1.5s\"/>",
    handle_too_loud_two: "¿El micrófono TOCA tu boca? ¿Puedes alejarlo un poco?<break time=\"1.5s\"/>",
    handle_too_loud_three: "Ahora, hablando un poco más suave, di: ¡Despierta, Spot! <break time=\"1.5s\"/>",
    handle_no_audio_one: "¡Vaya! ¡No pude oírte! Si estás usando auriculares, intenta presionar el botón del cable para reactivar el audio.<break time=\"2s\"/>",
    handle_no_audio_part_two: "cuando el micrófono esté verde, en voz alta y clara",
    handle_no_audio_two: "Todavía no puedo escucharte. Intentemos una vez más.<break time=\"1s\"/>",
    handle_get_teacher: "Por favor, pídele a tu maestro que venga a ayudarnos y levanta la mano.",
    handle_get_teacher_two: "Por favor, pídele a tu maestro que venga a ayudarnos.",
    teacher_mode_volume_welcome_one: "Gracias por venir a ayudarnos. No oigo a tu estudiante cuando lee. ¿Podemos intentarlo contigo? Por favor, di: \"¡Despierta, Spot!\"",
    teacher_mode_volume_success_one: "¡Excelente! Puedo oírte. ¿Podrías asegurarte de que tu estudiante esté cerca del micrófono y hable en voz alta y clara?",
    teacher_mode_volume_student_retry: "Por favor, deja que tu estudiante lo intente de nuevo.",
    teacher_mode_volume_success_but_loud_one: "Todavía se oye muy alto. ¿Puedes hablar más bajo o ajustar el volumen del micrófono y pedirle a tu estudiante que lo intente de nuevo?",
    teacher_mode_volume_failure_one: "¡Oh, no! Apenas puedo oírte. Consultemos este artículo para asegurarnos de que todo esté bien configurado. Quizá tengamos que realizar varios pasos.",
    network_ping_error: "¡Por fin estás aquí! ¡Qué emoción! Parece que hay un problema con el internet.",
    return_user_wake_up_prompt: "¿Puedes despertar a mi amigo Spot? <break time=\"1s\"/>",
    return_user_talk_loud_enough: "Necesitamos que hables lo suficientemente alto como para despertarlo.",
    student_hardware_denied: "Parece que hay un problema con el micrófono.",
    student_hardware_denied_two: "Por favor, pídele a tu maestro que venga a ayudarnos y levanta la mano.<break time=\"1s\"/>",
    student_images_blocked: "Mmm, parece que las imágenes están desactivadas en tu navegador, ¡así que no puedes verme!<break time=\"1s\"/>",
    student_hardware_prompt_intro: "¡Oh! ¡Casi lo olvido! Tienes que encender tu MICRÓFONO para que yo pueda oírte.",
    student_hardware_prompt_initial: "¡Presiona 'Permitir' y podremos comenzar!",
    student_hardware_prompt: "¡Tú puedes! ¡Presiona 'Permitir' para que podamos comenzar!",
    student_hardware_prompt_two: "¿Sigues ahí? Selecciona el botón que dice 'Permitir'.", // Edit v1
    student_hardware_manually_fixed: "¡Gracias! Ya solo tienes que cerrar y reiniciar. Nos vemos en un minuto.",
    prompt_ios_device_mic_modal_error: "Intenta de nuevo. Selecciona el botón que dice 'Permitir'.", // Edit v1
    prompt_ios_device_mic_modal_success: "Presiónalo de nuevo, una vez más.",
    prompt_ios_device_mic_modal_got_it: "¡Muy bien!",
    student_asr_on_screen_text: "",
    student_asr_initial_prompt: "Ahora di: '¡Es hora de leer!'.",
    student_asr_reminder_one: "No te oí. Por favor, di: 'Es hora de leer'.",
    student_asr_reminder_two: "¿Puedes volver a intentarlo? Habla por el micrófono y di: \"Es hora de leer\"",
    student_asr_reminder_three: "Todavía no oigo nada. Por favor, di \"Es hora de leer\".",
    student_asr_get_teacher: "Por favor, pídele a tu maestro que venga a ayudarnos y levanta la mano.",
    teacher_mode_asr_initial_prompt_one: "Gracias por venir a ayudarnos. No oigo a su estudiante cuando lee. ¿Podemos intentarlo con usted?",
    teacher_mode_asr_initial_prompt_two: "Por favor, diga: \"Es hora de leer\"",
    teacher_mode_asr_reminder_one: "No le oí. ¿Puede intentarlo de nuevo? Cuando el micrófono esté verde, diga \"Es hora de leer\".",
    teacher_mode_asr_success: "¡Excelente! Parece que puedo oírle.",
    teacher_mode_asr_failure_flagging_prompt_one: "En este caso particular, ¿se le hace difícil entender a su estudiante?",
    teacher_mode_asr_failure_flagging_prompt_yes_one: "Comprendo. Haré algunos ajustes para este caso específico. Por favor, asegúrese de que su estudiante esté en un lugar silencioso y de que tenga el micrófono cerca de la boca.",
    teacher_mode_asr_failure_flagging_prompt_no_one: "Bien, asegúrese de que su estudiante acerque la boca al micrófono y hable en voz alta y clara.",
    teacher_mode_asr_failure_high_bgn_one: "Oigo mucho ruido de fondo. Ayude a su estudiante a buscar un lugar más silencioso. Además, recuérdele que debe hablar por el micrófono en voz alta y clara.",
    teacher_mode_asr_failure_none_worked_one: "Apenas puedo oírle. Consultemos este artículo para asegurarnos de que todo esté bien configurado. Quizá tengamos que realizar varios pasos.", // Edit v1
  },
  student_checks_MID_GRADE_BAND: {
    intro: "¡Estás aquí!",
    intro_triple_yes: "¡Genial!",
    intro_excited: "¡Qué emoción!",
    intro_continued: "Estaba esperando para leer contigo.",
    intro_finished: (tutorName) => `¡Hola, soy ${tutorName}!`,
    intro_microphone: "¿Qué tal estás?<break time=\"1.5s\"/>",
    welcome_back: "¡Me alegra verte de nuevo!",
    wait_while_i_check: "Espera mientras reviso algunas cosas.",
    microphone_access_granted: "Empecemos a practicar juntos.<break time=\"1s\"/>", // Edit v1
    intro_amira_moveon_one: "y conocer nuevos textos.", // Edit v1
    intro_amira_moveon_two: "¡Soy TU asistente de lectura personal",
    intro_amira_moveon_three: "y estoy aquí para ayudarte a convertirte en un mejor lector.", // Edit v1
    intro_screen: "Vas a leer una variedad de textos en esta pantalla, y yo te ayudaré en todo el proceso.<break time=\".5s\"/>", // Edit v1
    intro_assessment_mode: "Vamos a asegurarnos de que pueda escucharte.", // Edit v1
    volume_check_intro_one: "Durante la lectura, nos encontraremos con personajes muy interesantes.", // glance // Edit v1
    volume_check_intro_two: "Déjame enseñarte lo que quiero decir.", // Edit v1
    check_on_spot_intro: "¡Mi personaje favorito es real! Se llama Spot.", // mid range point at 3 o clock // Edit v1
    check_on_spot_intro_part_two: "Vamos a ver en qué anda.<break time=\"1s\"/>", // Edit v1
    oh_hes_sleeping: "Oh, en este momento está descansando.", // wide eyed animation // Edit v1
    lets_wake_him_up_one: "Vamos a despertarlo. Tenemos que hablar fuerte y claro para que pueda escucharnos.", //pointdown // Edit v1
    talk_loud_enough: "Necesitamos hablar lo suficientemente alto como para que nos oiga,",
    lets_wake_him_up_two: "pero no TAN alto como para asustarlo",
    lets_wake_him_up_three: "Cuando este micrófono se ponga verde",
    wake_up_spot: "tú dirás ¡Despierta, Spot!",
    he_heard_you: "¡Muy bien! Ese es el volumen que necesito cuando lees conmigo.", // excited //waves // Edit v1
    he_heard_you_loud: "Bien, creo que Spot puede oírte.",
    he_heard_you_two: "Gracias, Spot. Nos vemos más tarde.", // Edit v1
    he_heard_you_two_generative: "Gracias, Spot. Nos vemos más tarde.", // Edit v1
    finish_asr_check: "¡Perfecto! Empecemos ya.", // thumbs up // Edit v1
    handle_too_soft_one: "Creo que Spot no te escuchó. Cuando el micrófono se ponga verde, di \"¡Despierta, Spot!\" pero esta vez, más fuerte.<break time=\"1.5s\"/>", // Edit v1
    handle_too_soft_second_round: "¡Vaya! Aun así no pudo oírte. <break time=\"1.5s\"/>",
    handle_too_soft_second_round_two: "¿Tienes el micrófono bien ubicado?<break time=\"1.5s\"/>", // Edit v1
    handle_too_soft_second_round_three: "¿Puedes hablar un poco más alto?", // Edit v1
    handle_too_soft_second_round_four: "Intenta despertarlo otra vez.",
    handle_too_loud_one: "¡Vaya! Tal vez eso fue un poco alto para él.<break time=\"1.5s\"/>", // Edit v1
    handle_too_loud_two: "¿Tienes el micrófono bien ubicado?<break time=\"1.5s\"/>", // Edit v1
    handle_too_loud_three: "Ahora, hablando un poco más suave, di: ¡Despierta, Spot! <break time=\"1.5s\"/>",
    handle_no_audio_one: "¡Vaya! ¡No pude oírte! Si estás usando auriculares, intenta presionar el botón del cable para reactivar el audio.<break time=\"2s\"/>",
    handle_no_audio_part_two: "cuando el micrófono esté verde, en voz alta y clara",
    handle_no_audio_two: "Todavía no puedo escucharte. Intentemos una vez más.<break time=\"1s\"/>",
    handle_get_teacher: "Algo no está funcionando. Por favor, pídele a tu maestro que venga a ayudarnos.", // Edit v1
    handle_get_teacher_two: "Esto aún no está funcionando bien. Por favor, pídele a tu maestro que venga a ayudarnos.", // Edit v1
    teacher_mode_volume_welcome_one: "Gracias por venir a ayudarnos. No oigo a tu estudiante cuando lee. ¿Podemos intentarlo contigo? Por favor, di: \"¡Despierta, Spot!\"",
    teacher_mode_volume_success_one: "¡Excelente! Puedo oírte. ¿Podrías asegurarte de que tu estudiante esté cerca del micrófono y hable en voz alta y clara?",
    teacher_mode_volume_student_retry: "Por favor, deja que tu estudiante lo intente de nuevo.",
    teacher_mode_volume_success_but_loud_one: "Todavía se oye muy alto. ¿Puedes hablar más bajo o ajustar el volumen del micrófono y pedirle a tu estudiante que lo intente de nuevo?",
    teacher_mode_volume_failure_one: "Apenas puedo oírte. Consultemos este artículo para asegurarnos de que todo esté bien configurado. Quizá tengamos que realizar varios pasos.", // Edit v1
    network_ping_error: "Ya estás aquí, pero parece que hay un problema con el internet.", // Edit v1
    return_user_wake_up_prompt: "¿Puedes ayudarme a despertar a Spot?<break time=\"1s\"/>", // Edit v1
    return_user_talk_loud_enough: "Intenta usar una voz clara y fuerte.", // Edit v1
    student_hardware_denied: "Parece que hay un problema con el micrófono.",
    student_hardware_denied_two: "Por favor, pídele a tu maestro que venga a ayudarnos y levanta la mano.<break time=\"1s\"/>",
    student_images_blocked: "Parece que las imágenes están desactivadas en tu navegador, así que no puedes verme.<break time=\"1s\"/>",
    student_hardware_prompt_intro: "Por favor, verifica si tu micrófono está encendido.", // Edit v1
    student_hardware_prompt_initial: "¡Presiona 'Permitir' y podremos comenzar!",
    student_hardware_prompt: "Selecciona 'Permitir' para que pueda escucharte.", // Edit v1
    student_hardware_prompt_two: "¿Sigues ahí? Selecciona el botón que dice 'Permitir'.", // Edit v1
    student_hardware_manually_fixed: "¡Gracias! Ya solo tienes que cerrar y reiniciar. Nos vemos en un minuto.",
    prompt_ios_device_mic_modal_error: "Intenta de nuevo. Selecciona el botón que dice 'Permitir'.", // Edit v1
    prompt_ios_device_mic_modal_success: "Presiónalo de nuevo, una vez más.",
    prompt_ios_device_mic_modal_got_it: "¡Muy bien!",
    student_asr_on_screen_text: "¡Es hora de leer!",
    student_asr_initial_prompt: "Ahora di: '¡Es hora de leer!'.",
    student_asr_reminder_one: "No te oí. Por favor, di: 'Es hora de leer'.",
    student_asr_reminder_two: "¿Puedes volver a intentarlo? Habla por el micrófono y di: \"Es hora de leer\"",
    student_asr_reminder_three: "Todavía no oigo nada. Por favor, di \"Es hora de leer\".",
    student_asr_get_teacher: "Por favor, pídele a tu maestro que venga a ayudarnos.", // Edit v1
    teacher_mode_asr_initial_prompt_one: "Gracias por venir a ayudarnos. No oigo a su estudiante cuando lee. ¿Podemos intentarlo con usted?",
    teacher_mode_asr_initial_prompt_two: "Por favor, diga: \"Es hora de leer\"",
    teacher_mode_asr_reminder_one: "No le oí. ¿Puede intentarlo de nuevo? Cuando el micrófono esté verde, diga \"Es hora de leer\".",
    teacher_mode_asr_success: "¡Excelente! Parece que puedo oírle.",
    teacher_mode_asr_failure_flagging_prompt_one: "En este caso particular, ¿se le hace difícil entender a su estudiante?",
    teacher_mode_asr_failure_flagging_prompt_yes_one: "Comprendo. Haré algunos ajustes para este caso específico. Por favor, asegúrese de que su estudiante esté en un lugar silencioso y de que tenga el micrófono cerca de la boca.",
    teacher_mode_asr_failure_flagging_prompt_no_one: "Bien, asegúrese de que su estudiante acerque la boca al micrófono y hable en voz alta y clara.",
    teacher_mode_asr_failure_high_bgn_one: "Oigo mucho ruido de fondo. Ayude a su estudiante a buscar un lugar más silencioso. Además, recuérdele que debe hablar por el micrófono en voz alta y clara.",
    teacher_mode_asr_failure_none_worked_one: "Apenas puedo oírle. Consultemos este artículo para asegurarnos de que todo esté bien configurado. Quizá tengamos que realizar varios pasos.", // Edit v1
  },
  student_checks_HIGH_GRADE_BAND: {
    intro: "¡Llegaste!",
    intro_triple_yes: "Qué bueno verte.",
    intro_excited: "Me alegra que estés aquí.",
    intro_continued: "He estado esperando este momento para leer contigo.",
    intro_finished: (tutorName) => `¡Hola, soy ${tutorName}!`,
    intro_microphone: "¿Cómo te va hoy?<break time=\"1.5s\"/>", // Edit v1
    welcome_back: "Bienvenido de nuevo.", // Edit v1
    wait_while_i_check: "Espera mientras reviso algunas cosas.",
    microphone_access_granted: "", // Edit v1
    intro_amira_moveon_one: "", // Edit v1
    intro_amira_moveon_two: "¡Soy TU asistente de lectura personal",
    intro_amira_moveon_three: "y estoy aquí para ayudarte a desarrollar tus habilidades de lectura.", // Edit v1
    intro_screen: "Podrás seleccionar un texto en esta pantalla, y yo te iré guiando mientras avanzamos.<break time=\".5s\"/>", // Edit v1
    intro_assessment_mode: "Vamos a asegurarnos de que pueda escucharte.", // Edit v1
    volume_check_intro_one: "", // glance // Edit v1
    volume_check_intro_two: "", // Edit v1
    check_on_spot_intro: "", // Edit v1
    check_on_spot_intro_part_two: "", // Edit v1
    oh_hes_sleeping: "", // Edit v1
    lets_wake_him_up_one: "", // Edit v1
    talk_loud_enough: "Pero primero, vamos a asegurarnos de que tu voz se escuche con claridad.", // Edit v1
    lets_wake_him_up_two: "", // Edit v2
    lets_wake_him_up_three: "Cuando veas que el micrófono se pone verde, puedes empezar a hablar.", // Edit v1
    wake_up_spot: "tú dirás 'Probando: uno, dos, tres.'", // Edit v1
    he_heard_you: "Fuerte y claro. Ese es el volumen que necesito cuando lees conmigo.", // excited //waves // Edit v1
    he_heard_you_loud: "", // Edit v1
    he_heard_you_two: "Gracias, ya puedes continuar.", // Edit v1
    he_heard_you_two_generative: "Gracias, ya puedes continuar.", // Edit v1
    finish_asr_check: "Muy bien, hagámoslo.", // thumbs up // Edit v1
    handle_too_soft_one: "No pude escucharte. Cuando el micrófono se ponga verde, di \"Probando: uno, dos, tres\" pero esta vez más fuerte.<break time=\"1.5s\"/>", // Edit v1
    handle_too_soft_second_round: "", // Edit v1
    handle_too_soft_second_round_two: "Verifica que el micrófono esté bien colocado.<break time=\"1.5s\"/>", // Edit v1
    handle_too_soft_second_round_three: "¿Puedes hablar un poco más alto?", // Edit v1
    handle_too_soft_second_round_four: "", // Edit v1
    handle_too_loud_one: "Creo que lo dijiste con demasiado volumen.<break time=\"1.5s\"/>", // Edit v1
    handle_too_loud_two: "Verifica que el micrófono esté bien colocado.<break time=\"1.5s\"/>", // Edit v1
    handle_too_loud_three: "Ahora, hablando un poco más suave, di: Probando: uno, dos, tres.<break time=\"1.5s\"/>",
    handle_no_audio_one: "¡Vaya! ¡No pude oírte! Si estás usando auriculares, intenta presionar el botón del cable para reactivar el audio.<break time=\"2s\"/>",
    handle_no_audio_part_two: "cuando el micrófono esté verde, en voz alta y clara",
    handle_no_audio_two: "Todavía no puedo escucharte. Intentemos una vez más.<break time=\"1s\"/>",
    handle_get_teacher: "Algo no está funcionando. Por favor, pídele a tu maestro que venga a ayudarnos.", // Edit v1
    handle_get_teacher_two: "Esto aún no está funcionando bien. Por favor, pídele a tu maestro que venga a ayudarnos.", // Edit v1
    teacher_mode_volume_welcome_one: "Gracias por venir a ayudarnos. No oigo a tu estudiante cuando lee. ¿Podemos intentarlo contigo? Por favor, di: \"Probando: uno, dos, tres\"",
    teacher_mode_volume_success_one: "¡Excelente! Puedo oírte. ¿Podrías asegurarte de que tu estudiante esté cerca del micrófono y hable en voz alta y clara?",
    teacher_mode_volume_student_retry: "Por favor, deja que tu estudiante lo intente de nuevo.",
    teacher_mode_volume_success_but_loud_one: "Todavía se oye muy alto. ¿Puedes hablar más bajo o ajustar el volumen del micrófono y pedirle a tu estudiante que lo intente de nuevo?",
    teacher_mode_volume_failure_one: "Apenas puedo oírte. Consultemos este artículo para asegurarnos de que todo esté bien configurado. Quizá tengamos que realizar varios pasos.", // Edit v1
    network_ping_error: "Ya estás aquí, pero parece que hay un problema con el internet.", // Edit v1
    return_user_wake_up_prompt: "Di algo cuando el micrófono se ponga verde.<break time=\"1s\"/>", // Edit v1
    return_user_talk_loud_enough: "Por favor, intenta hablar más fuerte.", // Edit v1
    student_hardware_denied: "Parece que hay un problema con el micrófono.",
    student_hardware_denied_two: "Por favor, pídele a tu maestro que venga a ayudarnos.<break time=\"1s\"/>", // Edit v1
    student_images_blocked: "Parece que las imágenes están desactivadas en tu navegador, así que no puedes verme.<break time=\"1s\"/>",
    student_hardware_prompt_intro: "Por favor, verifica si tu micrófono está encendido.", // Edit v1
    student_hardware_prompt_initial: "¡Presiona 'Permitir' y podremos comenzar!",
    student_hardware_prompt: "Presiona 'Permitir' para empezar.", // Edit v1
    student_hardware_prompt_two: "¿Sigues ahí? Selecciona el botón que dice 'Permitir'.", // Edit v1
    student_hardware_manually_fixed: "¡Gracias! Ya solo tienes que cerrar y reiniciar. Nos vemos en un minuto.",
    prompt_ios_device_mic_modal_error: "Intenta de nuevo. Selecciona el botón que dice 'Permitir'.", // Edit v1
    prompt_ios_device_mic_modal_success: "Presiónalo de nuevo, una vez más.",
    prompt_ios_device_mic_modal_got_it: "¡Muy bien!",
    student_asr_on_screen_text: "¡Es hora de leer!",
    student_asr_initial_prompt: "Ahora di: '¡Es hora de leer!'.",
    student_asr_reminder_one: "No te oí. Por favor, di: 'Es hora de leer'.",
    student_asr_reminder_two: "¿Puedes volver a intentarlo? Habla por el micrófono y di: \"Es hora de leer\"",
    student_asr_reminder_three: "Todavía no oigo nada. Por favor, di \"Es hora de leer\".",
    student_asr_get_teacher: "Por favor, pídele a tu maestro que venga a ayudarnos.", // Edit v1
    teacher_mode_asr_initial_prompt_one: "Gracias por venir a ayudarnos. No oigo a su estudiante cuando lee. ¿Podemos intentarlo con usted?",
    teacher_mode_asr_initial_prompt_two: "Por favor, diga: \"Es hora de leer\"",
    teacher_mode_asr_reminder_one: "No le oí. ¿Puede intentarlo de nuevo? Cuando el micrófono esté verde, diga \"Es hora de leer\".",
    teacher_mode_asr_success: "¡Excelente! Parece que puedo oírle.",
    teacher_mode_asr_failure_flagging_prompt_one: "En este caso particular, ¿se le hace difícil entender a su estudiante?",
    teacher_mode_asr_failure_flagging_prompt_yes_one: "Comprendo. Haré algunos ajustes para este caso específico. Por favor, asegúrese de que su estudiante esté en un lugar silencioso y de que tenga el micrófono cerca de la boca.",
    teacher_mode_asr_failure_flagging_prompt_no_one: "Bien, asegúrese de que su estudiante acerque la boca al micrófono y hable en voz alta y clara.",
    teacher_mode_asr_failure_high_bgn_one: "Oigo mucho ruido de fondo. Ayude a su estudiante a buscar un lugar más silencioso. Además, recuérdele que debe hablar por el micrófono en voz alta y clara.",
    teacher_mode_asr_failure_none_worked_one: "Apenas puedo oírle. Consultemos este artículo para asegurarnos de que todo esté bien configurado. Quizá tengamos que realizar varios pasos.", // Edit v1
  },
  student_raise_hand: {
    title: "Por favor, llama a tu maestro. No puedo escucharte.",
    try_again: "¿Intentar otra vez?",
    teacher_troubleshoot: "Ayuda del maestro",
  },

  // Comprehension Dialogue (Interaction Component)
  interactions: {
    FTUE: {
      displayPrompt: "What is the main thing you learned from the story?", // TRANSLATE
      displayPrompt_MID_GRADE_BAND: "What is the main thing you learned from the passage?", // TRANSLATE // Edit v1
      displayPrompt_HIGH_GRADE_BAND: "What is the main thing you learned from the passage?", // TRANSLATE // Edit v1
      // Each step
      start: "I'm going to ask you a question about what you’ve read.", // TRANSLATE
      microhpone: "You can answer by speaking into your microphone.", // TRANSLATE
      microphone2: "When the microphone icon looks like this, you'll know I'm listening.", // TRANSLATE
      text: "You can answer by typing into this box.", // TRANSLATE
      timer: "The timer will show you how much time you have left to answer.", // TRANSLATE
      repeatButton: "If you want me to repeat the question, use the speaker button.", // TRANSLATE
      excerptsButton: "If you want to see the text again, use the passage button.", // TRANSLATE
      hintButton: "If you’re not sure how to answer, use the hint button and I can help you!", // TRANSLATE
      submit: "When you done answering, use the share button to hear what I think.", // TRANSLATE
      ready: "Are you ready to give it a try? Ok, here’s my question...", // TRANSLATE
    },
    DEFAULT_RESPONSES: [
      "Thanks for your thoughts on this!", // TRANSLATE
      "Appreciate you providing your thoughts.", // TRANSLATE
      "Thank you for your response!", // TRANSLATE
    ],
    DEFAULT_RESPONSES_MID_GRADE_BAND: [
      "Thanks for your thoughts on this.", // TRANSLATE // Edit v1
      "Appreciate you providing your thoughts.", // TRANSLATE
      "Thank you for your response.", // TRANSLATE // Edit v1
    ],
    DEFAULT_RESPONSES_HIGH_GRADE_BAND: [
      "Thanks for your thoughts on this.", // TRANSLATE // Edit v1
      "Appreciate you providing your thoughts.", // TRANSLATE
      "Thank you for your response.", // TRANSLATE // Edit v1
    ],
    NO_INPUT_VOICE_PROMPT:  "Oops! I didn't hear you. Let's try again. I'm going to ask you a question and when the microphone turns green, speak with a loud, prod voice to answer!", // TRANSLATE
    NO_INPUT_VOICE_PROMPT_MID_GRADE_BAND:  "I didn't hear you. Let's try again. I'm going to ask you a question and when the microphone turns green, speak with a loud, prod voice to answer!", // TRANSLATE // Edit v1
    NO_INPUT_VOICE_PROMPT_HIGH_GRADE_BAND:  "I didn't hear you. Let's try again. I'm going to ask you a question and when the microphone turns green, speak with a loud, prod voice to answer!", // TRANSLATE // Edit v1
    NO_INPUT_TEXT_PROMPT: "Oops! Let's try again.  I'm going to ask you a question and when I am done, please type your answer in the text box.", // TRANSLATE
    NO_INPUT_TEXT_PROMPT_MID_GRADE_BAND: "Let's try again.  I'm going to ask you a question and when I am done, please type your answer in the text box.", // TRANSLATE // Edit v1
    NO_INPUT_TEXT_PROMPT_HIGH_GRADE_BAND: "Let's try again.  I'm going to ask you a question and when I am done, please type your answer in the text box.", // TRANSLATE // Edit v1
    NO_INPUT_FINAL_SUBMISSION_RESPONSE: "Thanks for the contribution.", // TRANSLATE
    TIME_STALLS: ["Hmm...", "Thinking...", "One moment...", "Let's see...",], // TRANSLATE
  },
  retell: { // Lower grade band
    introduction: "Mi amiga te va a contar una historia. Yo no voy a escuchar la historia. Después de que ella te la cuente, yo te voy a pedir que me la cuentes a mí.",
    after_video_prompt: "¿Quieres escuchar la historia otra vez antes de contármela? Si quieres volver a oírla, toca el botón blanco. Si ya estás listo para contarme la historia, toca el botón verde.",
    dialog_instructions: "Yo no escuché la historia. ¿Me puedes contar la historia que acabas de escuchar? Cuéntame todo lo que recuerdes, con muchos detalles.",
    submit_confirmation: "¡Gracias por contarme la historia!",
    what_happened_prompt: "¿Qué pasó en la historia?",
  },
  retell_MID_GRADE_BAND: { // Mid grade band
    introduction: "Mi amiga va a leerte un texto. Yo no voy a escucharlo. Después de que lo escuches, te voy a pedir que me cuentes lo que pasó.",
    after_video_prompt: "¿Quieres escuchar el texto otra vez antes de contármelo? Si deseas escucharlo de nuevo, toca el botón blanco. Si ya estás listo para contarlo, toca el botón verde.",
    dialog_instructions: "Yo no escuché el texto. ¿Puedes contarme qué pasó? Trata de incluir todos los detalles que recuerdes.",
    submit_confirmation: "¡Gracias por contarme sobre el texto!",
    what_happened_prompt: "¿Qué ocurrió en el texto que acabas de escuchar?",
  },
  retell_HIGH_GRADE_BAND: { // high grade band
    introduction: "Mi amiga va a leerte un texto. Yo no voy a escucharlo. Después de que lo escuches, te voy a pedir que me cuentes lo que pasó.",
    after_video_prompt: "¿Quieres escuchar el texto otra vez antes de contármelo? Si deseas escucharlo de nuevo, toca el botón blanco. Si ya estás listo para contarlo, toca el botón verde.",
    dialog_instructions: "Yo no escuché el texto. ¿Puedes contarme qué pasó? Trata de incluir todos los detalles que recuerdes.",
    "submit_confirmation": "¡Gracias por contarme sobre el texto!",
    "what_happened_prompt": "¿Qué ocurrió en el texto que acabas de escuchar?",
  },
  freeAnswer: { // Lower grade band
    submit_confirmation: "¡Gracias por contarme!"
  },
  freeAnswer_MID_GRADE_BAND: { // Mid grade band
    submit_confirmation: "Gracias por tu respuesta."
  },
  freeAnswer_HIGH_GRADE_BAND: { // high grade band
    submit_confirmation: "Gracias por tu respuesta."
  },
  blendingSelection: { // Same for all grade bands
    introduction: "Vas a ver unas imágenes. Yo te voy a decir cómo se llaman.",
    introduce_video: "Después de que yo diga los nombres de las imágenes, mi amiga en el video pronunciará los sonidos que forman una de esas palabras. Pon mucha atención para identificar cuál es.",
    select_picture_instructions: "Vas a unir los sonidos que escuchaste y decidir qué imagen representa la palabra que dijo mi amiga. Luego, toca la imagen correcta para seleccionarla.",
    your_turn: "Ahora te toca a ti.",
    your_turn_instructions: "Selecciona la imagen que representa la palabra que se forma al juntar estos sonidos.",
    idle_encouragement_1: "¡Tú puedes hacerlo! Elige la imagen que corresponde a la palabra que formas al juntar estos sonidos.",
    idle_encouragement_2: "Toca la flecha verde cuando estés listo para la siguiente palabra.",
    idle_timeout_message: "Vamos a seguir.",
  },
  // Cursor-Free Tutor FTUE
  cursor_free_ftue: {
    intro: "¡Vaya! ¡Qué bien estás leyendo! Voy a hacer un pequeño cambio para que todo se adapte a cómo lees. Así va a funcionar:",
    no_cursor_explanation: "Ya no voy a subrayar las palabras. Lee a tu ritmo.",
    automatic_progression: "Si te escucho bien, vamos a la siguiente frase automáticamente.",
    next_button_explanation: "Si no te escucho bien, va a aparecer este botón. Tócalo para decirme que ya terminaste de leer. Asegúrate de leer la frase completa antes de hacer clic.",
    lets_go: "Aquí estaré si me necesitas, ¿bien? ¡Vamos!",
    post_assess_intro: "Vamos a leer juntos. Mira cómo funciona.",
    post_assess_no_cursor: "Lee a tu ritmo.",
    demo_phrase_1: "El elefante africano es el animal terrestre más grande del mundo y vive en las sabanas y bosques de África.",
    demo_phrase_2: "Estos gigantes pueden pesar hasta seis mil kilogramos y medir tres metros de altura.",
  },
  // Tap-to-Read Tutor FTUE
  tap_to_read_ftue: {
    intro: "Algo salió mal con tu dispositivo o internet. Voy a hacer algunos ajustes para que esto funcione mejor.",
    how_it_works: "Así es como va a funcionar...",
    read_underlined: "Lee la palabra subrayada...",
    tap_next: "...luego toca la siguiente palabra para seguir leyendo.",
    next_button_explanation: "Cuando llegues al final de la frase verás un botón verde grande para continuar. Haz clic en ese botón para ir a la siguiente frase.",
    lets_go: "Estaré aquí si necesitas ayuda, ¿de acuerdo? ¡Vamos!",
    demo_phrase_1: "Como todos los peces, los tiburones respiran a través de branquias.",
  },
}


export let COPY_STRINGS = EN_US_COPY_STRINGS;

export function setCopyStrings(locale) {
  switch(locale){
    case("en-us"):
      COPY_STRINGS = EN_US_COPY_STRINGS;
      break;
    case("es-mx"):
      COPY_STRINGS = ES_MX_COPY_STRINGS;
      break;
    default:
      COPY_STRINGS = EN_US_COPY_STRINGS;
      break;
  }
}

function getInterface() {
  return isTouchDevice() ? "finger" : "mouse";
}

function getSpanishInterface() {
  return isTouchDevice() ? "dedo" : "ratón";
}

function isTouchDevice() {
  return (
    "ontouchstart" in window ||
    navigator.maxTouchPoints > 0 ||
    navigator.msMaxTouchPoints > 0
  );
}

function spell(letters) {
  let tts = "";
  for (const char of letters) tts += `${char}. `;
  return tts;
}
